(function () {
  'use strict';

  if (window.ATOZCart && window.ATOZCart.__atozCartController) {
    return;
  }

  var state = {
    pending: false,
    loading: false,
    eventsBound: false,
    lastAddSyncAt: 0,
    addSyncTimer: null,
    addSyncInFlight: false,
    addSyncQueued: false,
    addSyncCart: null,
    fetchObserverBound: false,
    cartSyncing: false,
    checkoutSubmitted: false,
    pageRestoreSyncInFlight: false,
    pageRestoreSyncTimer: null,
    drawerStateObserverBound: false,
    drawerStateObserver: null,
    drawerStateObserverTarget: null,
    drawerStateEventsBound: false,
    drawerOpenCartSyncInFlight: false,
    lastDrawerOpenCartSyncAt: 0,
    rotationContextActive: false,
    quantityQueue: {},
    lastPendingAddAt: 0,
    freebieAutoAddInFlight: false,
    freebieAutoAddAttemptKey: '',
    upsellAutoScrollTimer: null,
    upsellAutoScrollIndex: 0,
    upsellAutoScrollPasses: 0,
    upsellInteracted: false,
    upsellFallbackCaptured: false,
    upsellFallbackHtml: '',
    upsellCurrentSource: 'collection',
    upsellRequestSeq: 0,
    upsellCache: {},
    recentAddedProductId: '',
    acquisitionOfferSyncInFlight: false,
    acquisitionOfferSyncPromise: null,
    acquisitionCheckoutInFlight: false,
    acquisitionOfferSyncTimer: null,
    acquisitionOfferSyncCart: null,
    acquisitionOfferQueued: false,
    discountReconcileInFlight: false,
    discountReconcileQueued: false,
    discountReconcileCart: null,
    lastDiscountFingerprint: '',
    preferredDiscount: null,
    acquisitionContextActive: false,
    acquisitionContextOfferValue: '',
    acquisitionLinkObserverBound: false,
    acquisitionLinkObserver: null,
    acquisitionCountdownEndsAt: 0,
    acquisitionCountdownTimer: null,
    ribbedTeeLaunchContextActive: false,
    ribbedTeeLaunchCountdownEndsAt: 0,
    ribbedTeeLaunchCountdownTimer: null
  };

  var quantityDebounceDelay = 400;
  var pendingAddCoalesceDelay = 1500;

  var selectors = {
    drawer: '[data-atoz-cart-drawer]',
    items: '[data-atoz-cart-items]',
    itemsList: '[data-atoz-cart-items-list]',
    count: '[data-atoz-cart-count]',
    footer: '[data-atoz-cart-footer]',
    error: '[data-atoz-cart-error]',
    loadingControl: '[data-atoz-cart-control]',
    checkoutButton: '.cart__checkout',
    rewardBar: '[data-atoz-reward-bar]',
    rewardConfig: '[data-atoz-reward-config]',
    rotationReward: '[data-atoz-rotation-reward]',
    rotationRewardConfig: '[data-atoz-rotation-reward-config]',
    rotationMessage: '[data-atoz-rotation-message]',
    rotationFill: '[data-atoz-rotation-fill]',
    rotationTier: '[data-atoz-rotation-tier]',
    gwpConfig: '[data-atoz-gwp-config]',
    acquisitionOffer: '[data-atoz-acquisition-offer]',
    acquisitionOfferRibbon: '[data-atoz-acquisition-offer-ribbon]',
    acquisitionOfferCountdown: '[data-atoz-acquisition-offer-countdown]',
    acquisitionOfferHeading: '[data-atoz-acquisition-offer-heading]',
    acquisitionOfferDiscountLabel: '[data-atoz-acquisition-offer-discount-label]',
    acquisitionOfferDiscountDetail: '[data-atoz-acquisition-offer-discount-detail]',
    acquisitionOfferShipping: '[data-atoz-acquisition-offer-shipping]',
    acquisitionOfferShippingLabel: '[data-atoz-acquisition-offer-shipping-label]',
    acquisitionOfferShippingDetail: '[data-atoz-acquisition-offer-shipping-detail]',
    acquisitionOfferSample: '[data-atoz-acquisition-offer-sample]',
    acquisitionOfferSampleLabel: '[data-atoz-acquisition-offer-sample-label]',
    acquisitionOfferSampleDetail: '[data-atoz-acquisition-offer-sample-detail]',
    acquisitionOfferDisclaimer: '[data-atoz-acquisition-offer-disclaimer]',
    ribbedTeeLaunchCard: '[data-atoz-ribbed-tee-launch-card]',
    ribbedTeeLaunchCountdown: '[data-atoz-ribbed-tee-launch-countdown]',
    ribbedTeeLaunchHeading: '[data-atoz-ribbed-tee-launch-heading]',
    ribbedTeeLaunchSupport: '[data-atoz-ribbed-tee-launch-support]',
    rewardHeadline: '[data-atoz-reward-headline]',
    tierRail: '[data-atoz-tier-rail]',
    tierFill: '[data-atoz-tier-fill]',
    tierNode: '[data-atoz-tier-node]',
    tierLabel: '[data-atoz-tier-label]',
    tierValue: '[data-atoz-tier-value]',
    perkList: '[data-atoz-perk-list]',
    perkCard: '[data-atoz-perk-card]',
    perkTitle: '[data-atoz-perk-title]',
    perkStatus: '[data-atoz-perk-status]',
    upsells: '[data-atoz-upsells]',
    upsellConfig: '[data-atoz-upsell-config]',
    upsellTrack: '[data-atoz-upsell-track]',
    upsellViewport: '[data-atoz-upsell-viewport]',
    upsellCard: '[data-atoz-upsell-card]',
    upsellAdd: '[data-atoz-upsell-add]',
    upsellControls: '[data-atoz-upsell-controls]',
    upsellPrev: '[data-atoz-upsell-prev]',
    upsellNext: '[data-atoz-upsell-next]',
    upsellDots: '[data-atoz-upsell-dots]',
    upsellDot: '[data-atoz-upsell-dot]',
    upsellEmpty: '[data-atoz-upsell-empty]',
    upsellSubheading: '[data-atoz-upsell-subheading]',
    removeControl: '[data-atoz-cart-remove], [data-cart-remove], [data-remove], a[href*="/cart/change"], a[href*="/cart/update"]',
    pendingRow: '[data-atoz-pending-row]',
    productForm: '.product-single__form',
    row: '[data-atoz-cart-row]',
    quantityInput: '[data-atoz-cart-quantity]',
    quantityMinus: '[data-atoz-cart-quantity-minus]',
    quantityPlus: '[data-atoz-cart-quantity-plus]'
  };

  var refreshSelectors = [selectors.drawer, selectors.items, selectors.count, selectors.footer, selectors.error];

  var messages = {
    pending: 'A cart request is already in progress.',
    unavailable: 'This item is unavailable or sold out.',
    network: 'Unable to reach the cart. Please check your connection and try again.',
    generic: 'Unable to update cart. Please try again.'
  };

  var legacyRotationContextKey = 'tmRotationContext';
  var ribbedTeeLaunchParamValue = 'ribbed_tee_launch';
  var ribbedTeeProductHandle = 'the-man-slim-ribbed-tee';
  var acquisitionOfferParamKey = 'tm_offer';
  var validAcquisitionOfferValues = ['first_order_perks', 'first_order_15_sample'];
  var summerAcquisitionPath = '/pages/summer-collection-55-sale';
  var parfumCollectionAcquisitionPath = '/pages/the-man-parfum-collection';
  var parfumCollectionProductHandles = [
    'the-man-parfum-regal',
    'the-man-parfum-royal',
    'the-man-parfum-pure',
    'the-man-parfum-lure'
  ];

  var defaultUpsellSubheading = 'Add a scent for another part of your day.';

  var upsellDynamicSubheadings = {
    'Daily & Office': 'Add a night or fresh scent to balance your rotation.',
    'Fresh & Active': 'Add a signature or night scent to complete your rotation.',
    'Casual & Weekend': 'Add a daily or date-night scent for more versatility.',
    'Date Night': 'Add a clean daily scent for everyday wear.',
    'Night Out & Social': 'Add a clean or fresh scent for everyday wear.',
    'Signature & Confidence': 'Add a fresh or date-night scent for more versatility.',
    'Premium & Formal': 'Pair it with another elevated scent or daily option.'
  };

  var upsellCategoryTargets = {
    'Daily & Office': ['Date Night', 'Fresh & Active', 'Signature & Confidence'],
    'Fresh & Active': ['Signature & Confidence', 'Date Night', 'Casual & Weekend'],
    'Casual & Weekend': ['Daily & Office', 'Date Night', 'Signature & Confidence'],
    'Date Night': ['Daily & Office', 'Fresh & Active', 'Premium & Formal'],
    'Night Out & Social': ['Daily & Office', 'Fresh & Active', 'Premium & Formal'],
    'Signature & Confidence': ['Fresh & Active', 'Date Night', 'Premium & Formal'],
    'Premium & Formal': ['Daily & Office', 'Premium & Formal', 'Signature & Confidence']
  };

  function debugLog() {
    if (window.ATOZ_CART_DEBUG !== true || !window.console || typeof window.console.log !== 'function') {
      return;
    }

    window.console.log.apply(window.console, ['[ATOZCart]'].concat(Array.prototype.slice.call(arguments)));
  }

  function getShopifyRoot() {
    var root = '/';

    if (
      window.Shopify &&
      window.Shopify.routes &&
      typeof window.Shopify.routes.root === 'string' &&
      window.Shopify.routes.root.length
    ) {
      root = window.Shopify.routes.root;
    }

    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function buildRoute(path) {
    return getShopifyRoot() + path.replace(/^\/+/, '');
  }

  function getFetchUrl(input) {
    if (typeof input === 'string') {
      return input;
    }

    if (input && typeof input.href === 'string') {
      return input.href;
    }

    if (input && typeof input.url === 'string') {
      return input.url;
    }

    return '';
  }

  function getFetchMethod(input, options) {
    if (options && typeof options.method === 'string') {
      return options.method.toUpperCase();
    }

    if (input && typeof input.method === 'string') {
      return input.method.toUpperCase();
    }

    return 'GET';
  }

  function isCartAddUrl(url) {
    var parsedUrl;

    if (typeof url !== 'string' || !url) {
      return false;
    }

    try {
      parsedUrl = new URL(url, window.location.origin);
      return /\/cart\/add\.js$/.test(parsedUrl.pathname);
    } catch (error) {
      return /\/cart\/add\.js(?:$|\?)/.test(url);
    }
  }

  function isCartAddPath(url) {
    var parsedUrl;

    if (typeof url !== 'string' || !url) {
      return false;
    }

    try {
      parsedUrl = new URL(url, window.location.origin);
      return /\/cart\/add(?:\.js)?$/.test(parsedUrl.pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:$|\?)/.test(url);
    }
  }

  function parseJson(text) {
    if (!text) {
      return null;
    }

    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function parseHtml(text) {
    if (typeof text !== 'string' || !text.trim()) {
      return null;
    }

    try {
      return new DOMParser().parseFromString(text, 'text/html');
    } catch (error) {
      return null;
    }
  }

  function structuredError(code, message, details) {
    return {
      ok: false,
      status: details && details.status ? details.status : 0,
      code: code,
      message: message || messages.generic,
      details: details || null
    };
  }

  function normalizeQuantity(quantity, fallback) {
    var normalized = parseInt(quantity, 10);

    if (Number.isNaN(normalized) || normalized < 0) {
      return fallback;
    }

    return normalized;
  }

  function requestedCartQuantity(quantity) {
    if (typeof quantity === 'number') return Number.isSafeInteger(quantity) && quantity >= 0 ? quantity : null;
    if (typeof quantity !== 'string' || !/^\d+$/.test(quantity.trim())) return null;
    var parsed = Number(quantity.trim());
    return Number.isSafeInteger(parsed) ? parsed : null;
  }

  function normalizeLineTarget(lineKeyOrLine) {
    if (typeof lineKeyOrLine === 'number') {
      return lineKeyOrLine > 0 ? { line: lineKeyOrLine } : null;
    }

    if (typeof lineKeyOrLine === 'string' && lineKeyOrLine.trim()) {
      return { id: lineKeyOrLine.trim() };
    }

    return null;
  }

  function isAtozEnabled() {
    return window.ATOZ_CART_DRAWER_ENABLED === true;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var amount = normalizeQuantity(cents, 0);

    if (
      window.theme &&
      window.theme.Currency &&
      typeof window.theme.Currency.formatMoney === 'function' &&
      window.theme.settings &&
      window.theme.settings.moneyFormat
    ) {
      return window.theme.Currency.formatMoney(amount, window.theme.settings.moneyFormat);
    }

    try {
      return new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: amount % 100 === 0 ? 0 : 2
      }).format(amount / 100);
    } catch (error) {
      return '₱' + (amount / 100).toLocaleString('en-PH', {
        minimumFractionDigits: amount % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    }
  }

  function formatWholePesoCeil(cents) {
    var amount = Math.max(normalizeQuantity(cents, 0), 0);
    var pesos = Math.ceil(amount / 100);

    try {
      return '₱' + new Intl.NumberFormat('en-PH', {
        maximumFractionDigits: 0
      }).format(pesos);
    } catch (error) {
      return '₱' + pesos.toLocaleString('en-PH', {
        maximumFractionDigits: 0
      });
    }
  }

  function getCartSubtotal(cart) {
    if (!cart || typeof cart !== 'object') {
      return 0;
    }

    if (typeof cart.total_price === 'number') {
      return cart.total_price;
    }

    if (typeof cart.items_subtotal_price === 'number') {
      return cart.items_subtotal_price;
    }

    return 0;
  }

  function normalizeText(value) {
    return String(value || '').trim();
  }

  function normalizeTitle(value) {
    return normalizeText(value).toLowerCase();
  }

  function normalizeHandle(value) {
    return normalizeText(value)
      .toLowerCase()
      .split(/[?#]/)[0]
      .replace(/^\/+|\/+$/g, '')
      .split('/')
      .pop();
  }

  function getProductHandleFromUrl(url) {
    var parsedUrl;
    var match;

    if (typeof url !== 'string' || !url) {
      return '';
    }

    try {
      parsedUrl = new URL(url, window.location.origin);
      match = parsedUrl.pathname.match(/\/products\/([^/?#]+)/);

      return match && match[1] ? normalizeHandle(match[1]) : '';
    } catch (error) {
      match = url.split(/[?#]/)[0].match(/\/products\/([^/]+)/);

      return match && match[1] ? normalizeHandle(match[1]) : '';
    }
  }

  function normalizeTokenList(value) {
    if (Array.isArray(value)) {
      return value.map(normalizeText).filter(Boolean);
    }

    return normalizeText(value)
      .split(/[\n,|]+/)
      .map(normalizeText)
      .filter(Boolean);
  }

  function normalizeHandleList(value) {
    return normalizeTokenList(value).map(normalizeHandle).filter(Boolean);
  }

  function normalizeIdList(value) {
    return normalizeTokenList(value).map(normalizeText).filter(Boolean);
  }

  function normalizeDiscountCodeList(value) {
    return normalizeTokenList(value).join(',');
  }

  function normalizeFulfillmentMode(value) {
    return normalizeText(value) === 'cart_line' ? 'cart_line' : 'ops_managed';
  }

  function getSessionStorage() {
    try {
      return window.sessionStorage || null;
    } catch (error) {
      return null;
    }
  }

  function getLocalStorage() {
    try {
      return window.localStorage || null;
    } catch (error) {
      return null;
    }
  }

  function setRotationContextFlag() {
    state.rotationContextActive = true;
  }

  function clearRotationContextFlag() {
    var sessionStorage = getSessionStorage();
    var localStorage = getLocalStorage();

    state.rotationContextActive = false;

    // Remove the old persisted flag so rotation context cannot follow customers to other pages.
    if (sessionStorage) {
      try {
        sessionStorage.removeItem(legacyRotationContextKey);
      } catch (error) {
        debugLog('clearRotationContextFlag legacy session failed', error && error.message);
      }
    }

    if (localStorage) {
      try {
        localStorage.removeItem(legacyRotationContextKey);
      } catch (error) {
        debugLog('clearRotationContextFlag legacy local failed', error && error.message);
      }
    }
  }

  function isRotationPageContext() {
    var params;
    var pathname = window.location && window.location.pathname ? window.location.pathname : '';
    var normalizedPath = pathname.replace(/\/+$/, '');
    var isRotationPath = normalizedPath.indexOf('/pages/build-your-rotation') !== -1;
    var hasRotationDom = false;

    if (!isRotationPath) {
      return false;
    }

    try {
      params = new URLSearchParams(window.location.search || '');
      if (params.get('view') === 'tm-rotation' || params.get('tm_rotation') === '1') {
        return true;
      }
    } catch (error) {
      if (/(?:^|[?&])(?:view=tm-rotation|tm_rotation=1)(?:&|$)/.test(window.location.search || '')) {
        return true;
      }
    }

    if (isRotationPath) {
      return true;
    }

    if (document && document.querySelector) {
      hasRotationDom = Boolean(document.querySelector(
        '[data-tm-rotation-root], [data-tm-rotation-section], #tm-rotation-r03'
      ));
    }

    return hasRotationDom;
  }

  function getNormalizedCurrentPath() {
    var pathname = window.location && window.location.pathname ? window.location.pathname : '';

    return pathname.replace(/\/+$/, '') || '/';
  }

  function normalizePathname(pathname) {
    return normalizeText(pathname).replace(/\/+$/, '') || '/';
  }

  function isValidAcquisitionOfferValue(value) {
    return validAcquisitionOfferValues.indexOf(normalizeText(value)) !== -1;
  }

  function mergeUniqueTextValues() {
    var values = [];

    Array.prototype.forEach.call(arguments, function (source) {
      if (!Array.isArray(source)) {
        return;
      }

      source.forEach(function (value) {
        var normalized = normalizeText(value);

        if (normalized && values.indexOf(normalized) === -1) {
          values.push(normalized);
        }
      });
    });

    return values;
  }

  function getConfiguredAcquisitionProductHandles(config) {
    if (!config) {
      return [];
    }

    return mergeUniqueTextValues(
      config.eligibleProductHandles,
      config.royalProductHandles,
      config.pureProductHandles
    ).map(normalizeHandle).filter(Boolean);
  }

  function getConfiguredAcquisitionProductIds(config) {
    if (!config) {
      return [];
    }

    return mergeUniqueTextValues(
      config.eligibleProductIds,
      config.royalProductIds,
      config.pureProductIds
    );
  }

  function getProductHandleFromPathname(pathname) {
    var match = normalizeText(pathname).match(/^\/products\/([^/?#]+)/);

    return match && match[1] ? normalizeHandle(match[1]) : '';
  }

  function getCurrentProductIdFromPage() {
    var metaProduct = window.meta && window.meta.product ? window.meta.product : null;
    var analyticsProduct = window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product
      ? window.ShopifyAnalytics.meta.product
      : null;
    var productNode;

    if (metaProduct && metaProduct.id) {
      return normalizeText(metaProduct.id);
    }

    if (analyticsProduct && analyticsProduct.id) {
      return normalizeText(analyticsProduct.id);
    }

    if (document && document.querySelector) {
      productNode = document.querySelector(
        'form[action*="/cart/add"][data-productid], form[action*="/cart/add"][data-product-id], [data-section-type="product"][data-product-id]'
      );
    }

    return productNode && productNode.dataset
      ? normalizeText(productNode.dataset.productid || productNode.dataset.productId)
      : '';
  }

  function getProductIdFromLinkedElement(element) {
    var productNode = element && element.closest
      ? element.closest('[data-product-id], [data-productid]')
      : null;

    return productNode && productNode.dataset
      ? normalizeText(productNode.dataset.productId || productNode.dataset.productid)
      : '';
  }

  function isAcquisitionEligibleProductReference(config, handle, productId) {
    var handles = getConfiguredAcquisitionProductHandles(config);
    var ids = getConfiguredAcquisitionProductIds(config);
    var normalizedHandle = normalizeHandle(handle);
    var normalizedProductId = normalizeText(productId);

    if (normalizedHandle && handles.indexOf(normalizedHandle) !== -1) {
      return true;
    }

    return Boolean(normalizedProductId && ids.indexOf(normalizedProductId) !== -1);
  }

  function isCurrentAcquisitionEligiblePage(config) {
    var currentPath = getNormalizedCurrentPath();

    if (!config || !isValidAcquisitionOfferValue(config.campaignValue || config.offerId)) {
      return false;
    }

    if (currentPath === summerAcquisitionPath) {
      return true;
    }

    if (currentPath === parfumCollectionAcquisitionPath) {
      return Boolean(getAcquisitionOfferValueFromCurrentUrl());
    }

    return isAcquisitionEligibleProductReference(
      config,
      getProductHandleFromPathname(currentPath),
      getCurrentProductIdFromPage()
    );
  }

  function getAcquisitionOfferValueFromCurrentUrl() {
    var params;
    var value = '';
    var match;

    if (typeof URLSearchParams !== 'undefined') {
      try {
        params = new URLSearchParams(window.location.search || '');
        value = normalizeText(params.get(acquisitionOfferParamKey));
      } catch (error) {
        value = '';
      }
    }

    if (!value) {
      match = (window.location.search || '').match(/(?:^|[?&])tm_offer=([^&]+)/);
      try {
        value = match && match[1] ? normalizeText(decodeURIComponent(match[1].replace(/\+/g, ' '))) : '';
      } catch (error) {
        value = '';
      }
    }

    return isValidAcquisitionOfferValue(value) ? value : '';
  }

  function getActiveAcquisitionLinkOfferValue() {
    var urlValue = getAcquisitionOfferValueFromCurrentUrl();

    if (urlValue) {
      state.acquisitionContextActive = true;
      state.acquisitionContextOfferValue = urlValue;
      return urlValue;
    }

    if (
      state.acquisitionContextActive &&
      isValidAcquisitionOfferValue(state.acquisitionContextOfferValue)
    ) {
      return state.acquisitionContextOfferValue;
    }

    return '';
  }

  function isParfumCollectionAcquisitionContext() {
    return Boolean(
      getNormalizedCurrentPath() === parfumCollectionAcquisitionPath &&
      getAcquisitionOfferValueFromCurrentUrl()
    );
  }

  function isAcquisitionLinkDestination(pathname, config, link) {
    var normalizedPath = normalizePathname(pathname);
    var destinationHandle = getProductHandleFromPathname(normalizedPath);

    if (destinationHandle) {
      if (
        isParfumCollectionAcquisitionContext() &&
        parfumCollectionProductHandles.indexOf(destinationHandle) !== -1
      ) {
        return true;
      }

      return isAcquisitionEligibleProductReference(
        config,
        destinationHandle,
        getProductIdFromLinkedElement(link)
      );
    }

    return normalizedPath === summerAcquisitionPath && getNormalizedCurrentPath() === summerAcquisitionPath;
  }

  function formatAcquisitionHref(url, rawHref) {
    var href = normalizeText(rawHref);

    if (/^https?:\/\//i.test(href) || /^\/\//.test(href)) {
      return url.href;
    }

    return url.pathname + url.search + url.hash;
  }

  function applyAcquisitionOfferToLink(link) {
    var activeOffer = getActiveAcquisitionLinkOfferValue();
    var config;
    var rawHref;
    var url;
    var existingOffer;

    if (!activeOffer || !link || !link.getAttribute || !link.setAttribute) {
      return false;
    }

    config = getAcquisitionConfig();

    if (!config || isAcquisitionRuntimePaused(config)) {
      return false;
    }

    rawHref = normalizeText(link.getAttribute('href'));

    if (!rawHref || rawHref.charAt(0) === '#' || /^(?:mailto|tel|sms|javascript):/i.test(rawHref)) {
      return false;
    }

    try {
      url = new URL(rawHref, window.location.origin);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin || !isAcquisitionLinkDestination(url.pathname, config, link)) {
      return false;
    }

    existingOffer = normalizeText(url.searchParams.get(acquisitionOfferParamKey));

    if (existingOffer && existingOffer !== activeOffer) {
      return false;
    }

    url.searchParams.delete(acquisitionOfferParamKey);
    url.searchParams.set(acquisitionOfferParamKey, activeOffer);
    link.setAttribute('href', formatAcquisitionHref(url, rawHref));

    return true;
  }

  function syncAcquisitionOfferLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links;

    if (!getActiveAcquisitionLinkOfferValue() || !scope || !scope.querySelectorAll) {
      return;
    }

    if (scope.matches && scope.matches('a[href]')) {
      applyAcquisitionOfferToLink(scope);
    }

    links = scope.querySelectorAll('a[href]');
    Array.prototype.forEach.call(links, applyAcquisitionOfferToLink);
  }

  function handleAcquisitionLinkClick(event) {
    var target = event && event.target;
    var link = target && target.closest ? target.closest('a[href]') : null;

    applyAcquisitionOfferToLink(link);
  }

  function bindAcquisitionOfferLinkPreservation() {
    syncAcquisitionOfferLinks(document);

    document.addEventListener('click', handleAcquisitionLinkClick, true);

    if (state.acquisitionLinkObserverBound || typeof MutationObserver !== 'function') {
      return;
    }

    state.acquisitionLinkObserverBound = true;
    state.acquisitionLinkObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) {
            syncAcquisitionOfferLinks(node);
          }
        });
      });
    });

    state.acquisitionLinkObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function isRoyalAcquisitionPageContext() {
    return getNormalizedCurrentPath() === '/products/the-man-parfum-royal';
  }

  function hasExplicitAcquisitionOfferParam() {
    var params;

    if (typeof URLSearchParams === 'undefined') {
      return /(?:^|[?&])tm_offer=[^&]+/.test(window.location.search || '');
    }

    try {
      params = new URLSearchParams(window.location.search || '');
      return Boolean(params.get('tm_offer'));
    } catch (error) {
      return /(?:^|[?&])tm_offer=[^&]+/.test(window.location.search || '');
    }
  }

  function hasSummerFirstOrderOfferParam() {
    var params;

    if (typeof URLSearchParams === 'undefined') {
      return /(?:^|[?&])tm_offer=first_order_perks(?:&|$)/.test(window.location.search || '');
    }

    try {
      params = new URLSearchParams(window.location.search || '');
      return params.get('tm_offer') === 'first_order_perks';
    } catch (error) {
      return /(?:^|[?&])tm_offer=first_order_perks(?:&|$)/.test(window.location.search || '');
    }
  }

  function isSummerAcquisitionPageContext() {
    return Boolean(
      getNormalizedCurrentPath() === '/pages/summer-collection-55-sale' &&
      hasSummerFirstOrderOfferParam()
    );
  }

  function hasRibbedTeeLaunchParam() {
    var params;

    if (typeof URLSearchParams === 'undefined') {
      return /(?:^|[?&])tm_cart_context=ribbed_tee_launch(?:&|$)/.test(window.location.search || '');
    }

    try {
      params = new URLSearchParams(window.location.search || '');
      return params.get('tm_cart_context') === ribbedTeeLaunchParamValue;
    } catch (error) {
      return /(?:^|[?&])tm_cart_context=ribbed_tee_launch(?:&|$)/.test(window.location.search || '');
    }
  }

  function isRibbedTeeProductPageContext() {
    return getNormalizedCurrentPath() === '/products/' + ribbedTeeProductHandle;
  }

  function activateRibbedTeeLaunchContext() {
    state.ribbedTeeLaunchContextActive = true;

    if (!state.ribbedTeeLaunchCountdownEndsAt) {
      state.ribbedTeeLaunchCountdownEndsAt = Date.now() + (10 * 60 * 1000);
    }
  }

  function clearRibbedTeeLaunchContext() {
    var path = getNormalizedCurrentPath();

    if (path.indexOf('/products/') === 0 && !isRibbedTeeProductPageContext()) {
      state.ribbedTeeLaunchContextActive = false;
      state.ribbedTeeLaunchCountdownEndsAt = 0;
    }
  }

  function isRibbedTeeLaunchContextActive() {
    if (isRotationPageContext()) {
      return false;
    }

    if (hasRibbedTeeLaunchParam() || isRibbedTeeProductPageContext()) {
      activateRibbedTeeLaunchContext();
      return true;
    }

    clearRibbedTeeLaunchContext();

    return state.ribbedTeeLaunchContextActive;
  }

  function isRotationContextActive(cart) {
    var isRotationPage = isRotationPageContext();

    if (isRotationPage) {
      setRotationContextFlag();
      return true;
    }

    clearRotationContextFlag();

    return false;
  }

  function getItemProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function getLineProperty(item, key) {
    var properties = getItemProperties(item);

    return Object.prototype.hasOwnProperty.call(properties, key) ? normalizeText(properties[key]) : '';
  }

  function getItemProductId(item) {
    return normalizeText(item && item.product_id);
  }

  function getItemHandle(item) {
    return normalizeHandle(item && item.handle) || getProductHandleFromUrl(item && item.url);
  }

  function normalizeCents(value, fallback) {
    var normalized = parseInt(value, 10);

    if (Number.isNaN(normalized) || normalized < 0) {
      return fallback;
    }

    return normalized;
  }

  function normalizeRewardMode(value, fallback) {
    var normalized = normalizeText(value || fallback || 'threshold');

    if (normalized === 'disabled' || normalized === 'included' || normalized === 'threshold') {
      return normalized;
    }

    return fallback || 'threshold';
  }

  function getRewardBar() {
    var drawer = getDrawer();

    return drawer ? drawer.querySelector(selectors.rewardBar) : null;
  }

  function suppressRewardBar(rewardBar) {
    if (!rewardBar) {
      return;
    }

    rewardBar.hidden = true;
    rewardBar.setAttribute('aria-hidden', 'true');
    rewardBar.style.display = 'none';
  }

  function restoreRewardBar(rewardBar) {
    if (!rewardBar) {
      return;
    }

    rewardBar.hidden = false;
    rewardBar.setAttribute('aria-hidden', 'false');
    rewardBar.style.removeProperty('display');
  }

  function getRotationReward() {
    var drawer = getDrawer();

    return drawer ? drawer.querySelector(selectors.rotationReward) : null;
  }

  function parseRewardConfig() {
    var rewardBar = getRewardBar();
    var configNode = rewardBar ? rewardBar.querySelector(selectors.rewardConfig) : null;
    var parsed;
    var legacyMilestones;
    var tierSource;
    var perkSource;

    if (!configNode) {
      return null;
    }

    try {
      parsed = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      debugLog('parseRewardConfig failed', error && error.message);
      return null;
    }

    legacyMilestones = Array.isArray(parsed.milestones) ? parsed.milestones : [];
    tierSource = Array.isArray(parsed.tiers)
      ? parsed.tiers
      : legacyMilestones.filter(function (milestone) {
        return milestone && milestone.type === 'quantity_discount';
      });
    perkSource = Array.isArray(parsed.perks)
      ? parsed.perks
      : legacyMilestones.filter(function (milestone) {
        return milestone && milestone.type !== 'quantity_discount';
      }).map(function (milestone) {
        return Object.assign({}, milestone, {
          id: milestone.id === 'free_shipping' ? 'shipping' : 'sample',
          type: milestone.type === 'value_perk' ? 'free_shipping' : 'freebie',
          mode: 'threshold'
        });
      });

    return {
      profile: normalizeText(parsed.profile || 'evergreen'),
      freebieVariantId: normalizeText(parsed.freebieVariantId),
      autoAddFreebie: parsed.autoAddFreebie === true,
      tiers: tierSource.map(function (tier, index) {
        return {
          id: normalizeText(tier && tier.id),
          type: normalizeText(tier && tier.type),
          threshold: normalizeQuantity(tier && tier.threshold, 0),
          label: normalizeText(tier && tier.label),
          rewardLabel: normalizeText(tier && tier.rewardLabel),
          discountTitle: normalizeText(tier && tier.discountTitle),
          index: index
        };
      }).filter(function (tier) {
        return Boolean(tier.id && tier.threshold);
      }).sort(function (firstTier, secondTier) {
        if (firstTier.threshold === secondTier.threshold) {
          return firstTier.index - secondTier.index;
        }

        return firstTier.threshold - secondTier.threshold;
      }).map(function (tier, index) {
        return Object.assign({}, tier, {
          index: index
        });
      }),
      perks: perkSource.map(function (perk) {
        return {
          id: normalizeText(perk && perk.id),
          type: normalizeText(perk && perk.type),
          mode: normalizeRewardMode(perk && perk.mode, 'threshold'),
          thresholdCents: normalizeCents(perk && perk.thresholdCents, 0),
          label: normalizeText(perk && perk.label),
          title: normalizeText(perk && perk.title)
        };
      }).filter(function (perk) {
        return Boolean(perk.id);
      })
    };
  }

  function parseRotationRewardConfig() {
    var rotationReward = getRotationReward();
    var configNode = rotationReward ? rotationReward.querySelector(selectors.rotationRewardConfig) : null;
    var parsed;
    var discountCodes;

    if (!configNode) {
      return {
        eligibleHandles: [],
        discountCodes: {}
      };
    }

    try {
      parsed = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      debugLog('parseRotationRewardConfig failed', error && error.message);
      parsed = {};
    }

    discountCodes = parsed && parsed.discountCodes && typeof parsed.discountCodes === 'object'
      ? parsed.discountCodes
      : {};

    return {
      eligibleHandles: normalizeHandleList(parsed && parsed.eligibleHandles),
      discountCodes: {
        two: normalizeText(discountCodes.two),
        three: normalizeText(discountCodes.three),
        five: normalizeText(discountCodes.five)
      }
    };
  }

  function getRotationDiscountCode(eligibleQuantity, discountCodes) {
    var count = normalizeQuantity(eligibleQuantity, 0);
    var codes = discountCodes || {};

    if (count >= 5) {
      return normalizeText(codes.five);
    }

    if (count >= 3) {
      return normalizeText(codes.three);
    }

    if (count >= 2) {
      return normalizeText(codes.two);
    }

    return '';
  }

  function getRotationDiscountPercent(eligibleQuantity) {
    var count = normalizeQuantity(eligibleQuantity, 0);

    if (count >= 5) {
      return '18%';
    }

    if (count >= 3) {
      return '13%';
    }

    if (count >= 2) {
      return '10%';
    }

    return '';
  }

  function getRotationCheckoutUrl(code) {
    var normalizedCode = normalizeText(code);

    if (!normalizedCode) {
      return '';
    }

    return buildRoute('discount/' + encodeURIComponent(normalizedCode)) +
      '?redirect=' +
      encodeURIComponent(buildRoute('checkout'));
  }

  function isRotationRewardActive() {
    var drawer = getDrawer();
    var rotationReward = getRotationReward();

    return Boolean(
      drawer &&
      drawer.getAttribute('data-atoz-rotation-context') === 'true' &&
      rotationReward &&
      !rotationReward.hidden &&
      rotationReward.getAttribute('aria-hidden') !== 'true'
    );
  }

  function getRotationCheckoutTarget() {
    var rotationReward = getRotationReward();
    var config;
    var eligibleQuantity;
    var code;
    var url;

    if (!isRotationRewardActive() || !rotationReward) {
      return null;
    }

    config = parseRotationRewardConfig();
    eligibleQuantity = normalizeQuantity(rotationReward.getAttribute('data-atoz-rotation-eligible-count'), 0);
    code = getRotationDiscountCode(eligibleQuantity, config.discountCodes);
    url = getRotationCheckoutUrl(code);

    if (!code || !url) {
      return null;
    }

    return {
      code: code,
      url: url,
      eligibleQuantity: eligibleQuantity
    };
  }

  function getRotationCheckoutTargetFromButton(button) {
    var code = button ? normalizeText(button.getAttribute('data-atoz-rotation-checkout-code')) : '';
    var url = button ? normalizeText(button.getAttribute('data-atoz-rotation-checkout-url')) : '';

    if (!code || !url) {
      return null;
    }

    return {
      code: code,
      url: url,
      eligibleQuantity: normalizeQuantity(
        getRotationReward() && getRotationReward().getAttribute('data-atoz-rotation-eligible-count'),
        0
      )
    };
  }

  function routeRotationCheckout(button, target, event) {
    if (!target || !target.url || !button) {
      return false;
    }

    if (
      button.disabled ||
      button.getAttribute('aria-disabled') === 'true'
    ) {
      return true;
    }

    if (event) {
      event.preventDefault();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
    }

    state.checkoutSubmitted = true;
    button.classList.add('btn--loading');
    button.setAttribute('aria-busy', 'true');
    window.location.assign(target.url);

    return true;
  }

  function handleRotationCheckoutButtonClick(event) {
    var button = event && event.currentTarget ? event.currentTarget : null;
    var target = getRotationCheckoutTarget() || getRotationCheckoutTargetFromButton(button);

    if (routeRotationCheckout(button, target, event)) {
      return false;
    }

    return true;
  }

  function updateRotationCheckoutControls(target) {
    var drawer = getDrawer();
    var checkoutButtons = drawer ? drawer.querySelectorAll(selectors.checkoutButton) : [];

    checkoutButtons.forEach(function (button) {
      if (target && target.url) {
        if (!button.hasAttribute('data-atoz-rotation-original-type')) {
          button.setAttribute('data-atoz-rotation-original-type', button.getAttribute('type') || '');
        }

        button.setAttribute('type', 'button');
        button.setAttribute('data-atoz-rotation-checkout-code', target.code);
        button.setAttribute('data-atoz-rotation-checkout-url', target.url);
        button.setAttribute('formaction', target.url);
        button.setAttribute('formmethod', 'get');

        if (button.getAttribute('data-atoz-rotation-checkout-bound') !== 'true') {
          button.addEventListener('click', handleRotationCheckoutButtonClick, true);
          button.setAttribute('data-atoz-rotation-checkout-bound', 'true');
        }
      } else {
        if (button.hasAttribute('data-atoz-rotation-original-type')) {
          if (button.getAttribute('data-atoz-rotation-original-type')) {
            button.setAttribute('type', button.getAttribute('data-atoz-rotation-original-type'));
          } else {
            button.removeAttribute('type');
          }

          button.removeAttribute('data-atoz-rotation-original-type');
        }

        button.removeAttribute('data-atoz-rotation-checkout-code');
        button.removeAttribute('data-atoz-rotation-checkout-url');
        button.removeAttribute('formaction');
        button.removeAttribute('formmethod');

        if (button.getAttribute('data-atoz-rotation-checkout-bound') === 'true') {
          button.removeEventListener('click', handleRotationCheckoutButtonClick, true);
          button.removeAttribute('data-atoz-rotation-checkout-bound');
        }
      }
    });
  }

  function getGwpConfigNode() {
    var rewardBar = getRewardBar();
    var drawer = getDrawer();

    return rewardBar
      ? rewardBar.querySelector(selectors.gwpConfig)
      : drawer
        ? drawer.querySelector(selectors.gwpConfig)
        : null;
  }

  function normalizeAcquisitionLabels(labels, fallback) {
    var defaults = fallback || {};

    labels = labels && typeof labels === 'object' ? labels : {};

    return {
      ribbon: normalizeText(labels.ribbon) || normalizeText(defaults.ribbon) || 'FIRST ORDER EXCLUSIVE',
      heading: normalizeText(labels.heading) || normalizeText(defaults.heading) || 'First-order perks unlocked',
      orderDiscount: normalizeText(labels.orderDiscount) || normalizeText(defaults.orderDiscount) || '10% OFF',
      orderDiscountDetail: normalizeText(labels.orderDiscountDetail) || normalizeText(defaults.orderDiscountDetail) || 'Applied automatically',
      freeShipping: normalizeText(labels.freeShipping) || normalizeText(defaults.freeShipping) || 'FREE SHIPPING',
      freeShippingDetail: normalizeText(labels.freeShippingDetail) || normalizeText(defaults.freeShippingDetail) || 'No shipping fee',
      freeSample: normalizeText(labels.freeSample) || normalizeText(defaults.freeSample) || 'FREE 2ML SAMPLE',
      freeSampleDetail: normalizeText(labels.freeSampleDetail) || normalizeText(defaults.freeSampleDetail) || 'Packed with your order',
      disclaimer: normalizeText(labels.disclaimer) || normalizeText(defaults.disclaimer) || 'Your complimentary 2ml sample will be packed with this order after checkout confirmation.'
    };
  }

  function normalizeAcquisitionOffer(rawOffer, acquisition, baseLabels) {
    var offer = rawOffer && typeof rawOffer === 'object' ? rawOffer : {};
    var campaignValue = normalizeText(offer.campaignValue || offer.id || acquisition.campaignValue);
    var offerId = normalizeText(offer.id || campaignValue);

    if (!offerId && !campaignValue) {
      return null;
    }

    return {
      id: offerId || campaignValue,
      enabled: offer.enabled !== false,
      campaignKey: normalizeText(offer.campaignKey || acquisition.campaignKey),
      campaignValue: campaignValue || offerId,
      requiredDiscountTitle: normalizeText(offer.requiredDiscountTitle || acquisition.requiredDiscountTitle),
      discountCodes: normalizeDiscountCodeList(offer.discountCodes || acquisition.discountCodes || 'FIRSTORDER10,ROYALC1SHIP'),
      showFreeShipping: offer.showFreeShipping === true,
      showFreeSample: offer.showFreeSample !== false,
      labels: normalizeAcquisitionLabels(offer.labels, baseLabels)
    };
  }

  function normalizeAcquisitionOffers(acquisition, baseLabels) {
    var offers = Array.isArray(acquisition.offers)
      ? acquisition.offers.map(function (offer) {
        return normalizeAcquisitionOffer(offer, acquisition, baseLabels);
      }).filter(Boolean)
      : [];
    var hasPrimaryOffer = offers.some(function (offer) {
      return offer.campaignValue === normalizeText(acquisition.campaignValue);
    });

    if (!hasPrimaryOffer && normalizeText(acquisition.campaignValue)) {
      offers.unshift({
        id: normalizeText(acquisition.campaignValue),
        enabled: true,
        campaignKey: normalizeText(acquisition.campaignKey),
        campaignValue: normalizeText(acquisition.campaignValue),
        requiredDiscountTitle: normalizeText(acquisition.requiredDiscountTitle),
        discountCodes: normalizeDiscountCodeList(acquisition.discountCodes || 'FIRSTORDER10,ROYALC1SHIP'),
        showFreeShipping: acquisition.showFreeShipping !== false,
        showFreeSample: true,
        labels: baseLabels
      });
    }

    return offers;
  }

  function parseGwpConfig() {
    var configNode = getGwpConfigNode();
    var parsed;
    var acquisition;

    if (!configNode) {
      return null;
    }

    try {
      parsed = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      debugLog('parseGwpConfig failed', error && error.message);
      return null;
    }

    acquisition = parsed && parsed.programs && parsed.programs.acquisition
      ? parsed.programs.acquisition
      : {};

    var labels = normalizeAcquisitionLabels(acquisition.labels);
    var offers = normalizeAcquisitionOffers(acquisition, labels);

    return {
      enabled: parsed.enabled === true,
      allowCombinedPrograms: parsed.allowCombinedPrograms === true,
      maxTotalGifts: Math.max(1, Math.min(normalizeQuantity(parsed.maxTotalGifts, 1), 6)),
      autoRemoveIneligible: parsed.autoRemoveIneligible !== false,
      strictFreeValidation: parsed.strictFreeValidation === true,
      acquisition: {
        enabled: acquisition.enabled === true,
        fulfillmentMode: normalizeFulfillmentMode(acquisition.fulfillmentMode),
        triggerType: normalizeText(acquisition.triggerType || 'url_parameter'),
        campaignKey: normalizeText(acquisition.campaignKey),
        campaignValue: normalizeText(acquisition.campaignValue),
        giftVariantIds: normalizeIdList(acquisition.giftVariantIds),
        requiredDiscountTitle: normalizeText(acquisition.requiredDiscountTitle),
        discountCodes: normalizeDiscountCodeList(acquisition.discountCodes || 'FIRSTORDER10,ROYALC1SHIP'),
        eligibleProductIds: normalizeIdList(acquisition.eligibleProductIds),
        eligibleProductHandles: normalizeHandleList(acquisition.eligibleProductHandles),
        royalProductIds: normalizeIdList(acquisition.royalProductIds),
        royalProductHandles: normalizeHandleList(acquisition.royalProductHandles),
        pureProductIds: normalizeIdList(acquisition.pureProductIds),
        pureProductHandles: normalizeHandleList(acquisition.pureProductHandles),
        showFreeShipping: acquisition.showFreeShipping !== false,
        showFreeSample: true,
        labels: labels,
        offers: offers,
        customerKnown: acquisition.customerKnown === true,
        customerOrdersCount: normalizeQuantity(acquisition.customerOrdersCount, 0)
      }
    };
  }

  function getAcquisitionOfferMatches(config, value) {
    var normalizedValue = normalizeText(value);

    if (!config || !normalizedValue || !Array.isArray(config.offers)) {
      return null;
    }

    return config.offers.find(function (offer) {
      return Boolean(
        offer &&
        offer.enabled !== false &&
        (
          offer.campaignValue === normalizedValue ||
          offer.id === normalizedValue
        )
      );
    }) || null;
  }

  function getAcquisitionOfferFromUrl(config) {
    var params;
    var currentValue;

    if (!config || !config.campaignKey || typeof URLSearchParams === 'undefined') {
      return null;
    }

    try {
      params = new URLSearchParams(window.location.search || '');
      currentValue = params.get(config.campaignKey);
    } catch (error) {
      return null;
    }

    return getAcquisitionOfferMatches(config, currentValue);
  }

  function getPrimaryAcquisitionOffer(config) {
    if (!config || !Array.isArray(config.offers)) {
      return null;
    }

    return getAcquisitionOfferMatches(config, config.campaignValue) || config.offers.find(function (offer) {
      return offer && offer.enabled !== false;
    }) || null;
  }

  function getSessionAcquisitionOffer(config) {
    if (!config || !Array.isArray(config.offers)) {
      return null;
    }

    return config.offers.find(function (offer) {
      var offerConfig = Object.assign({}, config, offer);

      return Boolean(
        offer &&
        offer.enabled !== false &&
        (
          getAcquisitionSessionFlag(offerConfig, 'armed') ||
          getAcquisitionSessionFlag(offerConfig, 'activated')
        )
      );
    }) || null;
  }

  function getActiveAcquisitionOffer(config) {
    var urlOffer;

    if (!config || !Array.isArray(config.offers) || !config.offers.length) {
      return null;
    }

    urlOffer = getAcquisitionOfferFromUrl(config);

    if (urlOffer) {
      state.acquisitionContextActive = true;
      state.acquisitionContextOfferValue = urlOffer.campaignValue || urlOffer.id || '';
      return urlOffer;
    }

    if (state.acquisitionContextActive && state.acquisitionContextOfferValue) {
      return getAcquisitionOfferMatches(config, state.acquisitionContextOfferValue);
    }

    return null;
  }

  function mergeAcquisitionOfferConfig(config, offer) {
    if (!config || !offer) {
      return config;
    }

    return Object.assign({}, config, {
      offerId: offer.id,
      campaignKey: offer.campaignKey || config.campaignKey,
      campaignValue: offer.campaignValue || config.campaignValue,
      requiredDiscountTitle: offer.requiredDiscountTitle || config.requiredDiscountTitle,
      discountCodes: offer.discountCodes || config.discountCodes,
      showFreeShipping: offer.showFreeShipping === true,
      showFreeSample: offer.showFreeSample !== false,
      labels: normalizeAcquisitionLabels(offer.labels, config.labels)
    });
  }

  function getAcquisitionConfig() {
    var config = parseGwpConfig();
    var acquisitionConfig;
    var activeOffer;

    if (!config || !config.enabled || !config.acquisition || !config.acquisition.enabled) {
      return null;
    }

    acquisitionConfig = Object.assign({}, config.acquisition, {
      maxTotalGifts: config.maxTotalGifts,
      autoRemoveIneligible: config.autoRemoveIneligible,
      strictFreeValidation: config.strictFreeValidation
    });

    activeOffer = getActiveAcquisitionOffer(acquisitionConfig);

    if (!activeOffer) {
      return null;
    }

    return mergeAcquisitionOfferConfig(acquisitionConfig, activeOffer);
  }

  function getAcquisitionSessionKey(config, suffix) {
    var key = config && config.campaignKey ? config.campaignKey : 'campaign';
    var value = config && config.campaignValue ? config.campaignValue : 'active';

    return [
      'atoz',
      'acquisition',
      normalizeHandle(key) || 'campaign',
      normalizeHandle(value) || 'active',
      suffix
    ].join(':');
  }

  function setAcquisitionSessionFlag(config, suffix, value) {
    var storage = getSessionStorage();

    if (!storage || !config) {
      return false;
    }

    try {
      storage.setItem(getAcquisitionSessionKey(config, suffix), value ? 'true' : '');
      return true;
    } catch (error) {
      return false;
    }
  }

  function getAcquisitionSessionFlag(config, suffix) {
    var storage = getSessionStorage();

    if (!storage || !config) {
      return false;
    }

    try {
      return storage.getItem(getAcquisitionSessionKey(config, suffix)) === 'true';
    } catch (error) {
      return false;
    }
  }

  function isAcquisitionCustomerEligible(config) {
    return Boolean(config && (!config.customerKnown || config.customerOrdersCount <= 0));
  }

  function armAcquisitionOfferFromUrl() {
    var config = getAcquisitionConfig();
    var params;
    var currentValue;

    if (isAcquisitionRuntimePaused(config)) {
      return {
        ok: true,
        armed: false,
        skipped: true,
        paused: true
      };
    }

    if (
      !config ||
      !isAcquisitionCustomerEligible(config) ||
      config.triggerType !== 'url_parameter' ||
      !config.campaignKey ||
      !config.campaignValue ||
      typeof URLSearchParams === 'undefined'
    ) {
      return {
        ok: true,
        armed: false,
        skipped: true
      };
    }

    try {
      params = new URLSearchParams(window.location.search || '');
      currentValue = params.get(config.campaignKey);
    } catch (error) {
      return {
        ok: true,
        armed: false,
        skipped: true
      };
    }

    if (currentValue !== config.campaignValue) {
      return {
        ok: true,
        armed: getAcquisitionSessionFlag(config, 'armed')
      };
    }

    return {
      ok: true,
      armed: setAcquisitionSessionFlag(config, 'armed', true)
    };
  }

  function isAcquisitionSessionArmed(config) {
    return Boolean(config && isAcquisitionCustomerEligible(config) && getAcquisitionSessionFlag(config, 'armed'));
  }

  function isAcquisitionOfferActivated(config) {
    return Boolean(config && getAcquisitionSessionFlag(config, 'activated'));
  }

  function activateAcquisitionOffer(config) {
    if (!isAcquisitionSessionArmed(config)) {
      return false;
    }

    return setAcquisitionSessionFlag(config, 'activated', true);
  }

  function itemMatchesConfiguredProducts(item, idList, handleList) {
    var productId = getItemProductId(item);
    var handle = getItemHandle(item);

    return Boolean(
      (productId && idList.indexOf(productId) !== -1) ||
      (handle && handleList.indexOf(handle) !== -1)
    );
  }

  function isAcquisitionGiftItem(item, config) {
    var offer = getLineProperty(item, '_atoz_offer');

    return Boolean(
      item &&
      getLineProperty(item, '_atoz_gift_reward') === 'v2' &&
      getLineProperty(item, '_atoz_auto_added') === 'true' &&
      (
        getLineProperty(item, '_atoz_gwp') === 'acquisition' ||
        offer === 'first_order_perks' ||
        (config && offer === config.campaignValue) ||
        (config && offer === config.offerId)
      )
    );
  }

  function getAcquisitionOfferToken(config) {
    return normalizeText(config && (config.campaignValue || config.offerId)) || 'first_order_perks';
  }

  function isAcquisitionGiftForActiveOffer(item, config) {
    var offer = getLineProperty(item, '_atoz_offer');

    if (!isAcquisitionGiftItem(item, config)) {
      return false;
    }

    return Boolean(
      offer === getAcquisitionOfferToken(config) ||
      (config && config.offerId && offer === config.offerId)
    );
  }

  function isAcquisitionPaidItem(item, config) {
    return Boolean(
      item &&
      getItemQuantity(item) > 0 &&
      !isZeroPriceLine(item) &&
      !isAcquisitionGiftItem(item, config)
    );
  }

  function isAcquisitionEligiblePerfumeItem(item, config) {
    var hasExplicitMatching;
    var fallbackProductIds;
    var fallbackProductHandles;

    if (!isAcquisitionPaidItem(item, config)) {
      return false;
    }

    hasExplicitMatching = Boolean(
      config.eligibleProductIds.length ||
      config.eligibleProductHandles.length
    );

    if (!hasExplicitMatching) {
      if (isSummerAcquisitionPageContext()) {
        return true;
      }

      fallbackProductIds = config.royalProductIds.concat(config.pureProductIds);
      fallbackProductHandles = config.royalProductHandles.concat(config.pureProductHandles);

      if (!fallbackProductIds.length && !fallbackProductHandles.length) {
        return false;
      }

      return itemMatchesConfiguredProducts(item, fallbackProductIds, fallbackProductHandles);
    }

    return itemMatchesConfiguredProducts(item, config.eligibleProductIds, config.eligibleProductHandles);
  }

  function getAcquisitionCartState(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var paidItems = items.filter(function (item) {
      return isAcquisitionPaidItem(item, config);
    });
    var eligibleItems = items.filter(function (item) {
      return isAcquisitionEligiblePerfumeItem(item, config);
    });
    var giftItems = items.filter(function (item) {
      return isAcquisitionGiftItem(item, config);
    });
    var hasRoyal = eligibleItems.some(function (item) {
      return itemMatchesConfiguredProducts(item, config.royalProductIds, config.royalProductHandles);
    });
    var hasPure = eligibleItems.some(function (item) {
      return itemMatchesConfiguredProducts(item, config.pureProductIds, config.pureProductHandles);
    });
    var sampleToPack = 'assorted_2ml';

    if (hasRoyal && !hasPure) {
      sampleToPack = 'pure_2ml';
    } else if (hasPure && !hasRoyal) {
      sampleToPack = 'royal_2ml';
    }

    return {
      paidItems: paidItems,
      eligibleItems: eligibleItems,
      giftItems: giftItems,
      hasPaidItems: paidItems.length > 0,
      hasEligiblePerfume: eligibleItems.length > 0,
      sampleToPack: sampleToPack
    };
  }

  function normalizePercent(value, fallback) {
    var normalized = parseFloat(value);

    if (Number.isNaN(normalized) || normalized < 0) {
      return fallback || 0;
    }

    return normalized;
  }

  function getPercentFromText(value) {
    var match = normalizeText(value).match(/(\d+(?:\.\d+)?)\s*%/);

    return match && match[1] ? normalizePercent(match[1], 0) : 0;
  }

  function getDiscountCodeTokens(value) {
    return normalizeTokenList(value).map(function (code) {
      return normalizeTitle(code);
    }).filter(Boolean);
  }

  function normalizePreferredDiscountCandidate(candidate) {
    var normalized = candidate && typeof candidate === 'object' ? candidate : {};
    var code = normalizeText(normalized.code || normalized.discountCode || normalized.title);
    var variantIds = normalizeIdList(normalized.variantIds || normalized.requiredVariantIds);
    var percent = normalizePercent(normalized.percent || normalized.discountPercent, 0);

    if (!code || !variantIds.length) {
      return null;
    }

    return {
      code: code,
      title: normalizeText(normalized.title) || code,
      percent: percent,
      variantIds: variantIds
    };
  }

  function getPreferredDiscountFromDom() {
    var offer = document.querySelector('[data-tm-parfum-quadro-offer]');
    var code = offer ? normalizeText(offer.getAttribute('data-tm-parfum-quadro-discount-code')) : '';
    var variantIds = offer ? normalizeIdList(offer.getAttribute('data-tm-parfum-quadro-variant-ids')) : [];

    if (!code || !variantIds.length) {
      return null;
    }

    return normalizePreferredDiscountCandidate({
      code: code,
      percent: 18,
      variantIds: variantIds
    });
  }

  function getPreferredDiscountCandidate() {
    var domCandidate = getPreferredDiscountFromDom();

    if (domCandidate) {
      state.preferredDiscount = domCandidate;
    }

    return state.preferredDiscount;
  }

  function cartHasRequiredVariantIds(cart, variantIds) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return variantIds.every(function (variantId) {
      return items.some(function (item) {
        return getItemVariantId(item) === normalizeText(variantId) && getItemQuantity(item) > 0;
      });
    });
  }

  function getDiscountApplications(cart) {
    var applications = [];
    var seen = {};
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var cartApplications = cart && Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    function pushApplication(application, amount) {
      var title = normalizeText(application && (application.title || application.code));
      var key;

      if (!title) {
        return;
      }

      key = normalizeTitle(title) + ':' + normalizeText(application && application.value_type) + ':' + normalizeText(application && application.value);

      if (seen[key]) {
        return;
      }

      seen[key] = true;
      applications.push({
        title: title,
        code: normalizeText(application && application.code),
        value: normalizeText(application && application.value),
        valueType: normalizeText(application && application.value_type),
        amount: normalizeCents(amount !== undefined ? amount : application && application.total_allocated_amount, 0)
      });
    }

    cartApplications.forEach(function (application) {
      var actual = application && application.discount_application || application;
      pushApplication(actual, application && application.amount !== undefined ? application.amount : actual && actual.total_allocated_amount);
    });

    items.forEach(function (item) {
      if (!item || !Array.isArray(item.line_level_discount_allocations)) {
        return;
      }

      item.line_level_discount_allocations.forEach(function (allocation) {
        pushApplication(
          allocation && allocation.discount_application,
          allocation && allocation.amount
        );
      });
    });

    return applications;
  }

  function discountApplicationMatchesCode(application, code) {
    var normalizedCode = normalizeTitle(code);
    var title = normalizeTitle(application && application.title);
    var applicationCode = normalizeTitle(application && application.code);

    if (!normalizedCode) {
      return false;
    }

    return title === normalizedCode || applicationCode === normalizedCode;
  }

  function cartHasDiscountCode(cart, code) {
    return getDiscountApplications(cart).some(function (application) {
      return application.amount > 0 && discountApplicationMatchesCode(application, code);
    });
  }

  function cartHasAnyDiscountCode(cart, codes) {
    var normalizedCodes = getDiscountCodeTokens(codes);

    if (!normalizedCodes.length) {
      return false;
    }

    return getDiscountApplications(cart).some(function (application) {
      var title = normalizeTitle(application && application.title);
      var code = normalizeTitle(application && application.code);

      return application.amount > 0 && normalizedCodes.some(function (candidateCode) {
        return title === candidateCode || code === candidateCode;
      });
    });
  }

  function getAcquisitionBenefitStatus(cart, config) {
    var codes = normalizeTokenList(config && config.discountCodes);
    var shippingCodes = codes.filter(function (code) { return normalizeTitle(code) === normalizeTitle('ROYALC1SHIP'); });
    var merchandiseCodes = codes.filter(function (code) { return shippingCodes.indexOf(code) < 0; });
    var codeResults = cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    var merchandiseConfirmed = merchandiseCodes.length > 0 && merchandiseCodes.every(function (code) {
      return cartHasDiscountCode(cart, code);
    });
    var shippingSubmitted = shippingCodes.every(function (code) {
      return codeResults.some(function (entry) { return normalizeTitle(entry.code) === normalizeTitle(code) && typeof entry.applicable === 'boolean'; });
    });
    var shippingApplicable = shippingCodes.length > 0 && shippingCodes.every(function (code) {
      return codeResults.some(function (entry) { return normalizeTitle(entry.code) === normalizeTitle(code) && entry.applicable === true; });
    });
    var preferred = getPreferredDiscountCandidate();
    var ignored = codes.concat(preferred ? [preferred.code] : []);
    var higherPriority = Boolean(preferred && cartHasRequiredVariantIds(cart, preferred.variantIds) && cartHasDiscountCode(cart, preferred.code)) ||
      getHighestCurrentOrderDiscountPercent(cart, ignored) > getAcquisitionDiscountPercent(config);
    var cartState = getAcquisitionCartState(cart, config);
    var sampleConfirmed = config && config.fulfillmentMode === 'cart_line'
      ? cartState.giftItems.some(function (line) { return isAcquisitionGiftForActiveOffer(line, config); })
      : acquisitionAttributesMatch(cart, getAcquisitionAttributePayload(cartState.sampleToPack, config));
    return { merchandiseConfirmed: merchandiseConfirmed, shippingSubmitted: shippingSubmitted,
      shippingApplicable: shippingApplicable, sampleConfirmed: sampleConfirmed,
      higherPriority: higherPriority, confirmed: merchandiseConfirmed && shippingSubmitted && sampleConfirmed };
  }

  function getDiscountApplicationPercent(application) {
    if (!application) {
      return 0;
    }

    if (application.valueType === 'percentage') {
      return normalizePercent(application.value, 0);
    }

    return getPercentFromText(application.title || application.code);
  }

  function getHighestCurrentOrderDiscountPercent(cart, ignoredCodes) {
    var ignored = getDiscountCodeTokens(ignoredCodes);

    return getDiscountApplications(cart).reduce(function (highest, application) {
      var title = normalizeTitle(application && application.title);
      var code = normalizeTitle(application && application.code);
      var percent;

      if (
        application.amount <= 0 ||
        ignored.indexOf(title) !== -1 ||
        ignored.indexOf(code) !== -1
      ) {
        return highest;
      }

      percent = getDiscountApplicationPercent(application);

      return percent > highest ? percent : highest;
    }, 0);
  }

  function getAcquisitionDiscountPercent(config) {
    return getPercentFromText(config && config.labels && config.labels.orderDiscount) ||
      getPercentFromText(config && config.discountCodes);
  }

  function getDiscountFingerprint(cart, config, preferredDiscount) {
    var applications = getDiscountApplications(cart).map(function (application) {
      return normalizeTitle(application.title || application.code) + ':' + application.amount;
    }).sort().join('|');
    var preferred = preferredDiscount
      ? preferredDiscount.code + ':' + cartHasRequiredVariantIds(cart, preferredDiscount.variantIds)
      : '';

    return [
      preferred,
      normalizeText(config && config.discountCodes),
      applications,
      JSON.stringify((cart && cart.items || []).map(function (line) { return [line.variant_id || line.id, line.quantity, line.properties, line.selling_plan_allocation]; })),
      cart && cart.currency
    ].join('::');
  }

  function applyDiscountWinner(cart, config) {
    var preferredDiscount = getPreferredDiscountCandidate();
    var preferredQualified = Boolean(
      preferredDiscount &&
      cartHasRequiredVariantIds(cart, preferredDiscount.variantIds)
    );
    var acquisitionPercent = getAcquisitionDiscountPercent(config);
    var ignoredCodes = normalizeTokenList(config && config.discountCodes);
    var higherCurrentPercent;
    var fingerprint;

    if (preferredDiscount) {
      ignoredCodes.push(preferredDiscount.code);
    }

    fingerprint = getDiscountFingerprint(cart, config, preferredDiscount);

    if (preferredQualified) {
      if (cartHasDiscountCode(cart, preferredDiscount.code)) {
        state.lastDiscountFingerprint = fingerprint;
        return Promise.resolve({
          ok: true,
          skipped: true,
          action: 'preferred_already_active',
          preferred: preferredDiscount
        });
      }

      state.lastDiscountFingerprint = '';
      return postJson('/cart/update.js', {
        discount: preferredDiscount.code
      }).then(function (result) {
        return Object.assign({}, result, {
          action: 'preferred_applied',
          preferred: preferredDiscount
        });
      });
    }

    if (preferredDiscount && cartHasDiscountCode(cart, preferredDiscount.code)) {
      state.lastDiscountFingerprint = '';
      return postJson('/cart/update.js', {
        discount: ''
      }).then(function (result) {
        var resultCart = getCartFromCartMutationResult(result);

        if (resultCart) {
          state.discountReconcileCart = resultCart;
          state.discountReconcileQueued = true;
        }

        return Object.assign({}, result, {
          action: 'preferred_cleared',
          preferred: preferredDiscount
        });
      });
    }

    higherCurrentPercent = getHighestCurrentOrderDiscountPercent(cart, ignoredCodes);

    if (higherCurrentPercent > acquisitionPercent) {
      state.lastDiscountFingerprint = fingerprint;
      return Promise.resolve({
        ok: true,
        skipped: true,
        action: 'higher_discount_present',
        highestPercent: higherCurrentPercent
      });
    }

    var benefits = getAcquisitionBenefitStatus(cart, config);
    if (benefits.merchandiseConfirmed && benefits.shippingSubmitted) {
      state.lastDiscountFingerprint = fingerprint;
      return Promise.resolve({ ok: true, skipped: true, action: 'acquisition_already_active' });
    }

    state.lastDiscountFingerprint = '';
    return postJson('/cart/update.js', { discount: config.discountCodes }).then(function (result) {
      var actualCart = getCartFromCartMutationResult(result);
      var actual = actualCart && getAcquisitionBenefitStatus(actualCart, config);
      if (result.ok && actual && actual.merchandiseConfirmed && actual.shippingSubmitted) {
        state.lastDiscountFingerprint = getDiscountFingerprint(actualCart, config, preferredDiscount);
      }
      return Object.assign({}, result, { action: 'acquisition_applied', benefits: actual });
    });
  }

  function reconcileDiscountPriority(cart, config) {
    if (!config || !config.discountCodes) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        action: 'missing_config'
      });
    }

    if (state.discountReconcileInFlight) {
      if (cart && typeof cart === 'object') {
        state.discountReconcileCart = cart;
      }

      state.discountReconcileQueued = true;
      return Promise.resolve({
        ok: true,
        queued: true,
        action: 'queued'
      });
    }

    state.discountReconcileInFlight = true;
    state.discountReconcileQueued = false;

    return applyDiscountWinner(cart, config).finally(function () {
      state.discountReconcileInFlight = false;

      if (state.discountReconcileQueued) {
        state.discountReconcileQueued = false;
        scheduleAcquisitionOfferSync(state.discountReconcileCart, 'discount_reconcile_queued');
        state.discountReconcileCart = null;
      }
    });
  }

  function getItemVariantId(item) {
    if (!item) {
      return '';
    }

    return normalizeText(item.variant_id || item.id);
  }

  function getItemQuantity(item) {
    return normalizeQuantity(item && item.quantity, 0) || 0;
  }

  function getItemLineValue(item) {
    var quantity = getItemQuantity(item);

    if (!item || typeof item !== 'object') {
      return 0;
    }

    if (typeof item.final_line_price === 'number') {
      return item.final_line_price;
    }

    if (typeof item.line_price === 'number') {
      return item.line_price;
    }

    if (typeof item.final_price === 'number') {
      return item.final_price * quantity;
    }

    if (typeof item.price === 'number') {
      return item.price * quantity;
    }

    return 0;
  }

  function isZeroPriceLine(item) {
    return getItemLineValue(item) <= 0 ||
      (item && typeof item.final_price === 'number' && item.final_price <= 0);
  }

  function isConfiguredFreebieItem(item, config) {
    var freebieVariantId = config ? normalizeText(config.freebieVariantId) : '';

    return Boolean(freebieVariantId && getItemVariantId(item) === freebieVariantId);
  }

  function isEligiblePaidItem(item, config) {
    return Boolean(
      item &&
      getItemQuantity(item) > 0 &&
      getItemVariantId(item) !== '43326220763184' &&
      !isConfiguredFreebieItem(item, config) &&
      !isZeroPriceLine(item)
    );
  }

  function isRotationGiftItem(item) {
    return Boolean(
      getLineProperty(item, '_atoz_gift_reward') ||
      getLineProperty(item, '_atoz_auto_added') === 'true' ||
      getLineProperty(item, '_atoz_gwp') ||
      getLineProperty(item, '_free_gift')
    );
  }

  function isRotationEligibleItem(item, config) {
    var handle = getItemHandle(item);

    return Boolean(
      item &&
      handle &&
      config &&
      config.eligibleHandles.indexOf(handle) !== -1 &&
      getItemQuantity(item) > 0 &&
      !isZeroPriceLine(item) &&
      !isRotationGiftItem(item)
    );
  }

  function getRotationEligibleCartItems(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items.filter(function (item) {
      return isRotationEligibleItem(item, config);
    });
  }

  function getRotationEligibleQuantity(cart, config) {
    return getRotationEligibleCartItems(cart, config).reduce(function (total, item) {
      return total + getItemQuantity(item);
    }, 0);
  }

  function getEligibleCartItems(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items.filter(function (item) {
      return isEligiblePaidItem(item, config);
    });
  }

  function getEligibleQuantity(cart, config) {
    return getEligibleCartItems(cart, config).reduce(function (total, item) {
      return total + getItemQuantity(item);
    }, 0);
  }

  function getEligibleSubtotal(cart, config) {
    return getEligibleCartItems(cart, config).reduce(function (total, item) {
      return total + Math.max(getItemLineValue(item), 0);
    }, 0);
  }

  function getActualDiscountTitles(cart) {
    var titles = [];
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var cartApplications = cart && Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    items.forEach(function (item) {
      if (!item || !Array.isArray(item.line_level_discount_allocations)) {
        return;
      }

      item.line_level_discount_allocations.forEach(function (allocation) {
        var title = allocation &&
          allocation.discount_application &&
          allocation.discount_application.title
          ? allocation.discount_application.title
          : '';

        if (title) {
          titles.push(title);
        }
      });
    });

    cartApplications.forEach(function (application) {
      if (application && application.title) {
        titles.push(application.title);
      }
    });

    return titles.filter(function (title, index) {
      var normalized = normalizeTitle(title);

      return Boolean(normalized) && titles.map(normalizeTitle).indexOf(normalized) === index;
    });
  }

  function getAppliedBundleTier(cart) {
    var labels = {
      '10.10 SALE: BUY 2 GET 12% OFF': '12% off eligible bottles applied.',
      '10.10 SALE: BUY 3 GET 18% OFF': '18% off eligible bottles applied.',
      '10.10 SALE: BUY 5 GET 22% OFF': '22% off eligible bottles applied.'
    };
    var recognized = [];
    var malformed = false;
    var inspect = function (title, amount) {
      if (!Object.prototype.hasOwnProperty.call(labels, title)) return;
      if (!Number.isSafeInteger(amount) || amount < 0) {
        malformed = true;
        return;
      }
      if (amount > 0 && recognized.indexOf(title) === -1) recognized.push(title);
    };
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var cartApplications = cart && Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications : [];

    items.forEach(function (item) {
      if (!item || !Array.isArray(item.line_level_discount_allocations)) return;
      item.line_level_discount_allocations.forEach(function (allocation) {
        inspect(allocation && allocation.discount_application && allocation.discount_application.title,
          allocation && allocation.amount);
      });
    });
    cartApplications.forEach(function (application) {
      inspect(application && application.title, application && application.total_allocated_amount);
    });

    if (malformed || recognized.length > 1 || (recognized.length && cart.currency !== 'PHP'))
      return { state: 'uncertain', headline: 'Current discounts are shown in your bag.' };
    return recognized.length
      ? { state: 'applied', headline: labels[recognized[0]] }
      : { state: 'none', headline: '' };
  }

  function isActiveBundleBuilderPreview() {
    var provider = window.TheManBundleProvider;
    if (!provider || provider.enabled !== true || provider.campaignId !== 'THEMAN-002-1010' ||
        !['TEST_SCOPE', 'PUBLIC_CANDIDATE', 'PUBLIC'].includes(provider.scope) ||
        window.location?.pathname !== '/pages/bundle-deals-promo') return false;
    if (typeof provider.isActiveHere !== 'function') return false;
    try { return provider.isActiveHere() === true; } catch (_) { return false; }
  }

  function hasActualDiscountTitle(discountTitle, actualTitles) {
    var normalizedTitle = normalizeTitle(discountTitle);

    if (!normalizedTitle) {
      return false;
    }

    return actualTitles.map(normalizeTitle).indexOf(normalizedTitle) !== -1;
  }

  function getFreebieState(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var freebieItem = null;
    var freebieVariantId = config ? normalizeText(config.freebieVariantId) : '';

    if (!freebieVariantId) {
      return {
        configured: false,
        present: false,
        added: false,
        item: null
      };
    }

    freebieItem = items.find(function (item) {
      return isConfiguredFreebieItem(item, config);
    }) || null;

    return {
      configured: true,
      present: Boolean(freebieItem),
      added: Boolean(freebieItem && isZeroPriceLine(freebieItem)),
      item: freebieItem
    };
  }

  function getTierName(tier) {
    return normalizeText(tier && (tier.rewardLabel || tier.label)) || 'reward';
  }

  function getPerkName(perk) {
    return normalizeText(perk && (perk.title || perk.label)) || 'perk';
  }

  function calculateTierProgress(tiers, eligibleQuantity) {
    var nextLocked;
    var previousTier;
    var nextIndex;
    var previousPercent;
    var nextPercent;
    var partialRatio;

    if (!tiers.length) {
      return 0;
    }

    nextLocked = tiers.find(function (tier) {
      return tier.state === 'locked';
    });

    if (!nextLocked) {
      return 100;
    }

    nextIndex = nextLocked.index;

    if (nextIndex <= 0 || tiers.length === 1) {
      return 0;
    }

    previousTier = tiers[nextIndex - 1];
    previousPercent = previousTier.index / (tiers.length - 1) * 100;
    nextPercent = nextLocked.index / (tiers.length - 1) * 100;
    partialRatio = Math.max(0, Math.min(
      (eligibleQuantity - previousTier.threshold) / Math.max(nextLocked.threshold - previousTier.threshold, 1),
      1
    ));

    return previousPercent + ((nextPercent - previousPercent) * partialRatio);
  }

  function createRewardHeadline(rewardState) {
    var next = rewardState && rewardState.nextLockedTier ? rewardState.nextLockedTier : null;
    var best = rewardState && rewardState.bestTier ? rewardState.bestTier : null;
    var remaining;
    var name;

    if (next) {
      name = getTierName(next);
      remaining = Math.max(next.threshold - rewardState.eligibleQuantity, 0);
      return 'Add ' + remaining + ' more ' + (remaining === 1 ? 'scent' : 'scents') + ' to unlock ' + name + '.';
    }

    if (best) {
      name = getTierName(best);

      if (best.state === 'applied') {
        return name + ' applied.';
      }

      return name.charAt(0).toUpperCase() + name.slice(1) + ' eligible.';
    }

    return 'Add items to unlock rewards.';
  }

  function calculateTierStates(config, eligibleQuantity, actualDiscountTitles) {
    var tiers = config.tiers.map(function (tier, index) {
      var eligible = eligibleQuantity >= tier.threshold;
      var applied = Boolean(eligible && hasActualDiscountTitle(tier.discountTitle, actualDiscountTitles));
      var stateName = applied ? 'applied' : eligible ? 'eligible' : 'locked';

      return Object.assign({}, tier, {
        index: index,
        eligible: eligible,
        applied: applied,
        state: stateName
      });
    });
    var nextLockedTier = tiers.find(function (tier) {
      return eligibleQuantity < tier.threshold;
    }) || null;
    var bestTier = null;

    tiers.forEach(function (tier) {
      if (tier.state !== 'locked') {
        bestTier = tier;
      }
    });

    return {
      tiers: tiers,
      nextLockedTier: nextLockedTier,
      bestTier: bestTier,
      progressPercent: calculateTierProgress(tiers, eligibleQuantity)
    };
  }

  function getPerkStatus(perk, remaining) {
    if (perk.mode === 'disabled') {
      return 'Inactive';
    }

    if (perk.id === 'sample' && perk.state === 'added') {
      return 'Added';
    }

    if (perk.mode === 'included') {
      return 'Included';
    }

    if (perk.state === 'unlocked') {
      return 'Unlocked';
    }

    return formatWholePesoCeil(remaining) + ' left';
  }

  function calculatePerkStates(config, eligibleSubtotal, freebieState) {
    return config.perks.map(function (perk) {
      var remaining = 0;
      var eligible = false;
      var added = false;
      var stateName = 'locked';

      if (perk.mode === 'disabled') {
        return Object.assign({}, perk, {
          eligible: false,
          added: false,
          hidden: true,
          remainingCents: 0,
          state: 'disabled',
          status: 'Inactive'
        });
      }

      if (perk.mode === 'included') {
        eligible = true;
      } else {
        eligible = eligibleSubtotal >= perk.thresholdCents;
        remaining = Math.max(perk.thresholdCents - eligibleSubtotal, 0);
      }

      if (perk.id === 'sample') {
        added = Boolean(freebieState.added);
        stateName = added ? 'added' : eligible ? 'unlocked' : 'locked';
      } else {
        stateName = eligible ? 'unlocked' : 'locked';
      }

      return Object.assign({}, perk, {
        eligible: eligible,
        added: added,
        hidden: false,
        remainingCents: remaining,
        state: stateName,
        status: getPerkStatus(Object.assign({}, perk, { state: stateName }), remaining)
      });
    });
  }

  function calculateRewardState(cart) {
    var config = parseRewardConfig();
    var eligibleQuantity;
    var eligibleSubtotal;
    var actualDiscountTitles;
    var freebieState;
    var tierState;
    var perks;

    if (!config) {
      return null;
    }

    eligibleQuantity = getEligibleQuantity(cart, config);
    eligibleSubtotal = getEligibleSubtotal(cart, config);
    actualDiscountTitles = getActualDiscountTitles(cart);
    freebieState = getFreebieState(cart, config);
    tierState = calculateTierStates(config, eligibleQuantity, actualDiscountTitles);
    perks = calculatePerkStates(config, eligibleSubtotal, freebieState);

    return {
      config: config,
      eligibleItems: getEligibleCartItems(cart, config),
      eligibleQuantity: eligibleQuantity,
      eligibleSubtotal: eligibleSubtotal,
      actualDiscountTitles: actualDiscountTitles,
      freebieState: freebieState,
      tiers: tierState.tiers,
      perks: perks,
      nextLockedTier: tierState.nextLockedTier,
      bestTier: tierState.bestTier,
      progressPercent: tierState.progressPercent,
      tierProgressPercent: tierState.progressPercent,
      headline: createRewardHeadline({
        eligibleQuantity: eligibleQuantity,
        eligibleSubtotal: eligibleSubtotal,
        perks: perks,
        nextLockedTier: tierState.nextLockedTier,
        bestTier: tierState.bestTier
      })
    };
  }

  function renderTierRail(rewardBar, rewardState) {
    var railNode = rewardBar.querySelector(selectors.tierRail);
    var fillNode = rewardBar.querySelector(selectors.tierFill);

    if (railNode) {
      railNode.hidden = !rewardState.tiers.length;
      railNode.setAttribute('aria-hidden', rewardState.tiers.length ? 'false' : 'true');
    }

    if (fillNode) {
      fillNode.style.width = rewardState.tierProgressPercent.toFixed(2) + '%';
    }

    rewardState.tiers.forEach(function (tier) {
      var node = rewardBar.querySelector(selectors.tierNode + '[data-atoz-tier-node="' + cssEscape(tier.id) + '"]');
      var labelNode = node ? node.querySelector(selectors.tierLabel) : null;
      var valueNode = node ? node.querySelector(selectors.tierValue) : null;

      if (!node) {
        return;
      }

      node.setAttribute('data-atoz-tier-state', tier.state);
      node.classList.toggle('is-locked', tier.state === 'locked');
      node.classList.toggle('is-eligible', tier.state === 'eligible');
      node.classList.toggle('is-applied', tier.state === 'applied');
      node.setAttribute('aria-label', tier.label + ': ' + tier.state);

      if (labelNode) {
        labelNode.textContent = tier.label;
      }

      if (valueNode) {
        valueNode.textContent = tier.rewardLabel;
      }
    });
  }

  function renderPerkCards(rewardBar, rewardState) {
    rewardState.perks.forEach(function (perk) {
      var card = rewardBar.querySelector(selectors.perkCard + '[data-atoz-perk-card="' + cssEscape(perk.id) + '"]');
      var titleNode = card ? card.querySelector(selectors.perkTitle) : null;
      var statusNode = card ? card.querySelector(selectors.perkStatus) : null;

      if (!card) {
        return;
      }

      card.hidden = Boolean(perk.hidden);
      card.setAttribute('data-atoz-perk-state', perk.state);
      card.classList.toggle('is-locked', perk.state === 'locked');
      card.classList.toggle('is-unlocked', perk.state === 'unlocked');
      card.classList.toggle('is-added', perk.state === 'added');
      card.classList.toggle('is-disabled', perk.state === 'disabled');
      card.setAttribute('aria-label', getPerkName(perk) + ': ' + perk.status);

      if (titleNode) {
        titleNode.textContent = getPerkName(perk);
      }

      if (statusNode) {
        statusNode.textContent = perk.status;
      }
    });
  }

  function getSamplePerk(rewardState) {
    return rewardState && Array.isArray(rewardState.perks)
      ? rewardState.perks.find(function (perk) {
        return perk && perk.id === 'sample';
      }) || null
      : null;
  }

  function isLegacyIncludedFreebieSuppressedByAcquisition() {
    var acquisitionConfig = getAcquisitionConfig();

    return Boolean(acquisitionConfig && isAcquisitionSessionArmed(acquisitionConfig));
  }

  function maybeAutoAddFreebie(cart, rewardState) {
    var config = rewardState && rewardState.config ? rewardState.config : null;
    var samplePerk = getSamplePerk(rewardState);
    var variantId = config ? normalizeText(config.freebieVariantId) : '';
    var attemptKey;

    if (
      !config ||
      !config.autoAddFreebie ||
      !samplePerk ||
      samplePerk.mode !== 'included' ||
      !variantId ||
      state.freebieAutoAddInFlight ||
      state.acquisitionOfferSyncInFlight ||
      state.pending ||
      rewardState.freebieState.present ||
      !rewardState.eligibleItems.length ||
      isLegacyIncludedFreebieSuppressedByAcquisition()
    ) {
      return {
        ok: true,
        skipped: true
      };
    }

    state.freebieAutoAddInFlight = true;

    var coordinator = window.TheManCartCoordinator;
    var write = function (before) {
      var freshReward = coordinator ? calculateRewardState(before) : rewardState;
      var freshConfig = freshReward && freshReward.config;
      var freshPerk = freshReward && getSamplePerk(freshReward);
      if (!freshConfig || !freshConfig.autoAddFreebie || !freshPerk || freshPerk.mode !== 'included' ||
          normalizeText(freshConfig.freebieVariantId) !== variantId || freshReward.freebieState.present ||
          !freshReward.eligibleItems.length || isLegacyIncludedFreebieSuppressedByAcquisition())
        return Promise.resolve({ ok: true, skipped: true, cart: {} });
      attemptKey = variantId + ':' + freshReward.eligibleQuantity + ':' + freshReward.eligibleSubtotal;
      if (state.freebieAutoAddAttemptKey === attemptKey) return Promise.resolve({ ok: true, skipped: true, cart: {} });
      state.freebieAutoAddAttemptKey = attemptKey;
      return postJson('/cart/add.js', {
        items: [{ id: variantId, quantity: 1 }]
      }).then(function (result) { return Object.assign({}, result, { cart: {} }); });
    };

    (coordinator ? coordinator.mutate(write) : write()).then(function (addResult) {
      if (!addResult.ok && addResult.code === 'network_error') showError('Review your bag before trying again.');
      return (coordinator && addResult.cart && Array.isArray(addResult.cart.items)
        ? Promise.resolve({ ok: true, cart: addResult.cart })
        : getCart()).then(function (cartResult) {
        if (cartResult.ok) {
          applyCartState(cartResult.cart);
        }

        return Object.assign({}, addResult, {
          cart: cartResult
        });
      });
    }).catch(function (error) {
      debugLog('freebie auto-add error', error && error.message);
      if (error && error.uncertain) showError('Review your bag before trying again.');
    }).finally(function () {
      state.freebieAutoAddInFlight = false;
    });

    return {
      ok: true,
      autoAddStarted: true
    };
  }

  function getRotationProgressMessage(eligibleQuantity) {
    if (eligibleQuantity >= 5) {
      return '18% highest rotation savings unlocked.';
    }

    if (eligibleQuantity >= 3) {
      return '13% rotation savings unlocked. Add 1 more scent to unlock 18%.';
    }

    if (eligibleQuantity >= 2) {
      return '10% rotation savings unlocked. Add 1 more scent to unlock 13%.';
    }

    if (eligibleQuantity === 1) {
      return 'Add 1 more eligible scent to unlock your exclusive rotation savings.';
    }

    return 'Add 2 eligible scents to unlock your exclusive rotation savings.';
  }

  function getRotationProgressPercent(eligibleQuantity) {
    if (eligibleQuantity >= 5) {
      return 100;
    }

    if (eligibleQuantity <= 1) {
      return 0;
    }

    return Math.max(0, Math.min(eligibleQuantity / 5 * 100, 100));
  }

  function getRotationTierState(eligibleQuantity, threshold) {
    return eligibleQuantity >= threshold ? 'unlocked' : 'locked';
  }

  function renderRotationReward(cart) {
    var drawer = getDrawer();
    var rewardBar = getRewardBar();
    var rotationReward = getRotationReward();
    var active = isRotationContextActive(cart);
    var config;
    var eligibleQuantity;
    var checkoutTarget;
    var messageNode;
    var fillNode;
    var tiers;

    if (rewardBar) {
      rewardBar.hidden = active;
      rewardBar.setAttribute('aria-hidden', active ? 'true' : 'false');
    }

    if (!rotationReward) {
      updateRotationCheckoutControls(null);

      if (drawer) {
        drawer.removeAttribute('data-atoz-rotation-context');
      }

      return {
        ok: true,
        active: active,
        skipped: true
      };
    }

    rotationReward.hidden = !active;
    rotationReward.setAttribute('aria-hidden', active ? 'false' : 'true');

    if (drawer) {
      if (active) {
        drawer.setAttribute('data-atoz-rotation-context', 'true');
      } else {
        drawer.removeAttribute('data-atoz-rotation-context');
      }
    }

    if (!active) {
      rotationReward.removeAttribute('data-atoz-rotation-checkout-code');
      updateRotationCheckoutControls(null);

      return {
        ok: true,
        active: false
      };
    }

    config = parseRotationRewardConfig();
    eligibleQuantity = getRotationEligibleQuantity(cart, config);
    checkoutTarget = {
      code: getRotationDiscountCode(eligibleQuantity, config.discountCodes),
      eligibleQuantity: eligibleQuantity
    };
    checkoutTarget.url = getRotationCheckoutUrl(checkoutTarget.code);
    messageNode = rotationReward.querySelector(selectors.rotationMessage);
    fillNode = rotationReward.querySelector(selectors.rotationFill);
    tiers = Array.prototype.slice.call(rotationReward.querySelectorAll(selectors.rotationTier));

    rotationReward.setAttribute('data-atoz-rotation-eligible-count', String(eligibleQuantity));
    rotationReward.setAttribute('data-atoz-rotation-checkout-code', checkoutTarget.code || '');

    updateRotationCheckoutControls(checkoutTarget.url ? checkoutTarget : null);

    if (messageNode) {
      messageNode.textContent = getRotationProgressMessage(eligibleQuantity);
    }

    if (fillNode) {
      fillNode.style.width = getRotationProgressPercent(eligibleQuantity).toFixed(2) + '%';
    }

    tiers.forEach(function (tier) {
      var threshold = normalizeQuantity(tier.getAttribute('data-atoz-rotation-tier'), 0);
      var tierState = getRotationTierState(eligibleQuantity, threshold);

      tier.setAttribute('data-atoz-rotation-tier-state', tierState);
      tier.classList.toggle('is-unlocked', tierState === 'unlocked');
      tier.classList.toggle('is-locked', tierState === 'locked');
    });

    return {
      ok: true,
      active: true,
      eligibleQuantity: eligibleQuantity,
      discountCodes: config.discountCodes,
      checkout: checkoutTarget
    };
  }

  function renderRewardBar(cart, options) {
    var rewardBar = getRewardBar();
    var rotationResult = renderRotationReward(cart);
    var ribbedTeeLaunchActive = isRibbedTeeLaunchContextActive();
    var bundleTier = getAppliedBundleTier(cart);
    var suppressGenericTiers = bundleTier.state !== 'none' || isActiveBundleBuilderPreview();
    var rewardState;
    var headlineNode;

    if (rotationResult && rotationResult.active) {
      return {
        ok: true,
        reward: null,
        rotation: rotationResult
      };
    }

    if (!rewardBar) {
      return {
        ok: true,
        skipped: true
      };
    }

    if (ribbedTeeLaunchActive) {
      suppressRewardBar(rewardBar);

      return {
        ok: true,
        reward: null,
        ribbedTeeLaunch: true
      };
    }

    restoreRewardBar(rewardBar);

    rewardState = calculateRewardState(cart);

    if (!rewardState) {
      return {
        ok: true,
        skipped: true
      };
    }

    headlineNode = rewardBar.querySelector(selectors.rewardHeadline);

    if (headlineNode) {
      headlineNode.textContent = bundleTier.state !== 'none' ? bundleTier.headline :
        suppressGenericTiers ? 'Choose scents in Bundle Builder to see your offer.' : rewardState.headline;
    }

    if (suppressGenericTiers) {
      var railNode = rewardBar.querySelector(selectors.tierRail);
      if (railNode) {
        railNode.hidden = true;
        railNode.setAttribute('aria-hidden', 'true');
      }
    } else {
      renderTierRail(rewardBar, rewardState);
    }
    renderPerkCards(rewardBar, rewardState);
    if (!options?.readOnlyReview) maybeAutoAddFreebie(cart, rewardState);

    rewardBar.setAttribute('data-atoz-reward-progress', String(Math.round(rewardState.progressPercent)));

    return {
      ok: true,
      reward: rewardState
    };
  }

  function getAcquisitionOfferBlock() {
    var drawer = getDrawer();

    return drawer ? drawer.querySelector(selectors.acquisitionOffer) : null;
  }

  function stopAcquisitionCountdownTimer() {
    if (state.acquisitionCountdownTimer) {
      window.clearTimeout(state.acquisitionCountdownTimer);
    }

    state.acquisitionCountdownTimer = null;
  }

  function formatCountdownSeconds(seconds) {
    var safeSeconds = Math.max(normalizeQuantity(seconds, 0), 0);
    var minutes = Math.floor(safeSeconds / 60);
    var remainingSeconds = safeSeconds % 60;

    return minutes + ':' + (remainingSeconds < 10 ? '0' : '') + remainingSeconds;
  }

  function setNodeText(node, text) {
    if (node && text) {
      node.textContent = text;
    }
  }

  function getRibbedTeeLaunchCard() {
    var drawer = getDrawer();

    return drawer ? drawer.querySelector(selectors.ribbedTeeLaunchCard) : null;
  }

  function getRibbedTeeQuantity(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items.reduce(function (total, item) {
      return getItemHandle(item) === ribbedTeeProductHandle
        ? total + getItemQuantity(item)
        : total;
    }, 0);
  }

  function getRibbedTeeLaunchCopy(quantity) {
    if (quantity >= 2) {
      return {
        heading: '15% launch discount unlocked.',
        support: 'Your 15% launch discount is active for this cart.'
      };
    }

    if (quantity === 1) {
      return {
        heading: '10% launch discount unlocked.',
        support: 'Add 1 more Slim Ribbed Tee to unlock 15% off.'
      };
    }

    return {
      heading: 'Launch discount ready.',
      support: 'Add a Slim Ribbed Tee to unlock your launch discount.'
    };
  }

  function applyRibbedTeeLaunchCardTone(card) {
    var ribbon = card ? card.querySelector('.atoz-cart-drawer__acquisition-offer-ribbon') : null;
    var countdown = card ? card.querySelector(selectors.ribbedTeeLaunchCountdown) : null;
    var tiles = card ? Array.prototype.slice.call(card.querySelectorAll('.atoz-cart-drawer__acquisition-offer-list li')) : [];

    if (!card) {
      return;
    }

    card.style.background = '#F5F5F5';
    card.style.borderColor = '#111111';

    if (ribbon) {
      ribbon.style.background = '#111111';
      ribbon.style.color = '#FFFFFF';
    }

    if (countdown) {
      countdown.style.background = '#FFFFFF';
      countdown.style.borderColor = '#111111';
      countdown.style.color = '#111111';
    }

    tiles.forEach(function (tile) {
      tile.style.background = '#FFFFFF';
      tile.style.borderColor = '#DADADA';
    });
  }

  function createRibbedTeeLaunchCard() {
    var card = document.createElement('section');

    card.className = 'atoz-cart-drawer__acquisition-offer appear-animation appear-delay-3';
    card.setAttribute('data-atoz-ribbed-tee-launch-card', '');
    card.setAttribute('aria-label', 'Ribbed Tee launch discount');
    card.hidden = true;
    card.innerHTML = [
      '<div class="atoz-cart-drawer__acquisition-offer-kicker">',
      '<span class="atoz-cart-drawer__acquisition-offer-ribbon">LAUNCH SPECIAL</span>',
      '<span class="atoz-cart-drawer__acquisition-offer-countdown" data-atoz-ribbed-tee-launch-countdown>ENDS IN 10:00</span>',
      '</div>',
      '<h2 class="atoz-cart-drawer__acquisition-offer-heading" data-atoz-ribbed-tee-launch-heading>Launch discount ready.</h2>',
      '<ul class="atoz-cart-drawer__acquisition-offer-list">',
      '<li>',
      '<span class="atoz-cart-drawer__acquisition-offer-icon" aria-hidden="true">1</span>',
      '<span><strong>10% OFF</strong><span>1 Slim Ribbed Tee</span><span>Applied automatically</span></span>',
      '</li>',
      '<li>',
      '<span class="atoz-cart-drawer__acquisition-offer-icon" aria-hidden="true">2</span>',
      '<span><strong>15% OFF</strong><span>2+ Slim Ribbed Tees</span><span>Best value</span></span>',
      '</li>',
      '<li>',
      '<span class="atoz-cart-drawer__acquisition-offer-icon" aria-hidden="true">3</span>',
      '<span><strong>NO CODE NEEDED</strong><span>Discount appears in cart</span><span>Checkout when ready</span></span>',
      '</li>',
      '</ul>',
      '<p class="atoz-cart-drawer__acquisition-offer-disclaimer" data-atoz-ribbed-tee-launch-support>Add a Slim Ribbed Tee to unlock your launch discount.</p>'
    ].join('');
    applyRibbedTeeLaunchCardTone(card);

    return card;
  }

  function ensureRibbedTeeLaunchCard() {
    var drawer = getDrawer();
    var existing = getRibbedTeeLaunchCard();
    var acquisitionOffer;
    var rewardBar;

    if (existing || !drawer) {
      return existing;
    }

    existing = createRibbedTeeLaunchCard();
    acquisitionOffer = getAcquisitionOfferBlock();
    rewardBar = getRewardBar();

    if (acquisitionOffer && acquisitionOffer.parentNode) {
      acquisitionOffer.parentNode.insertBefore(existing, acquisitionOffer.nextSibling);
    } else if (rewardBar && rewardBar.parentNode) {
      rewardBar.parentNode.insertBefore(existing, rewardBar.nextSibling);
    } else {
      drawer.appendChild(existing);
    }

    return existing;
  }

  function stopRibbedTeeLaunchCountdownTimer() {
    if (state.ribbedTeeLaunchCountdownTimer) {
      window.clearTimeout(state.ribbedTeeLaunchCountdownTimer);
    }

    state.ribbedTeeLaunchCountdownTimer = null;
  }

  function updateRibbedTeeLaunchCountdown(card, visible) {
    var countdownNode = card ? card.querySelector(selectors.ribbedTeeLaunchCountdown) : null;
    var remainingSeconds;

    stopRibbedTeeLaunchCountdownTimer();

    if (!countdownNode || !visible) {
      return;
    }

    if (!state.ribbedTeeLaunchCountdownEndsAt) {
      state.ribbedTeeLaunchCountdownEndsAt = Date.now() + (10 * 60 * 1000);
    }

    remainingSeconds = Math.floor((state.ribbedTeeLaunchCountdownEndsAt - Date.now()) / 1000);

    if (remainingSeconds <= 0) {
      countdownNode.textContent = 'Launch offer active';
      return;
    }

    countdownNode.textContent = 'ENDS IN ' + formatCountdownSeconds(remainingSeconds);
    state.ribbedTeeLaunchCountdownTimer = window.setTimeout(function () {
      updateRibbedTeeLaunchCountdown(card, !card.hidden);
    }, 1000);
  }

  function renderRibbedTeeLaunchCard(cart) {
    var active = isRibbedTeeLaunchContextActive();
    var drawer = getDrawer();
    var card = active ? ensureRibbedTeeLaunchCard() : getRibbedTeeLaunchCard();
    var copy;

    if (drawer) {
      if (active) {
        drawer.setAttribute('data-atoz-ribbed-tee-launch-context', 'true');
      } else {
        drawer.removeAttribute('data-atoz-ribbed-tee-launch-context');
      }
    }

    if (!card) {
      return {
        ok: true,
        visible: false,
        skipped: true
      };
    }

    card.hidden = !active;
    card.setAttribute('aria-hidden', active ? 'false' : 'true');

    if (!active) {
      updateRibbedTeeLaunchCountdown(card, false);
      return {
        ok: true,
        visible: false
      };
    }

    copy = getRibbedTeeLaunchCopy(getRibbedTeeQuantity(cart));
    setNodeText(card.querySelector(selectors.ribbedTeeLaunchHeading), copy.heading);
    setNodeText(card.querySelector(selectors.ribbedTeeLaunchSupport), copy.support);
    updateRibbedTeeLaunchCountdown(card, true);

    return {
      ok: true,
      visible: true,
      quantity: getRibbedTeeQuantity(cart)
    };
  }

  function updateAcquisitionCountdown(block, visible, config) {
    var ribbonNode = block ? block.querySelector(selectors.acquisitionOfferRibbon) : null;
    var countdownNode = block ? block.querySelector(selectors.acquisitionOfferCountdown) : null;
    var labels = config && config.labels ? config.labels : {};
    var remainingSeconds;
    var countdownText;

    setNodeText(ribbonNode, labels.ribbon || 'FIRST ORDER EXCLUSIVE');

    stopAcquisitionCountdownTimer();

    if (!countdownNode || !visible) {
      return;
    }

    if (!state.acquisitionCountdownEndsAt) {
      state.acquisitionCountdownEndsAt = Date.now() + (15 * 60 * 1000);
    }

    remainingSeconds = Math.floor((state.acquisitionCountdownEndsAt - Date.now()) / 1000);

    if (remainingSeconds <= 0) {
      countdownNode.textContent = 'Perks active';
      return;
    }

    countdownText = formatCountdownSeconds(remainingSeconds);
    countdownNode.textContent = isMobileViewport() ? countdownText : 'ENDS IN ' + countdownText;
    state.acquisitionCountdownTimer = window.setTimeout(function () {
      updateAcquisitionCountdown(block, !block.hidden, config);
    }, 1000);
  }

  function isAcquisitionRuntimePaused(config) {
    if (isRotationPageContext()) {
      return true;
    }

    return !isCurrentAcquisitionEligiblePage(config);
  }

  function activateSummerAcquisitionOfferBridge(cart, config) {
    var cartState;

    if (
      !isSummerAcquisitionPageContext() ||
      !config ||
      config.campaignValue !== 'first_order_perks' ||
      isAcquisitionOfferActivated(config)
    ) {
      return false;
    }

    cartState = getAcquisitionCartState(cart, config);

    if (!cartState.hasEligiblePerfume) {
      return false;
    }

    setAcquisitionSessionFlag(config, 'armed', true);

    return activateAcquisitionOffer(config);
  }

  function renderAcquisitionOffer(cart, options) {
    var config = getAcquisitionConfig();
    var block = getAcquisitionOfferBlock();
    var labels = config && config.labels ? config.labels : {};
    var headingNode = block ? block.querySelector(selectors.acquisitionOfferHeading) : null;
    var discountLabel = block ? block.querySelector(selectors.acquisitionOfferDiscountLabel) : null;
    var discountDetail = block ? block.querySelector(selectors.acquisitionOfferDiscountDetail) : null;
    var shippingRow = block ? block.querySelector(selectors.acquisitionOfferShipping) : null;
    var shippingLabel = block ? block.querySelector(selectors.acquisitionOfferShippingLabel) : null;
    var shippingDetail = block ? block.querySelector(selectors.acquisitionOfferShippingDetail) : null;
    var sampleRow = block ? block.querySelector(selectors.acquisitionOfferSample) : null;
    var sampleLabel = block ? block.querySelector(selectors.acquisitionOfferSampleLabel) : null;
    var sampleDetail = block ? block.querySelector(selectors.acquisitionOfferSampleDetail) : null;
    var disclaimerNode = block ? block.querySelector(selectors.acquisitionOfferDisclaimer) : null;
    var cartState;
    var shouldShow;
    var shouldShowShipping;
    var shouldShowSample;
    var benefits;

    if (!block) {
      return {
        ok: true,
        skipped: true
      };
    }

    if (!options?.readOnlyReview) activateSummerAcquisitionOfferBridge(cart, config);

    if (isAcquisitionRuntimePaused(config) || !config || !isAcquisitionSessionArmed(config) || !isAcquisitionOfferActivated(config)) {
      block.hidden = true;
      block.setAttribute('aria-hidden', 'true');
      updateAcquisitionCountdown(block, false, config);
      return {
        ok: true,
        visible: false
      };
    }

    cartState = getAcquisitionCartState(cart, config);
    shouldShow = Boolean(cartState.hasEligiblePerfume);
    shouldShowShipping = Boolean(shouldShow && config.showFreeShipping !== false);
    shouldShowSample = Boolean(shouldShow && config.showFreeSample !== false);

    block.hidden = !shouldShow;
    block.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

    setNodeText(headingNode, labels.heading);
    setNodeText(discountLabel, labels.orderDiscount);
    benefits = getAcquisitionBenefitStatus(cart, config);
    setNodeText(discountDetail, benefits.merchandiseConfirmed ? labels.orderDiscountDetail : benefits.higherPriority ? 'Higher offer applied' : 'Applying discount…');
    setNodeText(shippingLabel, labels.freeShipping);
    setNodeText(shippingDetail, benefits.shippingApplicable ? 'Eligibility confirmed; final shipping at checkout' :
      benefits.shippingSubmitted || benefits.higherPriority ? 'Confirmed at checkout' : 'Applying shipping offer…');
    setNodeText(sampleLabel, labels.freeSample);
    setNodeText(sampleDetail, benefits.sampleConfirmed ? labels.freeSampleDetail : 'Preparing sample…');
    setNodeText(disclaimerNode, labels.disclaimer);

    if (shippingRow) {
      shippingRow.hidden = !shouldShowShipping;
    }

    if (sampleRow) {
      sampleRow.hidden = !shouldShowSample;
    }

    updateAcquisitionCountdown(block, shouldShow, config);

    return {
      ok: true,
      visible: shouldShow,
      sampleVisible: shouldShowSample
    };
  }

  function giftHasRequiredDiscount(item, config) {
    var titles;

    if (!config || !config.requiredDiscountTitle) {
      return true;
    }

    titles = getDiscountTitles(item).map(normalizeTitle);

    return titles.indexOf(normalizeTitle(config.requiredDiscountTitle)) !== -1;
  }

  function isAcquisitionGiftQualified(item, config) {
    if (!item || !config) {
      return false;
    }

    if (!config.strictFreeValidation) {
      return true;
    }

    return Boolean(isZeroPriceLine(item) || giftHasRequiredDiscount(item, config));
  }

  function normalizeSampleToPackValue(value) {
    var normalized = normalizeText(value).toLowerCase();

    if (normalized === 'pure 2ml' || normalized === 'pure_2ml') {
      return 'pure_2ml';
    }

    if (normalized === 'royal 2ml' || normalized === 'royal_2ml') {
      return 'royal_2ml';
    }

    if (normalized === 'assorted 2ml' || normalized === 'assorted_2ml') {
      return 'assorted_2ml';
    }

    return normalized;
  }

  function getAcquisitionGiftSampleToPack(item) {
    return normalizeSampleToPackValue(
      getLineProperty(item, '_atoz_sample_to_pack') ||
      getLineProperty(item, 'Sample to pack')
    );
  }

  function getCartAttributes(cart) {
    return cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
  }

  function getCartAttribute(cart, key) {
    var attributes = getCartAttributes(cart);

    return Object.prototype.hasOwnProperty.call(attributes, key) ? normalizeText(attributes[key]) : '';
  }

  function hasAcquisitionOfferAttributes(cart) {
    return Boolean(
      getCartAttribute(cart, 'ATOZ Offer') ||
      getCartAttribute(cart, 'ATOZ Free Sample') ||
      getCartAttribute(cart, 'ATOZ Gift Source') ||
      getCartAttribute(cart, 'ATOZ Sample To Pack')
    );
  }

  function getAcquisitionAttributePayload(sampleToPack, config) {
    return {
      'ATOZ Offer': sampleToPack ? getAcquisitionOfferToken(config) : '',
      'ATOZ Free Sample': sampleToPack ? 'yes' : '',
      'ATOZ Gift Source': sampleToPack ? 'acquisition' : '',
      'ATOZ Sample To Pack': sampleToPack || ''
    };
  }

  function acquisitionAttributesMatch(cart, attributes) {
    return Object.keys(attributes).every(function (key) {
      return getCartAttribute(cart, key) === normalizeText(attributes[key]);
    });
  }

  function updateAcquisitionOfferAttributes(attributes, action) {
    return postJson('/cart/update.js', {
      attributes: attributes
    }).then(function (updateResult) {
      return Object.assign({}, updateResult, {
        action: action
      });
    });
  }

  function removeAcquisitionGiftLines(giftItems) {
    var sequence = Promise.resolve({
      ok: true,
      removed: 0
    });

    giftItems.forEach(function (item) {
      sequence = sequence.then(function (result) {
        if (!result.ok) return result;
        var lineKey = item && item.key ? String(item.key) : '';

        if (!lineKey) {
          return result;
        }

        return postJson('/cart/change.js', {
          id: lineKey,
          quantity: 0
        }).then(function (changeResult) {
          return Object.assign({}, result, {
            ok: Boolean(result.ok && changeResult.ok),
            removed: result.removed + (changeResult.ok ? 1 : 0),
            data: changeResult.data || result.data,
            last: changeResult
          });
        });
      });
    });

    return sequence;
  }

  function addAcquisitionGift(config, sampleToPack) {
    var giftVariantId = config && config.giftVariantIds && config.giftVariantIds.length
      ? config.giftVariantIds[0]
      : '';
    var offerToken = getAcquisitionOfferToken(config);

    if (!giftVariantId) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        code: 'missing_gift_variant'
      });
    }

    return postJson('/cart/add.js', {
      items: [
        {
          id: giftVariantId,
          quantity: 1,
          properties: {
            _atoz_gwp: 'acquisition',
            _atoz_gift_reward: 'v2',
            _atoz_offer: offerToken,
            _atoz_auto_added: 'true',
            _atoz_sample_to_pack: sampleToPack
          }
        }
      ]
    });
  }

  function applyAcquisitionDiscountCodes(config, cart) {
    if (!config || !config.discountCodes) {
      return Promise.resolve({
        ok: true,
        skipped: true
      });
    }

    return reconcileDiscountPriority(cart, config);
  }

  function fetchApplyAndRenderAcquisitionOffer(source) {
    return getCart().then(function (cartResult) {
      if (cartResult.ok) {
        applyCartState(cartResult.cart);
        renderAcquisitionOffer(cartResult.cart);
      }

      return Object.assign({}, cartResult, {
        source: source
      });
    });
  }

  function getCartFromCartMutationResult(result) {
    var data = result && result.ok && result.data && typeof result.data === 'object'
      ? result.data
      : null;

    return data && Array.isArray(data.items) && typeof data.item_count === 'number' ? data : null;
  }

  function renderAcquisitionSyncResult(result, source) {
    var cart = result && result.renderCart ? result.renderCart : null;

    if (!cart && result && result.initialCart && !result.needsFreshCart) {
      cart = result.initialCart;
    }

    if (cart) {
      applyCartState(cart);
      renderAcquisitionOffer(cart);

      return Promise.resolve(Object.assign({}, result, {
        ok: result.ok === true,
        cart: cart,
        rendered: true,
        source: source
      }));
    }

    return fetchApplyAndRenderAcquisitionOffer(source).then(function (cartResult) {
      return Object.assign({}, cartResult, {
        offer: result
      });
    });
  }

  function reconcileAcquisitionCartLineGift(cart, config) {
    var cartState = getAcquisitionCartState(cart, config);
    var shouldHaveGift = Boolean(
      isAcquisitionSessionArmed(config) &&
      isAcquisitionOfferActivated(config) &&
      cartState.hasEligiblePerfume
    );
    var firstGift = cartState.giftItems[0] || null;
    var needsGiftReset = Boolean(
      firstGift &&
      (
        cartState.giftItems.length > 1 ||
        !isAcquisitionGiftForActiveOffer(firstGift, config) ||
        getLineProperty(firstGift, 'Sample to pack') ||
        getAcquisitionGiftSampleToPack(firstGift) !== cartState.sampleToPack
      )
    );

    if (isAcquisitionRuntimePaused(config)) {
      if (!cartState.giftItems.length) {
        return Promise.resolve({
          ok: true,
          skipped: true,
          action: 'paused',
          offerEligible: false
        });
      }

      return removeAcquisitionGiftLines(cartState.giftItems).then(function (removeResult) {
        return Object.assign({}, removeResult, {
          action: 'remove_paused',
          offerEligible: false
        });
      });
    }

    if (!shouldHaveGift) {
      if (!cartState.giftItems.length || config.autoRemoveIneligible === false) {
        return Promise.resolve({
          ok: true,
          skipped: true,
          action: 'none',
          offerEligible: false
        });
      }

      return removeAcquisitionGiftLines(cartState.giftItems).then(function (removeResult) {
        return Object.assign({}, removeResult, {
          action: 'remove_ineligible',
          offerEligible: false
        });
      });
    }

    if (needsGiftReset) {
      return removeAcquisitionGiftLines(cartState.giftItems)
        .then(function (removeResult) {
          if (!removeResult.ok) return Object.assign({}, removeResult, { action: 'replace_failed', offerEligible: false });
          return addAcquisitionGift(config, cartState.sampleToPack);
        })
        .then(function (addResult) {
          return Object.assign({}, addResult, {
            action: addResult.ok ? 'replace' : 'replace_failed',
            offerEligible: addResult.ok === true
          });
        });
    }

    if (firstGift) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        action: 'already_present',
        offerEligible: true
      });
    }

    return addAcquisitionGift(config, cartState.sampleToPack).then(function (addResult) {
      return Object.assign({}, addResult, {
        action: 'add',
        offerEligible: true
      });
    });
  }

  function reconcileOpsManagedAcquisitionOffer(cart, config) {
    var cartState = getAcquisitionCartState(cart, config);
    var shouldHaveAttributes = Boolean(
      isAcquisitionSessionArmed(config) &&
      isAcquisitionOfferActivated(config) &&
      cartState.hasEligiblePerfume
    );
    var targetAttributes = getAcquisitionAttributePayload(shouldHaveAttributes ? cartState.sampleToPack : '', config);
    var attributesCurrent = acquisitionAttributesMatch(cart, targetAttributes);
    var cleanup = cartState.giftItems.length
      ? removeAcquisitionGiftLines(cartState.giftItems)
      : Promise.resolve({
        ok: true,
        skipped: true,
        removed: 0,
        action: 'no_controlled_lines'
      });

    return cleanup.then(function (cleanupResult) {
      var cartAfterCleanup = getCartFromCartMutationResult(cleanupResult) || cart;
      if (!cleanupResult.ok) return Object.assign({}, cleanupResult, { action: 'cleanup_failed', offerEligible: false });

      if (attributesCurrent && !cartState.giftItems.length) {
        return {
          ok: true,
          skipped: true,
          action: shouldHaveAttributes ? 'attributes_current' : 'attributes_clear_current',
          offerEligible: shouldHaveAttributes,
          cleanup: cleanupResult
        };
      }

      return updateAcquisitionOfferAttributes(
        targetAttributes,
        shouldHaveAttributes ? 'attributes_set' : 'attributes_cleared'
      ).then(function (attributeResult) {
        var attributeCart = getCartFromCartMutationResult(attributeResult);

        return Object.assign({}, attributeResult, {
          ok: Boolean(cleanupResult.ok && attributeResult.ok),
          offerEligible: shouldHaveAttributes,
          cleanup: cleanupResult,
          data: attributeCart || cartAfterCleanup || attributeResult.data
        });
      });
    });
  }

  function reconcileAcquisitionGift(cart, config) {
    if (config && config.fulfillmentMode === 'cart_line') {
      return reconcileAcquisitionCartLineGift(cart, config);
    }

    return reconcileOpsManagedAcquisitionOffer(cart, config);
  }

  function runAcquisitionOfferSync(source) {
    var config = getAcquisitionConfig();
    var initialCart = state.acquisitionOfferSyncCart;

    state.acquisitionOfferSyncTimer = null;
    state.acquisitionOfferSyncCart = null;

    if (state.acquisitionOfferSyncInFlight) {
      if (initialCart) {
        state.acquisitionOfferSyncCart = initialCart;
      }

      if (source !== 'checkout') state.acquisitionOfferQueued = true;
      return state.acquisitionOfferSyncPromise || Promise.resolve({ ok: false, queued: true, source: source });
    }

    if (!config) {
      return fetchApplyAndRenderAcquisitionOffer(source);
    }

    state.acquisitionOfferSyncInFlight = true;
    state.acquisitionOfferQueued = false;

    var coordinator = window.TheManCartCoordinator;
    var reconcile = function (cart) {
      return (cart
      ? Promise.resolve({
        ok: true,
        status: 200,
        cart: cart
      })
      : getCart())
      .then(function (cartResult) {
        if (!cartResult.ok) {
          return cartResult;
        }

        return reconcileAcquisitionGift(cartResult.cart, config).then(function (giftResult) {
          var giftCart = getCartFromCartMutationResult(giftResult);
          var giftMutated = giftResult && !giftResult.skipped && giftResult.action !== 'none' && giftResult.action !== 'already_present';

          return {
            ok: Boolean(cartResult.ok && giftResult.ok),
            initialCart: cartResult.cart,
            renderCart: giftCart,
            needsFreshCart: Boolean(giftMutated && !giftCart),
            offerEligible: giftResult && giftResult.offerEligible === true,
            gift: giftResult
          };
        });
      })
      .then(function (result) {
        if (!result.ok || !isAcquisitionSessionArmed(config) || result.offerEligible !== true) {
          return result;
        }

        return applyAcquisitionDiscountCodes(config, result.renderCart || result.initialCart).then(function (discountResult) {
          var discountCart = getCartFromCartMutationResult(discountResult);

          return Object.assign({}, result, {
            ok: Boolean(result.ok && discountResult.ok),
            discount: discountResult,
            renderCart: discountCart || result.renderCart,
            needsFreshCart: Boolean(result.needsFreshCart && !discountCart)
          });
        });
      });
    };
    // The whole gift/attribute/discount decision runs under one lock. Render
    // afterward: rendering can schedule the legacy freebie's separate mutation.
    var operation = coordinator
      ? coordinator.mutate(function (before) {
        return reconcile(before).then(function (result) {
          return Object.assign({}, result, { cart: result.renderCart || result.initialCart || {} });
        });
      })
      : reconcile(initialCart);

    state.acquisitionOfferSyncPromise = operation
      .then(function (result) {
        if (coordinator && result.cart && Array.isArray(result.cart.items)) result.renderCart = result.cart;
        return renderAcquisitionSyncResult(result, source);
      })
      .catch(function (error) {
        debugLog('acquisition offer sync error', error && error.message);
        return structuredError('acquisition_offer_sync_error', error && error.uncertain ? 'Review your bag before trying again.' : messages.generic, error && error.message ? error.message : null);
      })
      .finally(function () {
        state.acquisitionOfferSyncInFlight = false;
        state.acquisitionOfferSyncPromise = null;

        if (state.acquisitionOfferQueued) {
          state.acquisitionOfferQueued = false;
          scheduleAcquisitionOfferSync(null, 'queued');
        }
      });
    return state.acquisitionOfferSyncPromise;
  }

  function scheduleAcquisitionOfferSync(cart, source) {
    var config = getAcquisitionConfig();
    var syncCart = cart || state.acquisitionOfferSyncCart;
    var cartState;
    var hasOfferAttributes;
    var shouldSync;

    if (!config) {
      return {
        ok: true,
        skipped: true,
        source: source
      };
    }

    if (isAcquisitionRuntimePaused(config)) {
      renderAcquisitionOffer(syncCart);
      return {
        ok: true,
        skipped: true,
        paused: true,
        source: source
      };
    }

    cartState = getAcquisitionCartState(syncCart, config);
    hasOfferAttributes = hasAcquisitionOfferAttributes(syncCart);
    shouldSync = Boolean(
      (
        isAcquisitionSessionArmed(config) &&
        isAcquisitionOfferActivated(config) &&
        cartState.hasPaidItems
      ) ||
      cartState.giftItems.length ||
      hasOfferAttributes
    );

    if (!shouldSync) {
      renderAcquisitionOffer(syncCart);
      return {
        ok: true,
        skipped: true,
        source: source
      };
    }

    if (state.acquisitionOfferSyncTimer) {
      window.clearTimeout(state.acquisitionOfferSyncTimer);
    }

    if (syncCart && typeof syncCart === 'object') {
      state.acquisitionOfferSyncCart = syncCart;
    }

    state.acquisitionOfferSyncTimer = window.setTimeout(function () {
      runAcquisitionOfferSync(source || 'scheduled');
    }, 120);

    return {
      ok: true,
      scheduled: true,
      source: source
    };
  }

  function activateAndScheduleAcquisitionOffer(cart, source) {
    var config = getAcquisitionConfig();
    var cartState;

    if (!config || !isAcquisitionSessionArmed(config)) {
      renderAcquisitionOffer(cart);
      return {
        ok: true,
        skipped: true
      };
    }

    cartState = getAcquisitionCartState(cart, config);

    if (!cartState.hasEligiblePerfume) {
      renderAcquisitionOffer(cart);
      return {
        ok: true,
        skipped: true
      };
    }

    activateAcquisitionOffer(config);
    renderAcquisitionOffer(cart);

    return scheduleAcquisitionOfferSync(cart, source);
  }

  function getUpsellSection() {
    var drawer = getDrawer();

    return drawer ? drawer.querySelector(selectors.upsells) : null;
  }

  function normalizeUpsellSourceMode(value) {
    var mode = normalizeText(value);

    if (mode === 'complementary_first' || mode === 'complementary_only') {
      return mode;
    }

    return 'collection_only';
  }

  function normalizeUpsellAnchorStrategy(value) {
    var strategy = normalizeText(value);

    if (strategy === 'first_paid' || strategy === 'highest_price') {
      return strategy;
    }

    return 'newest_paid';
  }

  function normalizeTaxonomyMap(value) {
    var normalized = {};

    if (!value || typeof value !== 'object') {
      return normalized;
    }

    Object.keys(value).forEach(function (productId) {
      var entry = value[productId];
      var normalizedId = normalizeText(productId);

      if (!normalizedId || !entry || typeof entry !== 'object') {
        return;
      }

      normalized[normalizedId] = {
        primary: normalizeText(entry.primary),
        secondary: normalizeText(entry.secondary),
        family: normalizeText(entry.family)
      };
    });

    return normalized;
  }

  function parseUpsellConfig() {
    var section = getUpsellSection();
    var configNode = section ? section.querySelector(selectors.upsellConfig) : null;
    var parsed;
    var maxCards;

    if (!configNode) {
      return null;
    }

    try {
      parsed = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      debugLog('parseUpsellConfig failed', error && error.message);
      return null;
    }

    maxCards = Math.max(1, Math.min(normalizeQuantity(parsed.maxCards, 4), 4));

    return {
      enabled: parsed.enabled === true,
      sourceMode: normalizeUpsellSourceMode(parsed.sourceMode),
      fallbackEnabled: parsed.fallbackEnabled !== false,
      recommendationLimit: Math.max(1, Math.min(normalizeQuantity(parsed.recommendationLimit, maxCards), 10)),
      anchorStrategy: normalizeUpsellAnchorStrategy(parsed.anchorStrategy),
      sectionId: normalizeText(parsed.sectionId) || 'atoz-cart-upsell-recommendations',
      maxCards: maxCards,
      autoScroll: parsed.autoScroll === true,
      autoScrollDelay: Math.max(normalizeQuantity(parsed.autoScrollDelay, 5000), 0),
      autoScrollInterval: Math.max(normalizeQuantity(parsed.autoScrollInterval, 6000), 0),
      heading: normalizeText(parsed.heading),
      subheading: normalizeText(parsed.subheading) || defaultUpsellSubheading,
      subheadingEnabled: parsed.subheadingEnabled !== false,
      dynamicSubheadingEnabled: parsed.dynamicSubheadingEnabled === true,
      categoryRankingEnabled: parsed.categoryRankingEnabled === true,
      taxonomyMap: normalizeTaxonomyMap(parsed.taxonomyMap),
      collectionHandle: normalizeText(parsed.collectionHandle),
      collectionId: normalizeText(parsed.collectionId)
    };
  }

  function getCartIdSet(cart, key) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var ids = {};

    items.forEach(function (item) {
      var id = item && item[key] ? String(item[key]) : '';

      if (id) {
        ids[id] = true;
      }
    });

    return ids;
  }

  function getUpsellTrack(section) {
    return section ? section.querySelector(selectors.upsellTrack) : null;
  }

  function captureUpsellFallback(section) {
    var track = getUpsellTrack(section);

    if (state.upsellFallbackCaptured || !track) {
      return;
    }

    state.upsellFallbackHtml = track.innerHTML || '';
    state.upsellFallbackCaptured = true;
    state.upsellCurrentSource = 'collection';
  }

  function setUpsellTrackHtml(section, html, source) {
    var track = getUpsellTrack(section);

    if (!track) {
      return false;
    }

    track.innerHTML = html || '';
    state.upsellCurrentSource = source || '';

    return true;
  }

  function restoreUpsellCollectionFallback(section) {
    captureUpsellFallback(section);

    return setUpsellTrackHtml(section, state.upsellFallbackHtml, 'collection');
  }

  function clearUpsellCards(section, source) {
    return setUpsellTrackHtml(section, '', source || 'empty');
  }

  function getCartItems(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : [];
  }

  function getLinePaidAmount(item) {
    var quantity = item && item.quantity ? normalizeQuantity(item.quantity, 1) : 1;
    var lineAmount = item && item.final_line_price;
    var unitAmount;

    if (typeof lineAmount !== 'number') {
      lineAmount = item && item.line_price;
    }

    if (typeof lineAmount === 'number') {
      return lineAmount;
    }

    unitAmount = item && item.final_price;

    if (typeof unitAmount !== 'number') {
      unitAmount = item && item.price;
    }

    return typeof unitAmount === 'number' ? unitAmount * Math.max(quantity, 1) : 0;
  }

  function getLineUnitPrice(item) {
    var quantity = item && item.quantity ? normalizeQuantity(item.quantity, 1) : 1;
    var unitAmount = item && item.final_price;

    if (typeof unitAmount === 'number') {
      return unitAmount;
    }

    if (item && typeof item.price === 'number') {
      return item.price;
    }

    return Math.round(getLinePaidAmount(item) / Math.max(quantity, 1));
  }

  function isPaidCartItem(item) {
    return Boolean(item && item.product_id && getLinePaidAmount(item) > 0);
  }

  function rememberRecentAddedProductId(productId) {
    var normalized = productId ? String(productId) : '';

    if (normalized) {
      state.recentAddedProductId = normalized;
    }
  }

  function rememberRecentAddedProductFromPayload(payload) {
    var items;
    var product;

    if (!payload || typeof payload !== 'object') {
      return;
    }

    items = Array.isArray(payload.items) ? payload.items : [];

    if (items.length) {
      product = items.slice().reverse().find(function (item) {
        return item && item.product_id;
      });
      rememberRecentAddedProductId(product && product.product_id);
      return;
    }

    rememberRecentAddedProductId(payload.product_id);
  }

  function cartHasPaidProduct(cart, productId) {
    var normalized = productId ? String(productId) : '';

    if (!normalized) {
      return false;
    }

    return getCartItems(cart).some(function (item) {
      return String(item && item.product_id) === normalized && isPaidCartItem(item);
    });
  }

  function selectUpsellAnchorProductId(cart, config) {
    var items = getCartItems(cart).filter(isPaidCartItem);
    var strategy = config && config.anchorStrategy ? config.anchorStrategy : 'newest_paid';
    var selected;

    if (!items.length) {
      return '';
    }

    if (strategy === 'first_paid') {
      return String(items[0].product_id);
    }

    if (strategy === 'highest_price') {
      selected = items.reduce(function (highest, item) {
        return !highest || getLineUnitPrice(item) > getLineUnitPrice(highest) ? item : highest;
      }, null);

      return selected && selected.product_id ? String(selected.product_id) : '';
    }

    if (cartHasPaidProduct(cart, state.recentAddedProductId)) {
      return state.recentAddedProductId;
    }

    selected = items[items.length - 1] || items[0];

    return selected && selected.product_id ? String(selected.product_id) : '';
  }

  function getUpsellProductTaxonomy(productId, config) {
    var normalized = normalizeText(productId);

    if (!normalized || !config || !config.taxonomyMap) {
      return null;
    }

    return config.taxonomyMap[normalized] || null;
  }

  function getAnchorScentPrimary(cart, config) {
    var anchorProductId = selectUpsellAnchorProductId(cart, config);
    var taxonomy = getUpsellProductTaxonomy(anchorProductId, config);

    return taxonomy ? normalizeText(taxonomy.primary) : '';
  }

  function updateUpsellSubheading(section, config, cart) {
    var node = section ? section.querySelector(selectors.upsellSubheading) : null;
    var anchorPrimary;
    var text;

    if (!node || !config || !config.subheadingEnabled) {
      return {
        ok: true,
        skipped: true
      };
    }

    text = config.subheading || defaultUpsellSubheading;

    if (config.dynamicSubheadingEnabled) {
      anchorPrimary = getAnchorScentPrimary(cart, config);
      text = upsellDynamicSubheadings[anchorPrimary] || defaultUpsellSubheading;
    }

    node.textContent = text;

    return {
      ok: true,
      text: text
    };
  }

  function getUpsellCardTaxonomyValue(card, key, config) {
    var datasetValue = '';
    var taxonomy;
    var productId;

    if (card && card.dataset) {
      if (key === 'primary') {
        datasetValue = normalizeText(card.dataset.scentUseCasePrimary);
      } else if (key === 'secondary') {
        datasetValue = normalizeText(card.dataset.scentUseCaseSecondary);
      } else if (key === 'family') {
        datasetValue = normalizeText(card.dataset.scentFamily);
      }
    }

    if (datasetValue) {
      return datasetValue;
    }

    productId = card && card.dataset ? normalizeText(card.dataset.productId) : '';
    taxonomy = getUpsellProductTaxonomy(productId, config);

    return taxonomy ? normalizeText(taxonomy[key]) : '';
  }

  function scoreUpsellCategory(card, anchorPrimary, config) {
    var targets = upsellCategoryTargets[anchorPrimary];
    var candidatePrimary;
    var candidateSecondary;
    var primaryIndex;
    var secondaryIndex;

    if (!targets || !targets.length) {
      return 0;
    }

    candidatePrimary = getUpsellCardTaxonomyValue(card, 'primary', config);
    candidateSecondary = getUpsellCardTaxonomyValue(card, 'secondary', config);
    primaryIndex = targets.indexOf(candidatePrimary);

    if (primaryIndex > -1) {
      return 100 - (primaryIndex * 10);
    }

    secondaryIndex = targets.indexOf(candidateSecondary);

    if (secondaryIndex > -1) {
      return 50 - (secondaryIndex * 10);
    }

    return 0;
  }

  function reorderUpsellCards(section, rankedCandidates, allCards) {
    var track = getUpsellTrack(section);
    var eligibleLookup = {};

    if (!track || !rankedCandidates.length) {
      return;
    }

    rankedCandidates.forEach(function (candidate) {
      eligibleLookup[candidate.index] = true;
      track.appendChild(candidate.card);
    });

    allCards.forEach(function (card, index) {
      if (!eligibleLookup[index]) {
        track.appendChild(card);
      }
    });
  }

  function buildUpsellRecommendationPath(productId, config) {
    var sectionId = config && config.sectionId ? config.sectionId : 'atoz-cart-upsell-recommendations';
    var limit = config && config.recommendationLimit ? config.recommendationLimit : 4;

    if (typeof URLSearchParams !== 'undefined') {
      var params = new URLSearchParams();
      params.set('product_id', productId);
      params.set('limit', String(limit));
      params.set('section_id', sectionId);
      params.set('intent', 'complementary');
      return 'recommendations/products?' + params.toString();
    }

    return 'recommendations/products?product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&section_id=' + encodeURIComponent(sectionId) +
      '&intent=complementary';
  }

  function extractUpsellCardsHtml(html) {
    var doc = parseHtml(html);
    var cards;

    if (!doc) {
      return {
        ok: false,
        code: 'parse_error',
        html: ''
      };
    }

    cards = Array.prototype.slice.call(doc.querySelectorAll(selectors.upsellCard));

    return {
      ok: true,
      count: cards.length,
      html: cards.map(function (card) {
        return card.outerHTML;
      }).join('')
    };
  }

  function fetchComplementaryUpsellCards(productId, config) {
    var cacheKey = [
      productId,
      config && config.recommendationLimit,
      config && config.sectionId
    ].join('|');
    var cached = state.upsellCache[cacheKey];

    if (cached) {
      return Promise.resolve(Object.assign({
        ok: true,
        cached: true
      }, cached));
    }

    return requestText(buildUpsellRecommendationPath(productId, config)).then(function (result) {
      var extracted;

      if (!result.ok) {
        return result;
      }

      extracted = extractUpsellCardsHtml(result.html);

      if (!extracted.ok) {
        return structuredError('recommendation_parse_error', messages.generic, extracted);
      }

      state.upsellCache[cacheKey] = extracted;

      return Object.assign({
        ok: true,
        cached: false,
        status: result.status
      }, extracted);
    });
  }

  function getUpsellVisibleCards(section) {
    return Array.prototype.slice.call(section ? section.querySelectorAll(selectors.upsellCard + ':not([hidden])') : []);
  }

  function resetUpsellButton(button) {
    if (!button) {
      return;
    }

    button.disabled = false;
    button.classList.remove('is-loading', 'is-added');
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
    button.textContent = button.dataset && button.dataset.defaultLabel ? button.dataset.defaultLabel : 'Add to rotation';
  }

  function resetUpsellCardState(card) {
    var button = card ? card.querySelector(selectors.upsellAdd) : null;

    if (card && card.classList) {
      card.classList.remove('is-loading', 'is-added');
    }

    resetUpsellButton(button);
  }

  function stopUpsellAutoScroll() {
    if (state.upsellAutoScrollTimer) {
      window.clearTimeout(state.upsellAutoScrollTimer);
    }

    state.upsellAutoScrollTimer = null;
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }

  function syncScrollableBodyPlacement() {
    var drawer = getDrawer();
    var rewardBar = getRewardBar();
    var acquisitionOffer = getAcquisitionOfferBlock();
    var ribbedTeeLaunchCard = getRibbedTeeLaunchCard();
    var rotationActive = isRotationContextActive();
    var ribbedTeeLaunchActive = isRibbedTeeLaunchContextActive();
    var body = drawer ? drawer.querySelector('.atoz-cart-drawer__body') : null;
    var anchor;

    if (!drawer || !body || !rewardBar || !acquisitionOffer) {
      return {
        ok: true,
        skipped: true
      };
    }

    drawer.setAttribute('data-atoz-body-scroll', 'true');
    drawer.removeAttribute('data-atoz-mobile-body-scroll');
    anchor = body.querySelector('.atoz-cart-drawer__cart-summary') || body.firstChild;

    if (rotationActive || ribbedTeeLaunchActive) {
      suppressRewardBar(rewardBar);
    } else {
      restoreRewardBar(rewardBar);
      body.insertBefore(rewardBar, anchor);
    }

    body.insertBefore(acquisitionOffer, anchor);
    if (ribbedTeeLaunchCard) {
      body.insertBefore(ribbedTeeLaunchCard, anchor);
    }

    return {
      ok: true
    };
  }

  function handleViewportChange() {
    var block = getAcquisitionOfferBlock();
    var config = getAcquisitionConfig();

    if (!isAtozEnabled()) {
      return;
    }

    syncScrollableBodyPlacement();
    updateAcquisitionCountdown(block, Boolean(block && !block.hidden), config);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getUpsellActiveIndex(section) {
    var viewport = section ? section.querySelector(selectors.upsellViewport) : null;
    var cards = getUpsellVisibleCards(section);
    var viewportCenter;
    var activeIndex = 0;
    var closestDistance = Number.POSITIVE_INFINITY;

    if (!viewport || !cards.length) {
      return 0;
    }

    viewportCenter = viewport.scrollLeft + (viewport.clientWidth / 2);
    cards.forEach(function (card, index) {
      var cardCenter = card.offsetLeft + (card.clientWidth / 2);
      var distance = Math.abs(cardCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function scrollUpsellTo(section, index, smooth) {
    var viewport = section ? section.querySelector(selectors.upsellViewport) : null;
    var cards = getUpsellVisibleCards(section);
    var card = cards[index];

    if (!viewport || !card) {
      return;
    }

    viewport.scrollTo({
      left: card.offsetLeft,
      behavior: smooth && !prefersReducedMotion() ? 'smooth' : 'auto'
    });
  }

  function updateUpsellControls(section) {
    var controls = section ? section.querySelector(selectors.upsellControls) : null;
    var dotsNode = section ? section.querySelector(selectors.upsellDots) : null;
    var prevButton = section ? section.querySelector(selectors.upsellPrev) : null;
    var nextButton = section ? section.querySelector(selectors.upsellNext) : null;
    var cards = getUpsellVisibleCards(section);
    var activeIndex = getUpsellActiveIndex(section);
    var hasOverflow = cards.length > 2;

    if (!section || !controls || !dotsNode) {
      return {
        ok: true,
        skipped: true
      };
    }

    controls.hidden = !hasOverflow;
    dotsNode.innerHTML = cards.map(function (_card, index) {
      return '<button type="button" class="atoz-upsell-carousel__dot' +
        (index === activeIndex ? ' is-active' : '') +
        '" data-atoz-upsell-dot data-index="' +
        index +
        '" aria-label="Show recommendation ' +
        (index + 1) +
        '" aria-current="' +
        (index === activeIndex ? 'true' : 'false') +
        '"></button>';
    }).join('');

    if (prevButton) {
      prevButton.disabled = activeIndex <= 0;
      prevButton.hidden = !hasOverflow || activeIndex <= 0;
      prevButton.setAttribute('aria-hidden', prevButton.hidden ? 'true' : 'false');
    }

    if (nextButton) {
      nextButton.disabled = activeIndex >= cards.length - 1;
      nextButton.hidden = !hasOverflow || activeIndex >= cards.length - 1;
      nextButton.setAttribute('aria-hidden', nextButton.hidden ? 'true' : 'false');
    }

    section.setAttribute('data-atoz-upsell-count', String(cards.length));
    section.setAttribute('data-atoz-upsell-active-index', String(activeIndex));

    return {
      ok: true,
      count: cards.length,
      activeIndex: activeIndex
    };
  }

  function scheduleUpsellAutoScroll(section, config) {
    var cards = getUpsellVisibleCards(section);

    stopUpsellAutoScroll();

    if (
      !section ||
      !config ||
      !config.autoScroll ||
      !isMobileViewport() ||
      prefersReducedMotion() ||
      state.upsellInteracted ||
      cards.length < 3
    ) {
      return;
    }

    state.upsellAutoScrollIndex = getUpsellActiveIndex(section);
    state.upsellAutoScrollPasses = 0;
    state.upsellAutoScrollTimer = window.setTimeout(function run() {
      var visibleCards = getUpsellVisibleCards(section);

      if (state.upsellInteracted || visibleCards.length < 3 || state.upsellAutoScrollPasses >= visibleCards.length - 1) {
        stopUpsellAutoScroll();
        return;
      }

      state.upsellAutoScrollIndex = Math.min(state.upsellAutoScrollIndex + 1, visibleCards.length - 1);
      state.upsellAutoScrollPasses += 1;
      scrollUpsellTo(section, state.upsellAutoScrollIndex, true);
      updateUpsellControls(section);

      state.upsellAutoScrollTimer = window.setTimeout(run, config.autoScrollInterval);
    }, config.autoScrollDelay);
  }

  function reconcileUpsellCards(section, config, cart) {
    var productIds = getCartIdSet(cart, 'product_id');
    var variantIds = getCartIdSet(cart, 'variant_id');
    var seenProducts = {};
    var seenVariants = {};
    var visibleCount = 0;
    var cards;
    var candidates = [];
    var candidateLookup = {};
    var visibleLookup = {};
    var anchorPrimary;
    var shouldRank;

    if (!section || !config || !config.enabled) {
      return {
        ok: true,
        skipped: true
      };
    }

    anchorPrimary = getAnchorScentPrimary(cart, config);
    shouldRank = Boolean(config.categoryRankingEnabled && upsellCategoryTargets[anchorPrimary]);
    updateUpsellSubheading(section, config, cart);

    cards = Array.prototype.slice.call(section.querySelectorAll(selectors.upsellCard));
    cards.forEach(function (card, index) {
      var productId = card.dataset ? normalizeText(card.dataset.productId) : '';
      var variantId = card.dataset ? normalizeText(card.dataset.variantId) : '';
      var available = card.dataset ? card.dataset.variantAvailable !== 'false' : true;
      var inCart = Boolean(productIds[productId] || variantIds[variantId]);
      var eligible = Boolean(
        available &&
        productId &&
        variantId &&
        !inCart &&
        !seenProducts[productId] &&
        !seenVariants[variantId]
      );

      if (eligible) {
        seenProducts[productId] = true;
        seenVariants[variantId] = true;
        candidateLookup[index] = true;
        candidates.push({
          card: card,
          index: index,
          inCart: inCart,
          score: shouldRank ? scoreUpsellCategory(card, anchorPrimary, config) : 0
        });
      }
    });

    if (shouldRank) {
      candidates.sort(function (a, b) {
        if (b.score !== a.score) {
          return b.score - a.score;
        }

        return a.index - b.index;
      });

      reorderUpsellCards(section, candidates, cards);
    }

    candidates.slice(0, config.maxCards).forEach(function (candidate) {
      visibleLookup[candidate.index] = true;
    });

    cards.forEach(function (card, index) {
      var productId = card.dataset ? normalizeText(card.dataset.productId) : '';
      var variantId = card.dataset ? normalizeText(card.dataset.variantId) : '';
      var inCart = Boolean(productIds[productId] || variantIds[variantId]);
      var eligible = Boolean(candidateLookup[index] && visibleLookup[index]);

      if (eligible) {
        visibleCount += 1;
      }

      card.hidden = !eligible;
      card.setAttribute('aria-hidden', eligible ? 'false' : 'true');

      if (!inCart) {
        resetUpsellCardState(card);
      }
    });

    section.hidden = visibleCount === 0;
    section.classList.toggle('is-empty', visibleCount === 0);

    updateUpsellControls(section);

    if (visibleCount > 0) {
      scrollUpsellTo(section, 0, false);
    }

    scheduleUpsellAutoScroll(section, config);

    return {
      ok: true,
      count: visibleCount,
      source: state.upsellCurrentSource
    };
  }

  function applyUpsellEmptyState(section, config, cart, source) {
    clearUpsellCards(section, source || 'empty');
    return reconcileUpsellCards(section, config, cart);
  }

  function applyUpsellFallback(section, config, cart, reason) {
    var result;

    if (config.sourceMode === 'complementary_first' && config.fallbackEnabled) {
      restoreUpsellCollectionFallback(section);
      result = reconcileUpsellCards(section, config, cart);
      result.fallback = true;
      result.reason = reason || '';
      return result;
    }

    result = applyUpsellEmptyState(section, config, cart, config.sourceMode);
    result.fallback = false;
    result.reason = reason || '';

    return result;
  }

  function applyComplementaryUpsells(section, config, cart, cardsHtml, requestSeq) {
    var result;

    if (requestSeq !== state.upsellRequestSeq) {
      return {
        ok: true,
        skipped: true,
        stale: true
      };
    }

    if (!cardsHtml || !String(cardsHtml).trim()) {
      return applyUpsellFallback(section, config, cart, 'empty_recommendations');
    }

    setUpsellTrackHtml(section, cardsHtml, 'complementary');
    result = reconcileUpsellCards(section, config, cart);

    if (!result.count) {
      return applyUpsellFallback(section, config, cart, 'filtered_recommendations');
    }

    return result;
  }

  function scheduleComplementaryUpsellFetch(section, config, cart, productId) {
    var requestSeq = state.upsellRequestSeq + 1;

    state.upsellRequestSeq = requestSeq;
    section.setAttribute('data-atoz-upsell-loading', 'true');

    fetchComplementaryUpsellCards(productId, config).then(function (result) {
      if (requestSeq !== state.upsellRequestSeq) {
        return {
          ok: true,
          skipped: true,
          stale: true
        };
      }

      if (!result.ok) {
        debugLog('complementary upsell fetch failed', result);
        return applyUpsellFallback(section, config, cart, result.code || 'fetch_failed');
      }

      return applyComplementaryUpsells(section, config, cart, result.html, requestSeq);
    }).catch(function (error) {
      if (requestSeq !== state.upsellRequestSeq) {
        return;
      }

      debugLog('complementary upsell fetch error', error && error.message);
      applyUpsellFallback(section, config, cart, 'fetch_error');
    }).finally(function () {
      if (requestSeq === state.upsellRequestSeq) {
        section.removeAttribute('data-atoz-upsell-loading');
      }
    });
  }

  function renderUpsells(cart) {
    var section = getUpsellSection();
    var config = parseUpsellConfig();
    var anchorProductId;
    var immediateResult;

    if (!section || !config || !config.enabled) {
      return {
        ok: true,
        skipped: true
      };
    }

    captureUpsellFallback(section);

    if (config.sourceMode === 'collection_only') {
      state.upsellRequestSeq += 1;

      if (state.upsellCurrentSource !== 'collection') {
        restoreUpsellCollectionFallback(section);
      }

      return reconcileUpsellCards(section, config, cart);
    }

    anchorProductId = selectUpsellAnchorProductId(cart, config);

    if (!anchorProductId) {
      return applyUpsellFallback(section, config, cart, 'missing_anchor');
    }

    if (config.sourceMode === 'complementary_first' && config.fallbackEnabled) {
      restoreUpsellCollectionFallback(section);
      immediateResult = reconcileUpsellCards(section, config, cart);
    } else {
      immediateResult = applyUpsellEmptyState(section, config, cart, 'complementary_pending');
    }

    scheduleComplementaryUpsellFetch(section, config, cart, anchorProductId);

    return Object.assign({}, immediateResult, {
      pending: true,
      anchorProductId: anchorProductId
    });
  }

  function getCartEmptyMessage() {
    if (
      window.theme &&
      window.theme.strings &&
      typeof window.theme.strings.cartEmpty === 'string' &&
      window.theme.strings.cartEmpty.trim()
    ) {
      return window.theme.strings.cartEmpty;
    }

    return 'Cart is empty.';
  }

  function getItemImage(item) {
    if (!item) {
      return '';
    }

    if (typeof item.image === 'string') {
      return item.image;
    }

    if (item.featured_image && typeof item.featured_image.url === 'string') {
      return item.featured_image.url;
    }

    return '';
  }

  function getVariantText(item) {
    var optionValues;

    if (!item) {
      return '';
    }

    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }

    if (Array.isArray(item.options_with_values)) {
      optionValues = item.options_with_values
        .map(function (option) {
          return option && option.value && option.value !== 'Default Title' ? option.value : '';
        })
        .filter(Boolean);

      return optionValues.join(' / ');
    }

    return '';
  }

  function getDiscountTitles(item) {
    if (!item || !Array.isArray(item.line_level_discount_allocations)) {
      return [];
    }

    return item.line_level_discount_allocations
      .map(function (allocation) {
        return allocation &&
          allocation.discount_application &&
          allocation.discount_application.title
          ? allocation.discount_application.title
          : '';
      })
      .filter(Boolean);
  }

  function isRotationDiscountTitle(title) {
    var normalized = normalizeTitle(title);

    return Boolean(
      normalized.indexOf('tmrotate') !== -1 ||
      normalized.indexOf('rotation') !== -1
    );
  }

  function shouldRenderLineDiscountTitle(title, suppressDefaultDiscounts) {
    return Boolean(title && (!suppressDefaultDiscounts || isRotationDiscountTitle(title)));
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value || '').replace(/["\\]/g, '\\$&');
  }

  function getRowByLineKey(lineKey) {
    var drawer = getDrawer();

    if (!drawer || !lineKey) {
      return null;
    }

    return drawer.querySelector(selectors.row + '[data-line-key="' + cssEscape(lineKey) + '"]') ||
      drawer.querySelector('.cart__item[data-key="' + cssEscape(lineKey) + '"]');
  }

  function normalizeError(payload, status, fallbackMessage) {
    var description = payload && typeof payload.description === 'string' ? payload.description : '';
    var message = payload && typeof payload.message === 'string' ? payload.message : '';
    var userMessage = description || message || fallbackMessage || messages.generic;
    var code = status === 422 ? 'unavailable' : 'cart_error';

    if (/no valid id or line parameter/i.test(userMessage)) {
      userMessage = messages.generic;
      code = 'missing_line';
    } else if (status === 422 && !description && !message) {
      userMessage = messages.unavailable;
    }

    return {
      ok: false,
      status: status || 0,
      code: code,
      message: userMessage,
      details: payload || null
    };
  }

  function requestJson(path, options) {
    var fetchOptions = Object.assign(
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      },
      options || {}
    );

    return fetch(buildRoute(path), fetchOptions)
      .then(function (response) {
        return response.text().then(function (text) {
          var payload = parseJson(text);

          if (!response.ok) {
            return normalizeError(payload, response.status);
          }

          return {
            ok: true,
            status: response.status,
            data: payload
          };
        });
      })
      .catch(function (error) {
        return {
          ok: false,
          status: 0,
          code: 'network_error',
          message: messages.network,
          details: error && error.message ? error.message : null
        };
      });
  }

  function requestText(path, options) {
    var fetchOptions = Object.assign(
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      },
      options || {}
    );

    return fetch(buildRoute(path), fetchOptions)
      .then(function (response) {
        return response.text().then(function (text) {
          if (!response.ok) {
            return structuredError('ajax_cart_error', messages.generic, {
              status: response.status,
              html: text
            });
          }

          return {
            ok: true,
            status: response.status,
            html: text
          };
        });
      })
      .catch(function (error) {
        return structuredError('network_error', messages.network, error && error.message ? error.message : null);
      });
  }

  function postJson(path, body) {
    return requestJson(path, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
  }

  function getDrawer() {
    return document.querySelector('#CartDrawer' + selectors.drawer) ||
      document.querySelector(selectors.drawer) ||
      document.querySelector('#CartDrawer.atoz-cart-drawer');
  }

  function isDrawerOpen(drawer) {
    return Boolean(drawer && drawer.classList && drawer.classList.contains('drawer--is-open'));
  }

  function syncDrawerOpenState() {
    var drawer = getDrawer();
    var isOpen = isDrawerOpen(drawer);

    if (!isAtozEnabled()) {
      return {
        ok: true,
        skipped: true,
        opened: false
      };
    }

    if (isOpen) {
      if (document.documentElement.getAttribute('data-atoz-cart-drawer-open') !== 'true') {
        document.documentElement.setAttribute('data-atoz-cart-drawer-open', 'true');
      }

      if (drawer) {
        if (drawer.getAttribute('aria-hidden') !== 'false') {
          drawer.setAttribute('aria-hidden', 'false');
        }
      }

      syncCartOnDrawerOpen();
    } else {
      if (document.documentElement.hasAttribute('data-atoz-cart-drawer-open')) {
        document.documentElement.removeAttribute('data-atoz-cart-drawer-open');
      }

      if (drawer) {
        if (drawer.getAttribute('aria-hidden') !== 'true') {
          drawer.setAttribute('aria-hidden', 'true');
        }
      }
    }

    return {
      ok: true,
      opened: isOpen
    };
  }

  function syncCartOnDrawerOpen() {
    var now = Date.now();

    if (
      state.drawerOpenCartSyncInFlight ||
      state.cartSyncing ||
      state.addSyncInFlight ||
      state.addSyncTimer ||
      now - state.lastDrawerOpenCartSyncAt < 750
    ) {
      return;
    }

    state.drawerOpenCartSyncInFlight = true;
    state.lastDrawerOpenCartSyncAt = now;

    getCart().then(function (cartResult) {
      if (cartResult.ok && isDrawerOpen(getDrawer())) {
        applyCartState(cartResult.cart);
      }
    }).catch(function (error) {
      debugLog('drawer open cart sync failed', error && error.message);
    }).finally(function () {
      state.drawerOpenCartSyncInFlight = false;
    });
  }

  function scheduleDrawerOpenStateSync() {
    syncDrawerOpenState();
    window.setTimeout(syncDrawerOpenState, 0);
    window.setTimeout(syncDrawerOpenState, 80);
    window.setTimeout(syncDrawerOpenState, 550);
  }

  function bindDrawerStateObserver() {
    var drawer = getDrawer();

    if (!isAtozEnabled() || !drawer || typeof MutationObserver !== 'function') {
      syncDrawerOpenState();
      return;
    }

    if (state.drawerStateObserverBound && state.drawerStateObserverTarget === drawer) {
      syncDrawerOpenState();
      return;
    }

    if (state.drawerStateObserver && typeof state.drawerStateObserver.disconnect === 'function') {
      state.drawerStateObserver.disconnect();
    }

    state.drawerStateObserverBound = true;
    state.drawerStateObserverTarget = drawer;
    state.drawerStateObserver = new MutationObserver(syncDrawerOpenState);
    state.drawerStateObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (!state.drawerStateEventsBound) {
      state.drawerStateEventsBound = true;
      document.addEventListener('drawerOpen.CartDrawer', scheduleDrawerOpenStateSync);
      document.addEventListener('cart:open', scheduleDrawerOpenStateSync);
      document.addEventListener('cart:close', scheduleDrawerOpenStateSync);
      window.addEventListener('keyup', function (event) {
        if (event && event.keyCode === 27) {
          scheduleDrawerOpenStateSync();
        }
      });
    }

    syncDrawerOpenState();
  }

  function getItemsTarget() {
    var drawer = getDrawer();

    if (!drawer) {
      return null;
    }

    return drawer.querySelector(selectors.itemsList) ||
      drawer.querySelector(selectors.items) ||
      drawer.querySelector('[data-products]');
  }

  function getAtozSubtotalTargets() {
    var drawer = getDrawer();

    if (!drawer) {
      return [];
    }

    return drawer.querySelectorAll('[data-subtotal]');
  }

  function normalizeSectionIds(sectionIds) {
    if (!Array.isArray(sectionIds)) {
      return [];
    }

    return sectionIds
      .map(function (id) {
        return typeof id === 'string' ? id.trim() : '';
      })
      .filter(function (id, index, ids) {
        return Boolean(id) && ids.indexOf(id) === index;
      });
  }

  function replaceElement(currentNode, nextNode) {
    if (!currentNode || !nextNode) {
      return false;
    }

    try {
      currentNode.replaceWith(nextNode.cloneNode(true));
      return true;
    } catch (error) {
      return false;
    }
  }

  function replaceInnerHtml(currentNode, nextNode) {
    if (!currentNode || !nextNode) {
      return false;
    }

    try {
      currentNode.innerHTML = nextNode.innerHTML;
      return true;
    } catch (error) {
      return false;
    }
  }

  function findFirst(root, selectorList) {
    var foundNode = null;

    selectorList.some(function (selector) {
      foundNode = root.querySelector(selector);
      return Boolean(foundNode);
    });

    return foundNode;
  }

  function replaceTargetsFromHtml(html, targetSelectors) {
    var parsedHtml = parseHtml(html);
    var replacements = [];
    var missingTargets = [];

    if (!parsedHtml) {
      return {
        ok: false,
        code: 'html_parse_error',
        message: 'Unable to parse refreshed cart HTML.',
        replacements: replacements,
        missingTargets: missingTargets
      };
    }

    targetSelectors.forEach(function (selector) {
      var currentNode = document.querySelector(selector);
      var nextNode = parsedHtml.querySelector(selector);

      if (!currentNode || !nextNode) {
        missingTargets.push(selector);
        return;
      }

      if (replaceElement(currentNode, nextNode)) {
        replacements.push(selector);
      }
    });

    if (replacements.indexOf(selectors.drawer) !== -1) {
      if (isRibbedTeeLaunchContextActive()) {
        suppressRewardBar(getRewardBar());
      }

      window.setTimeout(bindDrawerStateObserver, 0);
    }

    return {
      ok: true,
      replacements: replacements,
      missingTargets: missingTargets
    };
  }

  function updateCountTargets(count) {
    var countNodes = document.querySelectorAll(selectors.count + ', .cart-link__bubble-num');
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    var drawer = getDrawer();
    var normalizedCount = normalizeQuantity(count, null);

    if (normalizedCount === null) {
      return {
        ok: false,
        code: 'missing_cart_count',
        message: 'Cart count was not available.',
        updated: 0
      };
    }

    countNodes.forEach(function (node) {
      node.textContent = String(normalizedCount);

      if (node.matches(selectors.count)) {
        node.setAttribute('data-atoz-cart-count-value', String(normalizedCount));
      }
    });

    bubbles.forEach(function (bubble) {
      bubble.classList.toggle('cart-link__bubble--visible', normalizedCount > 0);
    });

    if (drawer) {
      drawer.classList.remove('is-empty');
      drawer.classList.toggle('atoz-cart-drawer--empty', normalizedCount === 0);
    }

    return {
      ok: true,
      count: normalizedCount,
      updated: countNodes.length
    };
  }

  function updateCartCount(cart) {
    debugLog('updateCartCount', cart && cart.item_count);
    return updateCountTargets(cart && cart.item_count);
  }

  function updateCartSubtotal(cart) {
    var subtotalNodes = getAtozSubtotalTargets();
    var subtotal = getCartSubtotal(cart);
    var formattedSubtotal = formatMoney(subtotal);

    subtotalNodes.forEach(function (node) {
      node.innerHTML = formattedSubtotal;
    });

    return {
      ok: true,
      subtotal: subtotal,
      updated: subtotalNodes.length
    };
  }

  function getCartDiscountAmount(cart) {
    var totalDiscount = normalizeCents(cart && cart.total_discount, 0);
    var originalTotal = normalizeCents(cart && cart.original_total_price, 0);
    var totalPrice = normalizeCents(cart && cart.total_price, 0);

    if (totalDiscount > 0) {
      return totalDiscount;
    }

    if (originalTotal > totalPrice) {
      return originalTotal - totalPrice;
    }

    return 0;
  }

  function getDiscountPercentLabelFromTitle(title) {
    var text = normalizeText(title);
    var percentMatch;

    if (!text) {
      return '';
    }

    percentMatch = text.match(/(\d+(?:\.\d+)?)\s*%/);

    if (percentMatch && percentMatch[1]) {
      return percentMatch[1].replace(/\.0$/, '') + '% OFF';
    }

    if (normalizeTitle(text).indexOf('firstorder10') !== -1) {
      return '10% OFF';
    }

    return '';
  }

  function getCartDiscountLabel(cart) {
    var applications = cart && Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var label = '';

    applications.some(function (application) {
      if (normalizeCents(application && application.total_allocated_amount, 0) <= 0) {
        return false;
      }

      label = getDiscountPercentLabelFromTitle(application && application.title);
      return Boolean(label);
    });

    if (label) {
      return 'Discounts (' + label + ')';
    }

    items.some(function (item) {
      if (!item || !Array.isArray(item.line_level_discount_allocations)) {
        return false;
      }

      return item.line_level_discount_allocations.some(function (allocation) {
        if (normalizeCents(allocation && allocation.amount, 0) <= 0) {
          return false;
        }

        label = getDiscountPercentLabelFromTitle(
          allocation &&
            allocation.discount_application &&
            allocation.discount_application.title
        );
        return Boolean(label);
      });
    });

    return label ? 'Discounts (' + label + ')' : 'Discounts';
  }

  function updateCartDiscounts(cart) {
    var discountsNode = getDrawer() ? getDrawer().querySelector('[data-discounts]') : null;
    var discountAmount = getCartDiscountAmount(cart);
    var discountLabel = getCartDiscountLabel(cart);
    var rotationActive = isRotationContextActive(cart);
    var rotationConfig;
    var rotationEligibleQuantity;
    var rotationDiscountCode;
    var rotationDiscountPercent;

    if (!discountsNode) {
      return {
        ok: true,
        skipped: true,
        updated: 0
      };
    }

    if (rotationActive) {
      rotationConfig = parseRotationRewardConfig();
      rotationEligibleQuantity = getRotationEligibleQuantity(cart, rotationConfig);
      rotationDiscountCode = getRotationDiscountCode(rotationEligibleQuantity, rotationConfig.discountCodes);
      rotationDiscountPercent = getRotationDiscountPercent(rotationEligibleQuantity);

      if (!rotationDiscountCode || !rotationDiscountPercent) {
        discountsNode.innerHTML = '';
        return {
          ok: true,
          updated: 1,
          rotation: true,
          eligibleQuantity: rotationEligibleQuantity
        };
      }

      discountsNode.innerHTML = [
        '<div class="cart__discounts cart__item-sub cart__item-row atoz-cart-drawer__rotation-discount" data-atoz-rotation-discount-preview>',
        '<div>',
        '<span class="atoz-cart-drawer__rotation-discount-label">',
        escapeHtml(rotationDiscountPercent) + ' rotation savings applies at checkout',
        '</span>',
        '<small class="atoz-cart-drawer__rotation-discount-note">',
        'Final rotation discount is applied on the next checkout step.',
        '</small>',
        '</div>',
        '<div class="text-right">',
        '<div class="cart__discount atoz-cart-drawer__rotation-discount-code">',
        escapeHtml(rotationDiscountCode),
        '</div>',
        '</div>',
        '</div>'
      ].join('');

      return {
        ok: true,
        updated: 1,
        rotation: true,
        eligibleQuantity: rotationEligibleQuantity,
        code: rotationDiscountCode
      };
    }

    if (!discountAmount) {
      discountsNode.innerHTML = '';
      return {
        ok: true,
        updated: 1
      };
    }

    discountsNode.innerHTML = [
      '<div class="cart__discounts cart__item-sub cart__item-row">',
      '<div>' + escapeHtml(discountLabel) + '</div>',
      '<div class="text-right">',
      '<div class="cart__discount">-' + formatMoney(discountAmount) + '</div>',
      '</div>',
      '</div>'
    ].join('');

    return {
      ok: true,
      updated: 1
    };
  }

  function createPendingRowId() {
    return 'pending-' + Date.now() + '-' + Math.round(Math.random() * 100000);
  }

  function getDatasetValue(element, names) {
    var current = element;
    var value = '';

    while (current && current !== document) {
      if (current.dataset) {
        names.some(function (name) {
          if (typeof current.dataset[name] === 'string' && current.dataset[name].trim()) {
            value = current.dataset[name].trim();
            return true;
          }

          return false;
        });
      }

      if (value) {
        return value;
      }

      current = current.parentElement;
    }

    return '';
  }

  function getTextFromFirst(root, selectorList) {
    var text = '';

    if (!root || !root.querySelector) {
      return '';
    }

    selectorList.some(function (selector) {
      var node = root.querySelector(selector);

      if (node && node.textContent && node.textContent.trim()) {
        text = node.textContent.trim();
        return true;
      }

      return false;
    });

    return text;
  }

  function getImageSourceFromFirst(root) {
    var image;

    if (!root || !root.querySelector) {
      return '';
    }

    image = root.querySelector('img[currentSrc], img[src], img[data-src]');

    if (!image) {
      return '';
    }

    return image.currentSrc || image.src || image.getAttribute('data-src') || '';
  }

  function getFormDataValue(formData, key) {
    var value;

    if (!formData || typeof formData.get !== 'function') {
      return '';
    }

    value = formData.get(key);

    return value === null || typeof value === 'undefined' ? '' : String(value);
  }

  function getSelectedVariantText(form) {
    var select;
    var selectedOption;

    if (!form || !form.querySelector) {
      return '';
    }

    select = form.querySelector('select[name="id"], [data-product-select]');

    if (!select || typeof select.selectedIndex !== 'number') {
      return '';
    }

    selectedOption = select.options && select.options[select.selectedIndex];

    if (!selectedOption || !selectedOption.textContent) {
      return '';
    }

    return selectedOption.textContent.trim().replace(/\s+-\s+[^-]+$/, '');
  }

  function normalizePendingAddContext(context) {
    var normalized = context && typeof context === 'object' ? context : {};
    var quantity = normalizeQuantity(normalized.quantity, 1);

    return {
      variantId: normalized.variantId ? String(normalized.variantId) : '',
      title: normalized.title ? String(normalized.title).trim() : '',
      variantText: normalized.variantText ? String(normalized.variantText).trim() : '',
      quantity: quantity > 0 ? quantity : 1,
      image: normalized.image ? String(normalized.image).trim() : '',
      url: normalized.url ? String(normalized.url).trim() : ''
    };
  }

  function getPendingSignature(context) {
    var normalized = normalizePendingAddContext(context);

    if (normalized.variantId) {
      return 'variant:' + normalized.variantId;
    }

    if (normalized.title || normalized.variantText) {
      return 'item:' + normalized.title + '|' + normalized.variantText;
    }

    return '';
  }

  function hasUsefulPendingContext(context) {
    var normalized = normalizePendingAddContext(context);

    return Boolean(normalized.title || normalized.variantText || normalized.image || normalized.url || normalized.quantity > 1);
  }

  function getPendingContextFromForm(form) {
    var formData;
    var root;
    var variantId = '';
    var quantity = 1;
    var title = '';
    var variantText = '';
    var image = '';
    var url = '';

    if (!form) {
      return null;
    }

    try {
      formData = new FormData(form);
      variantId = getFormDataValue(formData, 'id');
      quantity = normalizeQuantity(getFormDataValue(formData, 'quantity'), 1);
    } catch (error) {
      formData = null;
    }

    root = form.closest('[data-product-title], .product-single, .modal--quick-shop, .grid-product, .pdp-summer-rotation__card, [data-product-id]') || form;
    title = getDatasetValue(form, ['productTitle', 'productName']) ||
      getTextFromFirst(root, [
        '.product-single__title',
        '.grid-product__title',
        '.pdp-summer-rotation__title',
        '[data-product-title]'
      ]);
    variantText = getDatasetValue(form, ['productSize', 'variantTitle']) || getSelectedVariantText(form);
    image = getDatasetValue(form, ['productImage']) || getImageSourceFromFirst(root);
    url = getDatasetValue(form, ['productUrl']) || form.getAttribute('data-product-url') || '';

    return normalizePendingAddContext({
      variantId: variantId,
      title: title,
      variantText: variantText,
      quantity: quantity,
      image: image,
      url: url
    });
  }

  function getPendingContextsFromPayload(payload) {
    if (!payload || typeof payload !== 'object') {
      return [];
    }

    if (Array.isArray(payload.items)) {
      return payload.items.map(function (item) {
        return normalizePendingAddContext({
          variantId: item && (item.id || item.variant_id),
          title: item && (item.product_title || item.title),
          variantText: item ? getVariantText(item) : '',
          quantity: item && item.quantity,
          image: item ? getItemImage(item) : '',
          url: item && item.url
        });
      });
    }

    if (payload.id || payload.variant_id) {
      return [normalizePendingAddContext({
        variantId: payload.id || payload.variant_id,
        title: payload.product_title || payload.title,
        variantText: getVariantText(payload),
        quantity: payload.quantity,
        image: getItemImage(payload),
        url: payload.url
      })];
    }

    return [];
  }

  function getPendingContextsFromRequestBody(body) {
    var payload;
    var params;

    if (!body) {
      return [];
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return [normalizePendingAddContext({
        variantId: getFormDataValue(body, 'id'),
        quantity: getFormDataValue(body, 'quantity')
      })];
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return [normalizePendingAddContext({
        variantId: body.get('id'),
        quantity: body.get('quantity')
      })];
    }

    if (typeof body !== 'string') {
      return [];
    }

    try {
      payload = JSON.parse(body);
      return getPendingContextsFromPayload(payload);
    } catch (error) {
      payload = null;
    }

    try {
      params = new URLSearchParams(body);
      return [normalizePendingAddContext({
        variantId: params.get('id'),
        quantity: params.get('quantity')
      })];
    } catch (error) {
      return [];
    }
  }

  function getPendingContextsFromFetch(input, options) {
    if (options && options.body) {
      return getPendingContextsFromRequestBody(options.body);
    }

    if (input && input.body) {
      return getPendingContextsFromRequestBody(input.body);
    }

    return [];
  }

  function getPendingContextFromCartAddProduct(product) {
    if (!product || typeof product !== 'object') {
      return null;
    }

    return normalizePendingAddContext({
      variantId: product.variant_id || product.id,
      title: product.product_title || product.title,
      variantText: getVariantText(product),
      quantity: product.quantity,
      image: getItemImage(product),
      url: product.url
    });
  }

  function renderPendingRow(context, rowId) {
    var normalized = normalizePendingAddContext(context);
    var id = rowId || createPendingRowId();
    var signature = getPendingSignature(normalized);
    var title = normalized.title || 'Adding product...';
    var quantityText = normalized.quantity > 1 ? 'Qty: ' + normalized.quantity : 'Qty: 1';
    var imageContent = normalized.image
      ? '<img src="' + escapeHtml(normalized.image) + '" alt="' + escapeHtml(title) + '" loading="eager">'
      : '<span class="atoz-cart-line-item__image-placeholder" aria-hidden="true"></span>';
    var imageHtml = normalized.url
      ? '<a href="' + escapeHtml(normalized.url) + '" class="image-wrap">' + imageContent + '</a>'
      : '<div class="image-wrap">' + imageContent + '</div>';

    return [
      '<div class="cart__item atoz-cart-line-item atoz-cart-line-item--pending" data-atoz-pending-row data-atoz-pending-row-id="',
      escapeHtml(id),
      '" data-atoz-pending-signature="',
      escapeHtml(signature),
      '" aria-busy="true">',
      '<div class="cart__image atoz-cart-line-item__image">',
      imageHtml,
      '</div>',
      '<div class="cart__item-details atoz-cart-line-item__details">',
      '<div class="cart__item-title atoz-cart-line-item__title-group">',
      '<div class="cart__item-name atoz-cart-line-item__name">',
      escapeHtml(title),
      '</div>',
      normalized.variantText
        ? '<div class="cart__item--variants atoz-cart-line-item__variant">' + escapeHtml(normalized.variantText) + '</div>'
        : '',
      '</div>',
      '<div class="cart__item-sub atoz-cart-line-item__meta">',
      '<div class="atoz-cart-line-item__pending-quantity">',
      escapeHtml(quantityText),
      '</div>',
      '<div class="cart__item-price-col text-right atoz-cart-line-item__price">',
      '<span class="atoz-cart-line-item__pending-status">Adding...</span>',
      '</div>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');
  }

  function getPendingRowsContainer() {
    var itemsNode = getItemsTarget();

    if (!itemsNode) {
      return null;
    }

    return itemsNode.querySelector('.cart__items') || itemsNode;
  }

  function findPendingRow(signature) {
    var drawer = getDrawer();
    var rows;

    if (!drawer) {
      return null;
    }

    if (signature) {
      return drawer.querySelector(selectors.pendingRow + '[data-atoz-pending-signature="' + cssEscape(signature) + '"]');
    }

    rows = drawer.querySelectorAll(selectors.pendingRow);

    if (rows.length && Date.now() - state.lastPendingAddAt < pendingAddCoalesceDelay) {
      return rows[rows.length - 1];
    }

    return null;
  }

  function ensurePendingAddRow(context, source) {
    var container = getPendingRowsContainer();
    var normalized = normalizePendingAddContext(context);
    var signature = getPendingSignature(normalized);
    var existingRow = findPendingRow(signature);
    var rowId = existingRow && existingRow.dataset ? existingRow.dataset.atozPendingRowId : createPendingRowId();
    var emptyState;

    if (!container) {
      return {
        ok: false,
        code: 'missing_items_target',
        source: source
      };
    }

    state.lastPendingAddAt = Date.now();

    if (existingRow) {
      if (!hasUsefulPendingContext(normalized)) {
        return {
          ok: true,
          coalesced: true,
          source: source,
          signature: signature
        };
      }

      existingRow.outerHTML = renderPendingRow(normalized, rowId);
      return {
        ok: true,
        updated: true,
        source: source,
        signature: signature
      };
    }

    emptyState = container.querySelector('.atoz-cart-drawer__empty-state');

    if (emptyState) {
      emptyState.remove();
    }

    container.insertAdjacentHTML('afterbegin', renderPendingRow(normalized, rowId));

    return {
      ok: true,
      created: true,
      source: source,
      signature: signature
    };
  }

  function ensurePendingAddRows(contexts, source) {
    var normalizedContexts = Array.isArray(contexts) ? contexts : [contexts];
    var results;

    normalizedContexts = normalizedContexts.filter(function (context) {
      return context && typeof context === 'object';
    });

    if (!normalizedContexts.length) {
      normalizedContexts = [normalizePendingAddContext(null)];
    }

    results = normalizedContexts.map(function (context) {
      return ensurePendingAddRow(context, source);
    });

    return {
      ok: results.every(function (result) {
        return result.ok;
      }),
      source: source,
      rows: results
    };
  }

  function clearPendingAddRows() {
    var drawer = getDrawer();
    var rows = drawer ? drawer.querySelectorAll(selectors.pendingRow) : [];

    rows.forEach(function (row) {
      row.remove();
    });

    state.lastPendingAddAt = 0;

    return {
      ok: true,
      removed: rows.length
    };
  }

  function renderDiscountTitles(item, suppressDefaultDiscounts) {
    var titles = getDiscountTitles(item).filter(function (title) {
      return shouldRenderLineDiscountTitle(title, suppressDefaultDiscounts);
    });

    if (!titles.length) {
      return '';
    }

    return '<div class="atoz-cart-line-item__discount-title" data-atoz-line-discount-list>' +
      titles.map(function (title) {
        return '<span data-atoz-line-discount-title data-atoz-rotation-discount-title>' + escapeHtml(title) + '</span>';
      }).join('') +
      '</div>';
  }

  function renderPrice(item, suppressDefaultDiscounts) {
    var originalPrice = typeof item.original_price === 'number' ? item.original_price : 0;
    var finalPrice = typeof item.final_price === 'number' ? item.final_price : originalPrice;
    var hasDiscount = originalPrice > finalPrice;
    var discountAllocations = Array.isArray(item.line_level_discount_allocations)
      ? item.line_level_discount_allocations
      : [];
    var discountHtml = discountAllocations.map(function (allocation) {
      var title = allocation &&
        allocation.discount_application &&
        allocation.discount_application.title
        ? allocation.discount_application.title
        : '';

      if (!title) {
        return '';
      }

      if (!shouldRenderLineDiscountTitle(title, suppressDefaultDiscounts)) {
        return '';
      }

      return '<small class="cart__discount">' +
        escapeHtml(title) +
        ' (-' +
        formatMoney(allocation.amount || 0) +
        ')</small>';
    }).join('');

    if (!hasDiscount) {
      return '<span class="cart__price">' + formatMoney(finalPrice) + '</span>' + discountHtml;
    }

    return [
      '<span class="visually-hidden">Regular price</span>',
      '<small class="cart__price cart__price--strikethrough">',
      formatMoney(originalPrice),
      '</small>',
      '<span class="visually-hidden">Sale price</span>',
      '<span class="cart__price cart__discount">',
      formatMoney(finalPrice),
      '</span>',
      discountHtml
    ].join('');
  }

  function renderCartRow(item, suppressDefaultDiscounts) {
    var lineKey = item && item.key ? String(item.key) : '';
    var image = getItemImage(item);
    var url = item && item.url ? item.url : '#';
    var productTitle = item && item.product_title ? item.product_title : 'Product';
    var variantText = getVariantText(item);
    var quantity = normalizeQuantity(item && item.quantity, 1);
    var sharedSample = getItemVariantId(item) === '43326220763184';

    return [
      '<div class="cart__item atoz-cart-line-item" data-atoz-cart-row data-key="',
      escapeHtml(lineKey),
      '" data-line-key="',
      escapeHtml(lineKey),
      '">',
      '<div class="cart__image atoz-cart-line-item__image">',
      image
        ? sharedSample
          ? '<span class="image-wrap"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(productTitle) + '" loading="lazy"></span>'
          : '<a href="' + escapeHtml(url) + '" class="image-wrap"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(productTitle) + '" loading="lazy"></a>'
        : '',
      '</div>',
      '<div class="cart__item-details atoz-cart-line-item__details">',
      '<div class="cart__item-title atoz-cart-line-item__title-group">',
      sharedSample
        ? '<span class="cart__item-name atoz-cart-line-item__name">'
        : '<a href="' + escapeHtml(url) + '" class="cart__item-name atoz-cart-line-item__name">',
      escapeHtml(productTitle),
      sharedSample ? '</span>' : '</a>',
      variantText
        ? '<div class="cart__item--variants atoz-cart-line-item__variant">' + escapeHtml(variantText) + '</div>'
        : '',
      renderDiscountTitles(item, suppressDefaultDiscounts),
      '</div>',
      '<div class="cart__item-sub atoz-cart-line-item__meta">',
      '<div>',
      sharedSample
        ? '<div class="atoz-cart-line-item__quantity-static" aria-label="Quantity: ' + quantity + '">Qty ' + quantity + '</div>'
        : '<div class="js-qty__wrapper atoz-cart-line-item__quantity">',
      sharedSample ? '' : [
      '<label for="cart_updates_' + escapeHtml(lineKey) + '" class="hidden-label">Quantity</label>',
      '<input type="text" id="cart_updates_' + escapeHtml(lineKey) + '" name="updates[]" class="js-qty__num" value="' + quantity + '" min="0" pattern="[0-9]*" data-id="' + escapeHtml(lineKey) + '" data-atoz-cart-quantity data-atoz-cart-control>',
      '<button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce quantity" data-atoz-cart-quantity-minus data-atoz-cart-control>',
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>',
      '<span class="icon__fallback-text" aria-hidden="true">&minus;</span>',
      '</button>',
      '<button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase quantity" data-atoz-cart-quantity-plus data-atoz-cart-control>',
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>',
      '<span class="icon__fallback-text" aria-hidden="true">+</span>',
      '</button>',
      '</div>'
      ].join(''),
      '<div class="cart__remove">',
      '<a href="/cart/change?id=' + encodeURIComponent(lineKey) + '&quantity=0" class="text-link" aria-label="Remove ' + escapeHtml(productTitle) + '" data-atoz-cart-remove data-atoz-cart-control data-line-key="' + escapeHtml(lineKey) + '">',
      '<span class="cart__remove-label">Remove</span>',
      '<svg aria-hidden="true" focusable="false" role="presentation" class="atoz-cart-line-item__remove-icon" viewBox="0 0 24 24">',
      '<path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm1 6h2v9h-2V9Zm4 0h2v9h-2V9ZM6 9h2l1 12h6l1-12h2l-1.2 14H8.2L6 9Z"/>',
      '</svg>',
      '</a>',
      '</div>',
      '</div>',
      '<div class="cart__item-price-col text-right atoz-cart-line-item__price">',
      renderPrice(item, suppressDefaultDiscounts),
      '</div>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');
  }

  function renderCartRows(cart) {
    var itemsNode = getItemsTarget();
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var suppressDefaultDiscounts = isRotationContextActive(cart);

    if (!itemsNode) {
      debugLog('renderCartRows missing item target', cart);
      return {
        ok: false,
        code: 'missing_items_target',
        message: 'Cart item container was not found.'
      };
    }

    if (!items.length) {
      debugLog('renderCartRows empty');
      itemsNode.innerHTML = '<div class="atoz-cart-drawer__empty-state">' + escapeHtml(getCartEmptyMessage()) + '</div>';
      return {
        ok: true,
        rendered: 0,
        empty: true
      };
    }

    debugLog('renderCartRows', items.length);
    itemsNode.innerHTML = '<div class="cart__items atoz-cart-drawer__items" data-count="' +
      escapeHtml(cart.item_count) +
      '" data-cart-subtotal="' +
      escapeHtml(getCartSubtotal(cart)) +
      '">' +
      items.map(function (item) {
        return renderCartRow(item, suppressDefaultDiscounts);
      }).join('') +
      '</div>';

    return {
      ok: true,
      rendered: items.length,
      empty: false
    };
  }

  function applyCartState(cart, options) {
    var rowResult;
    var countResult;
    var subtotalResult;
    var discountsResult;
    var rewardResult;
    var upsellResult;
    var acquisitionResult;
    var ribbedTeeLaunchResult;
    var ok;

    if (!cart || typeof cart !== 'object') {
      debugLog('applyCartState missing cart');
      setCartSyncing(false);
      return {
        ok: false,
        code: 'missing_cart',
        message: 'Cart data was not available.'
      };
    }

    rowResult = renderCartRows(cart);
    countResult = updateCartCount(cart);
    subtotalResult = updateCartSubtotal(cart);
    discountsResult = updateCartDiscounts(cart);
    rewardResult = renderRewardBar(cart, options);
    acquisitionResult = renderAcquisitionOffer(cart, options);
    ribbedTeeLaunchResult = renderRibbedTeeLaunchCard(cart);
    syncScrollableBodyPlacement();
    upsellResult = renderUpsells(cart);
    ok = Boolean(rowResult.ok && countResult.ok && subtotalResult.ok && discountsResult.ok && rewardResult.ok && acquisitionResult.ok && ribbedTeeLaunchResult.ok && upsellResult.ok);

    if (!options?.readOnlyReview && !state.acquisitionOfferSyncInFlight) {
      acquisitionResult = Object.assign({}, acquisitionResult, {
        sync: scheduleAcquisitionOfferSync(cart, 'applyCartState')
      });
    }

    if (rowResult.ok) {
      clearPendingAddRows();
    }

    if (ok) {
      try {
        if (pendingAtozAdd()) showAtozAddRecovery();
        else if (pendingPaidDecrease()) showPaidDecreaseRecovery();
        else if (window.TheManCartCoordinator?.pending()) showError('An unfinished bag change needs review before another edit.');
        else clearError();
      }
      catch (_) { clearError(); }
    }

    setCartSyncing(false);
    if (!options?.readOnlyReview && Array.isArray(cart.items)) {
      document.dispatchEvent(new CustomEvent('tm:cart-state-updated', { detail: { cart: cart } }));
    }

    debugLog('applyCartState result', {
      itemCount: cart.item_count,
      rows: rowResult,
      count: countResult,
      subtotal: subtotalResult,
      discounts: discountsResult,
      reward: rewardResult,
      ribbedTeeLaunch: ribbedTeeLaunchResult,
      acquisition: acquisitionResult,
      upsells: upsellResult
    });

    return {
      ok: ok,
      cart: cart,
      rows: rowResult,
      count: countResult,
      subtotal: subtotalResult,
      discounts: discountsResult,
      reward: rewardResult,
      ribbedTeeLaunch: ribbedTeeLaunchResult,
      acquisition: acquisitionResult,
      upsells: upsellResult
    };
  }

  function setRowLoading(lineKey, isLoading) {
    var row = getRowByLineKey(lineKey);
    var controls;

    if (!row) {
      return {
        ok: false,
        code: 'missing_row',
        lineKey: lineKey
      };
    }

    row.classList.toggle('is-loading', Boolean(isLoading));
    row.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    controls = row.querySelectorAll('button, input, a');
    controls.forEach(function (control) {
      if ('disabled' in control) {
        control.disabled = Boolean(isLoading);
      }

      if (isLoading) {
        control.setAttribute('aria-disabled', 'true');
      } else {
        control.removeAttribute('aria-disabled');
      }
    });

    return {
      ok: true,
      lineKey: lineKey,
      loading: Boolean(isLoading)
    };
  }

  function removeRowOptimistically(lineKey) {
    var row = getRowByLineKey(lineKey);

    if (!row) {
      return {
        ok: false,
        code: 'missing_row',
        lineKey: lineKey
      };
    }

    row.remove();

    return {
      ok: true,
      lineKey: lineKey
    };
  }

  function applyAjaxCartHtml(html) {
    var parsedHtml = parseHtml(html);
    var replacements = [];
    var missingTargets = [];
    var cartItems;
    var cartCountResult = null;

    if (!parsedHtml) {
      return {
        ok: false,
        code: 'html_parse_error',
        message: 'Unable to parse ajax cart HTML.',
        replacements: replacements,
        missingTargets: missingTargets
      };
    }

    cartItems = findFirst(parsedHtml, [selectors.items, '.cart__items']);

    if (document.querySelector(selectors.items) && cartItems) {
      if (replaceInnerHtml(document.querySelector(selectors.items), cartItems)) {
        replacements.push(selectors.items);
      }
    } else {
      missingTargets.push(selectors.items);
    }

    if (document.querySelector(selectors.footer) && parsedHtml.querySelector(selectors.footer)) {
      if (replaceElement(document.querySelector(selectors.footer), parsedHtml.querySelector(selectors.footer))) {
        replacements.push(selectors.footer);
      }
    } else {
      missingTargets.push(selectors.footer);
    }

    if (cartItems && cartItems.dataset && typeof cartItems.dataset.count !== 'undefined') {
      cartCountResult = updateCountTargets(cartItems.dataset.count);

      if (cartCountResult.ok && cartCountResult.updated) {
        replacements.push(selectors.count);
      }
    } else {
      missingTargets.push(selectors.count);
    }

    return {
      ok: true,
      replacements: replacements,
      missingTargets: missingTargets,
      cartCount: cartCountResult
    };
  }

  function setLoading() {
    var drawer = getDrawer();
    var controls = document.querySelectorAll(selectors.loadingControl);

    state.loading = true;
    document.documentElement.setAttribute('data-atoz-cart-loading', 'true');

    if (drawer) {
      drawer.setAttribute('aria-busy', 'true');
    }

    controls.forEach(function (control) {
      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
    });

    return {
      ok: true,
      loading: state.loading
    };
  }

  function clearLoading() {
    var drawer = getDrawer();
    var controls = document.querySelectorAll(selectors.loadingControl);

    state.loading = false;
    document.documentElement.removeAttribute('data-atoz-cart-loading');

    if (drawer) {
      drawer.removeAttribute('aria-busy');
    }

    controls.forEach(function (control) {
      control.disabled = false;
      control.removeAttribute('aria-disabled');
    });

    return {
      ok: true,
      loading: state.loading
    };
  }

  function getCheckoutButtons() {
    var drawer = getDrawer();

    if (drawer) {
      return drawer.querySelectorAll(selectors.checkoutButton);
    }

    return document.querySelectorAll(selectors.checkoutButton);
  }

  function getCartItemCount(cart) {
    var count = normalizeQuantity(cart && cart.item_count, null);

    return count === null ? null : count;
  }

  function clearCheckoutLoading(cart) {
    var checkoutButtons = getCheckoutButtons();
    var itemCount = getCartItemCount(cart);

    checkoutButtons.forEach(function (button) {
      button.classList.remove('btn--loading', 'is-loading');
      button.removeAttribute('aria-busy');

      if (itemCount === null || itemCount > 0) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      } else if (button.hasAttribute('data-atoz-cart-control')) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });

    state.checkoutSubmitted = false;

    return {
      ok: true,
      updated: checkoutButtons.length,
      itemCount: itemCount
    };
  }

  function clearRowLoadingStates() {
    var drawer = getDrawer();
    var rows = drawer ? drawer.querySelectorAll(selectors.row + ', .atoz-cart-line-item.is-loading') : [];
    var cleared = 0;

    rows.forEach(function (row) {
      var controls;

      if (row.matches(selectors.pendingRow)) {
        return;
      }

      row.classList.remove('is-loading');
      row.removeAttribute('aria-busy');

      controls = row.querySelectorAll('button, input, a');
      controls.forEach(function (control) {
        if ('disabled' in control) {
          control.disabled = false;
        }

        control.removeAttribute('aria-disabled');
      });

      cleared += 1;
    });

    return {
      ok: true,
      cleared: cleared
    };
  }

  function clearQuantityQueues() {
    Object.keys(state.quantityQueue).forEach(function (lineKey) {
      clearQuantityQueue(lineKey);
    });

    return {
      ok: true,
      cleared: true
    };
  }

  function clearAddSyncState() {
    if (state.addSyncTimer) {
      window.clearTimeout(state.addSyncTimer);
    }

    state.addSyncTimer = null;
    state.addSyncInFlight = false;
    state.addSyncQueued = false;
    state.addSyncCart = null;

    return {
      ok: true
    };
  }

  function clearAllLoadingStates(cart) {
    state.pending = false;
    state.loading = false;

    clearAddSyncState();
    clearQuantityQueues();
    clearPendingAddRows();
    setCartSyncing(false);
    clearLoading();

    return {
      ok: true,
      checkout: clearCheckoutLoading(cart),
      rows: clearRowLoadingStates()
    };
  }

  function setCartSyncing(isSyncing) {
    var drawer = getDrawer();

    state.cartSyncing = Boolean(isSyncing);

    if (drawer) {
      drawer.toggleAttribute('data-atoz-cart-syncing', state.cartSyncing);
      drawer.setAttribute('aria-busy', state.cartSyncing ? 'true' : 'false');
    }

    return {
      ok: true,
      syncing: state.cartSyncing
    };
  }

  function clearError() {
    var errorNode = document.querySelector(selectors.error);

    if (errorNode) {
      errorNode.textContent = '';
      errorNode.hidden = true;
    }

    return {
      ok: true,
      cleared: Boolean(errorNode)
    };
  }

  function showError(message) {
    var errorNode = document.querySelector(selectors.error);
    var normalizedMessage = typeof message === 'string' && message.trim() ? message.trim() : messages.generic;

    if (errorNode) {
      errorNode.textContent = normalizedMessage;
      errorNode.hidden = false;
    }

    return {
      ok: true,
      displayed: Boolean(errorNode),
      message: normalizedMessage
    };
  }

  function pendingAtozAdd() {
    var operation = window.TheManCartCoordinator && window.TheManCartCoordinator.pending();
    return operation && operation.kind === 'atoz-add' ? operation : null;
  }

  function cartReviewIdentity(cart) {
    return JSON.stringify([cart.token, cart.currency, cart.items]);
  }

  function showAtozAddRecovery() {
    var operation = pendingAtozAdd();
    if (!operation) return;
    showError('Review your bag before adding again. Nothing will be sent automatically.');
    var errorNode = document.querySelector(selectors.error);
    if (!errorNode) return;
    var check = document.createElement('button');
    check.type = 'button'; check.textContent = 'Check bag';
    check.addEventListener('click', reviewPendingAtozAdd);
    errorNode.append(' ', check);
    if (state.atozAddReviewSnapshot && state.atozAddReviewSnapshot.operationId === operation.operationId) {
      var list = document.createElement('ul');
      state.atozAddReviewSnapshot.items.forEach(function (item) {
        var row = document.createElement('li');
        row.textContent = (item.product_title || item.title || 'Item') + ' ×' + item.quantity;
        list.append(row);
      });
      var confirm = document.createElement('button');
      confirm.type = 'button'; confirm.textContent = 'I reviewed this bag; enable adding';
      confirm.addEventListener('click', resolveReviewedAtozAdd);
      errorNode.append(list, confirm);
    }
  }

  function reviewPendingAtozAdd() {
    var operation = pendingAtozAdd();
    if (!operation) return Promise.resolve({ ok: false, code: 'NO_PENDING_ADD' });
    state.atozAddReviewSnapshot = null;
    return getCart().then(function (result) {
      if (!result.ok || !Array.isArray(result.cart && result.cart.items) || pendingAtozAdd()?.operationId !== operation.operationId) throw new Error('CART_REVIEW_UNAVAILABLE');
      state.atozAddReviewSnapshot = { operationId: operation.operationId, identity: cartReviewIdentity(result.cart), items: result.cart.items };
      showAtozAddRecovery();
      return { ok: true, cart: result.cart };
    }).catch(function () { showError('Could not check your bag. Try again before adding.'); return { ok: false, code: 'CART_REVIEW_UNAVAILABLE' }; });
  }

  function resolveReviewedAtozAdd() {
    var coordinator = window.TheManCartCoordinator;
    var snapshot = state.atozAddReviewSnapshot;
    if (!coordinator || !snapshot) return Promise.resolve({ ok: false, code: 'REVIEW_REQUIRED' });
    return coordinator.run(async function () {
      var operation = pendingAtozAdd();
      var result = await getCart();
      if (!operation || operation.operationId !== snapshot.operationId || !result.ok || cartReviewIdentity(result.cart) !== snapshot.identity)
        throw new Error('BAG_CHANGED_REVIEW_AGAIN');
      coordinator.clear(operation.operationId);
      return result;
    }, { recovery: true }).then(function (result) {
      state.atozAddReviewSnapshot = null;
      clearError();
      var applied = applyCartState(result.cart);
      var config = applied && applied.ok ? getAcquisitionConfig() : null;
      if (applied && applied.ok && config && !isAcquisitionRuntimePaused(config)) {
        activateAndScheduleAcquisitionOffer(result.cart, 'ATOZCart.reviewedAdd');
      }
      return result;
    }).catch(function () {
      state.atozAddReviewSnapshot = null; showAtozAddRecovery();
      return { ok: false, code: 'BAG_CHANGED_REVIEW_AGAIN' };
    });
  }

  function pendingPaidDecrease() {
    var operation = window.TheManCartCoordinator && window.TheManCartCoordinator.pending();
    return operation && operation.kind === 'paid-decrease' ? operation : null;
  }

  function hashPaidDecreaseReview(value) {
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (bytes) {
      return Array.from(new Uint8Array(bytes), function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    });
  }

  function showPaidDecreaseRecovery(message) {
    var operation = pendingPaidDecrease();
    if (!operation) return;
    if (operation.version !== 2 || operation.campaignId !== 'THEMAN-002-1010' ||
        operation.revision !== '2026-10-08.4-mixed-32') {
      showError('An unfinished bag change could not be identified. Please contact us before another edit.');
      return;
    }
    showError(message || 'A previous cart request may finish later. Check your bag before another edit. Nothing will be sent automatically.');
    var errorNode = document.querySelector(selectors.error);
    if (!errorNode) return;
    var check = document.createElement('button');
    check.type = 'button'; check.textContent = 'Check bag';
    check.addEventListener('click', reviewPendingPaidDecrease);
    errorNode.append(' ', check);
    var snapshot = state.paidDecreaseReviewSnapshot;
    if (snapshot && snapshot.operationId === operation.operationId) {
      var list = document.createElement('ul');
      snapshot.items.forEach(function (item) {
        var row = document.createElement('li');
        row.textContent = (item.product_title || item.title || 'Item') + ' ×' + item.quantity;
        list.append(row);
      });
      var confirm = document.createElement('button');
      confirm.type = 'button'; confirm.textContent = 'I reviewed this bag; enable cart edits';
      confirm.addEventListener('click', resolveReviewedPaidDecrease);
      errorNode.append(list, confirm);
    }
  }

  function renderPaidDecreaseReview(cart, options) {
    if (typeof options?.renderCart === 'function') {
      return Promise.resolve(options.renderCart(cart)).then(function (result) {
        return result === true || result?.ok === true ? { ok: true } : { ok: false };
      });
    }
    return Promise.resolve(applyCartState(cart, { readOnlyReview: true }));
  }

  function reviewPendingPaidDecrease(options) {
    var coordinator = window.TheManCartCoordinator;
    state.paidDecreaseReviewSnapshot = null;
    if (!coordinator?.crossTab) return Promise.resolve({ ok: false, code: 'CROSS_TAB_LOCK_UNAVAILABLE' });
    return coordinator.run(async function () {
      var operation = pendingPaidDecrease();
      if (!operation || operation.version !== 2 || operation.campaignId !== 'THEMAN-002-1010' ||
          operation.revision !== '2026-10-08.4-mixed-32') throw new Error('UNKNOWN_PENDING_OPERATION');
      var result = await getCart();
      if (!result.ok || !Array.isArray(result.cart?.items) || !result.cart.token) throw new Error('CART_REVIEW_UNAVAILABLE');
      var identity = await hashPaidDecreaseReview(result.cart.token);
      if (identity !== operation.cartIdentity) throw new Error('CART_IDENTITY_CHANGED');
      return { cart: result.cart, snapshot: { operationId: operation.operationId,
        operation: JSON.stringify(operation), cartIdentity: identity,
        cartHash: await hashPaidDecreaseReview(JSON.stringify(result.cart)), items: result.cart.items } };
    }, { recovery: true, requireCrossTab: true }).then(async function (result) {
      var applied = await renderPaidDecreaseReview(result.cart, options);
      if (!applied?.ok) throw new Error('CART_RENDER_UNAVAILABLE');
      state.paidDecreaseReviewSnapshot = result.snapshot;
      showPaidDecreaseRecovery();
      return { ok: true, cart: result.cart };
    }).catch(function (error) {
      state.paidDecreaseReviewSnapshot = null;
      showPaidDecreaseRecovery(error?.message === 'CART_IDENTITY_CHANGED'
        ? 'This is a different bag from the unfinished change. Return to the original bag or contact us before editing.'
        : 'Could not display and verify this bag. Check again before another edit.');
      return { ok: false, code: 'CART_REVIEW_UNAVAILABLE' };
    });
  }

  function resolveReviewedPaidDecrease(options) {
    var coordinator = window.TheManCartCoordinator;
    var snapshot = state.paidDecreaseReviewSnapshot;
    if (!coordinator?.crossTab || !snapshot) return Promise.resolve({ ok: false, code: 'REVIEW_REQUIRED' });
    return coordinator.run(async function () {
      var operation = pendingPaidDecrease();
      var result = await getCart();
      if (!operation || operation.version !== 2 || operation.campaignId !== 'THEMAN-002-1010' ||
          operation.revision !== '2026-10-08.4-mixed-32' || operation.operationId !== snapshot.operationId ||
          JSON.stringify(operation) !== snapshot.operation || !result.ok || !Array.isArray(result.cart?.items) ||
          await hashPaidDecreaseReview(result.cart.token || '') !== snapshot.cartIdentity ||
          snapshot.cartIdentity !== operation.cartIdentity ||
          await hashPaidDecreaseReview(JSON.stringify(result.cart)) !== snapshot.cartHash)
        throw new Error('BAG_CHANGED_REVIEW_AGAIN');
      var applied = await renderPaidDecreaseReview(result.cart, options);
      if (!applied?.ok) throw new Error('CART_RENDER_UNAVAILABLE');
      coordinator.clear(operation.operationId);
      return result;
    }, { recovery: true, requireCrossTab: true }).then(function (result) {
      state.paidDecreaseReviewSnapshot = null;
      showError('Cart edits are enabled. Check your bag again before another edit; an earlier request may finish later.');
      return result;
    }).catch(function () {
      state.paidDecreaseReviewSnapshot = null;
      showPaidDecreaseRecovery('The bag changed or could not be displayed. Check it again before enabling cart edits.');
      return { ok: false, code: 'BAG_CHANGED_REVIEW_AGAIN' };
    });
  }

  function atozLineQuantity(cart, item) {
    var expected = item.properties || {};
    return (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (line) {
      var actual = line.properties || {};
      return String(line.variant_id || line.id) === String(item.id) && !line.selling_plan_allocation &&
        Object.keys(actual).length === Object.keys(expected).length &&
        Object.keys(expected).every(function (key) { return actual[key] === expected[key]; });
    }).reduce(function (total, line) { return total + line.quantity; }, 0);
  }

  function atozSameCartContext(before, after, allowFirstToken) {
    if (!before || !after || typeof before.currency !== 'string' || !before.currency ||
        before.currency !== after.currency || !Array.isArray(before.items) || !Array.isArray(after.items)) return false;
    var beforeToken = typeof before.token === 'string' && before.token;
    var afterToken = typeof after.token === 'string' && after.token;
    if (!afterToken) return false;
    if (beforeToken) return beforeToken === afterToken;
    return Boolean(allowFirstToken && before.items.length === 0);
  }

  function atozAddLineIdentity(line) {
    var properties = line.properties || {};
    return JSON.stringify([String(line.variant_id || line.id), Object.keys(properties).sort().map(function (key) {
      return [key, properties[key]];
    }), line.selling_plan_allocation || line.selling_plan || null]);
  }

  function atozAddQuantities(cart) {
    var quantities = Object.create(null);
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var index = 0; index < cart.items.length; index++) {
      var line = cart.items[index];
      if (!line || !(line.variant_id || line.id) || !Number.isSafeInteger(line.quantity) || line.quantity <= 0) return null;
      var identity = atozAddLineIdentity(line);
      quantities[identity] = (quantities[identity] || 0) + line.quantity;
    }
    if (cart.item_count !== undefined && cart.item_count !== Object.keys(quantities).reduce(function (total, key) { return total + quantities[key]; }, 0)) return null;
    return quantities;
  }

  function atozExactAddDelta(before, after, item) {
    var previous = atozAddQuantities(before), current = atozAddQuantities(after);
    if (!previous || !current) return false;
    var target = atozAddLineIdentity(item);
    var keys = Array.from(new Set(Object.keys(previous).concat(Object.keys(current), [target])));
    return keys.every(function (key) {
      return (current[key] || 0) - (previous[key] || 0) === (key === target ? item.quantity : 0);
    });
  }

  function atozSuccessfulFirstAddReceipt(result, item, after) {
    var data = result && result.data;
    var receipt = data && Array.isArray(data.items) ? data.items : data && (data.variant_id || data.id) ? [data] : [];
    return result.ok && result.status >= 200 && result.status < 300 && receipt.length === 1 &&
      atozAddLineIdentity(receipt[0]) === atozAddLineIdentity(item) &&
      receipt[0].quantity === item.quantity && atozLineQuantity(after, item) === item.quantity;
  }

  function runMutation(action) {
    if (state.pending) {
      return Promise.resolve({
        ok: false,
        skipped: true,
        pending: true,
        message: messages.pending
      });
    }

    state.pending = true;
    setCartSyncing(true);
    setLoading();

    return action()
      .then(function (result) {
        if (!result.ok) {
          showError(result.message);
          try { if (pendingAtozAdd()) showAtozAddRecovery(); } catch (_) {}
        }

        return result;
      })
      .catch(function (error) {
        var result = {
          ok: false,
          status: 0,
          code: error && error.uncertain ? 'cart_review_required' : 'controller_error',
          message: error && error.uncertain ? 'Review your bag before trying again.' : messages.generic,
          details: error && error.message ? error.message : null
        };

        showError(result.message);
        try { if (pendingAtozAdd()) showAtozAddRecovery(); } catch (_) {}
        return result;
      })
      .finally(function () {
        state.pending = false;
        setCartSyncing(false);
        clearLoading();
      });
  }

  function getCart() {
    return requestJson('/cart.js').then(function (result) {
      if (!result.ok) {
        return result;
      }

      return {
        ok: true,
        status: result.status,
        cart: result.data
      };
    });
  }

  function attachRefreshResult(result) {
    if (!result.ok) {
      return Promise.resolve(result);
    }

    return refreshAfterCartChange().then(function (refreshResult) {
      return Object.assign({}, result, {
        refresh: refreshResult
      });
    });
  }

  function attachApplyResult(result) {
    var applyResult;

    if (!result.ok) {
      return Promise.resolve(result);
    }

    if (!result.cart) {
      return getCart().then(function (cartResult) {
        if (!cartResult.ok) {
          return Object.assign({}, result, {
            apply: structuredError('cart_json_error', cartResult.message, cartResult)
          });
        }

        applyResult = applyCartState(cartResult.cart);
        return Object.assign({}, result, {
          cart: cartResult.cart,
          apply: applyResult
        });
      });
    }

    applyResult = applyCartState(result.cart);
    return Promise.resolve(Object.assign({}, result, {
      apply: applyResult
    }));
  }

  function addItem(variantId, quantity, properties, pendingContext) {
    if (isAtozEnabled()) {
      openDrawerForAddStart('ATOZCart.addItem:start', Object.assign({
        variantId: variantId,
        quantity: quantity
      }, pendingContext && typeof pendingContext === 'object' ? pendingContext : {}));
    }

    return runMutation(function () {
      var normalizedQuantity = normalizeQuantity(quantity, 1);
      var item = {
        id: variantId,
        quantity: normalizedQuantity > 0 ? normalizedQuantity : 1
      };

      if (!variantId) {
        clearPendingAddRows();
        return Promise.resolve({
          ok: false,
          status: 0,
          code: 'missing_variant',
          message: 'Missing variant ID.'
        });
      }

      if (properties && typeof properties === 'object' && Object.keys(properties).length) {
        item.properties = properties;
      }

      var coordinator = window.TheManCartCoordinator;
      var operationId;
      var write = function () {
        if (coordinator) {
          operationId = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random();
          coordinator.save({ version: 2, kind: 'atoz-add', operationId: operationId,
            cartIdentity: 'atoz-add-' + operationId, revision: 'atoz-add-v1', createdAt: Date.now() });
        }
        return postJson('/cart/add.js', { items: [item] }).then(function (addResult) {
          return Object.assign({}, addResult, { cart: {} });
        });
      };
      var finalize = async function (state) {
        var before = state.before, after = state.cart, result = state.result;
        if (state.failure || !result || !after || !before) return result;
        var added = atozLineQuantity(after, item) - atozLineQuantity(before, item);
        if (result.ok && added === item.quantity && atozExactAddDelta(before, after, item)) {
          if (atozSameCartContext(before, after, true)) {
            coordinator.clear(operationId);
            return result;
          }
          if (before.items.length === 0 && before.currency === after.currency && after.token &&
              atozSuccessfulFirstAddReceipt(result, item, after)) {
            var stable = await getCart();
            if (stable.ok && atozSameCartContext(after, stable.cart, false) &&
                atozExactAddDelta(before, stable.cart, item) && cartReviewIdentity(after) === cartReviewIdentity(stable.cart)) {
              coordinator.clear(operationId);
              return result;
            }
          }
        }
        if (!result.ok && result.status >= 400 && result.status < 500 &&
            atozSameCartContext(before, after, false) &&
            JSON.stringify(before.items) === JSON.stringify(after.items)) {
          coordinator.clear(operationId);
          return result;
        }
        return Object.assign({}, result, { ok: false, code: 'cart_review_required',
          message: 'Review your bag before trying again.' });
      };
      var addition = coordinator ? coordinator.mutate(write, { finalize: finalize }) : write();

      return addition.then(function (addResult) {
        if (!addResult.ok) {
          clearPendingAddRows();
          if (addResult.code === 'cart_review_required' || addResult.code === 'network_error') {
            if (addResult.cart && Array.isArray(addResult.cart.items)) {
              applyCartState(addResult.cart, { readOnlyReview: true });
            }
          }
          return addResult.code === 'network_error' || addResult.code === 'cart_review_required'
            ? Object.assign({}, addResult, { message: 'Review your bag before trying again.' })
            : addResult;
        }

        rememberRecentAddedProductFromPayload(addResult.data);

        return (coordinator && addResult.cart && Array.isArray(addResult.cart.items)
          ? Promise.resolve({ ok: true, status: 200, cart: addResult.cart })
          : getCart()).then(function (cartResult) {
          return {
            ok: true,
            status: addResult.status,
            action: 'add',
            item: addResult.data,
            cart: cartResult.ok ? cartResult.cart : null,
            cartError: cartResult.ok ? null : cartResult
          };
        }).then(attachApplyResult).then(function (result) {
          if (result.ok && result.apply && result.apply.ok) {
            openDrawer({ skipBuild: true });
            activateAndScheduleAcquisitionOffer(result.cart, 'ATOZCart.addItem');
          } else if (result.ok && result.apply && !result.apply.ok) {
            clearPendingAddRows();
            showError(result.apply.message);
          }

          return result;
        });
      });
    });
  }

  function changeItemRequest(lineKeyOrLine, quantity) {
    var target = normalizeLineTarget(lineKeyOrLine);
    var normalizedQuantity = requestedCartQuantity(quantity);

    if (!target) {
      return Promise.resolve({
        ok: false,
        status: 0,
        code: 'missing_line',
        message: 'Missing cart line.'
      });
    }

    if (normalizedQuantity === null) {
      return Promise.resolve({ ok: false, status: 0, code: 'invalid_quantity',
        message: 'Enter a whole number of zero or more items.' });
    }

    var paidWrite = function (key, requestedQuantity) {
      return postJson('/cart/change.js', { id: key, quantity: requestedQuantity }).then(function (result) {
        if (!result.ok) return result;
        return {
          ok: true,
          status: result.status,
          action: requestedQuantity === 0 ? 'remove' : 'change',
          cart: result.data
        };
      });
    };
    var write = function () {
      return postJson('/cart/change.js', Object.assign({}, target, { quantity: normalizedQuantity })).then(function (result) {
        if (!result.ok) return result;
        return { ok: true, status: result.status, action: normalizedQuantity === 0 ? 'remove' : 'change', cart: result.data };
      });
    };
    var coordinator = window.TheManCartCoordinator;
    var configuration = null;
    try { configuration = JSON.parse(document.querySelector('[data-tm-bb-campaign-configuration]')?.textContent || 'null'); }
    catch (_) {}
    var campaignConfigured = configuration?.enabled === true && configuration.id === 'THEMAN-002-1010' &&
      configuration.revision === '2026-10-08.4-mixed-32';
    if (campaignConfigured && !coordinator?.crossTab) {
      return Promise.resolve({ ok: false, code: 'safe_adjustment_unavailable',
        message: 'Could not safely adjust your sample gifts. Review your bag before reducing bottles.' });
    }
    return coordinator ? coordinator.mutate(function (before) {
      var line = before && Array.isArray(before.items)
        ? (target.id ? before.items.find(function (item) { return item.key === target.id; }) : before.items[target.line - 1]) : null;
      if (campaignConfigured && (!target.id || !line || !Number.isSafeInteger(line.quantity) || line.quantity < 0)) {
        return { ok: false, code: 'paid_line_changed',
          message: 'The bag changed. Review it before editing a bottle quantity.' };
      }
      var eligible = campaignConfigured && line && !line.selling_plan_allocation && !line.selling_plan &&
        Array.isArray(configuration.eligibleVariantIds) &&
        configuration.eligibleVariantIds.includes(String(line.variant_id || line.id));
      if (!eligible || normalizedQuantity >= line.quantity) return write();
      if (!window.TheManBundleProvider?.decreaseWithinLock) {
        return { ok: false, code: 'safe_adjustment_unavailable',
          message: 'Could not safely adjust your sample gifts. Review your bag before reducing bottles.' };
      }
      return window.TheManBundleProvider.decreaseWithinLock({ before: before, lineKey: line.key,
        quantity: normalizedQuantity, writePaid: paidWrite });
    }) : write();
  }

  function changeItem(lineKeyOrLine, quantity) {
    var target = normalizeLineTarget(lineKeyOrLine);
    var lineKey = target && target.id ? target.id : '';

    setCartSyncing(true);

    if (lineKey) {
      setRowLoading(lineKey, true);
    }

    return changeItemRequest(lineKeyOrLine, quantity)
      .then(attachApplyResult)
      .then(function (result) {
        if (!result.ok) {
          if (result.code === 'invalid_quantity') {
            showError(result.message);
            return result;
          }
          return resyncAfterCartWriteFailure(result);
        }
        if (result.apply && !result.apply.ok) {
          showError(result.apply.message || 'Review your bag before making another change.');
        }

        return result;
      })
      .catch(function (error) {
        return resyncAfterCartWriteFailure(structuredError('controller_error', messages.generic,
          error && error.message ? error.message : null));
      })
      .finally(function () {
        if (lineKey) {
          setRowLoading(lineKey, false);
        }

        setCartSyncing(false);
      });
  }

  function getQueuedQuantity(lineKey) {
    var queue = state.quantityQueue[lineKey];

    return queue && typeof queue.pendingQuantity === 'number' ? queue.pendingQuantity : null;
  }

  function getConfirmedCartQuantity(cart, lineKey) {
    var item;

    if (!cart || !Array.isArray(cart.items)) {
      return null;
    }

    item = cart.items.find(function (cartItem) {
      return cartItem && cartItem.key === lineKey;
    });

    return item && typeof item.quantity === 'number' ? item.quantity : 0;
  }

  function getQuantityQueue(lineKey) {
    if (!state.quantityQueue[lineKey]) {
      state.quantityQueue[lineKey] = {
        timer: null,
        inFlight: false,
        pendingQuantity: null,
        requestedQuantity: null
      };
    }

    return state.quantityQueue[lineKey];
  }

  function setQueuedInputValue(lineKey, quantity) {
    var row = getRowByLineKey(lineKey);
    var input = row ? row.querySelector(selectors.quantityInput) : null;

    if (input) {
      input.value = quantity;
    }
  }

  function clearQuantityQueue(lineKey) {
    var queue = state.quantityQueue[lineKey];

    if (!queue) {
      return;
    }

    if (queue.timer) {
      window.clearTimeout(queue.timer);
    }

    delete state.quantityQueue[lineKey];
  }

  function resyncAfterCartWriteFailure(result) {
    return getCart().then(function (cartResult) {
      if (cartResult.ok) {
        applyCartState(cartResult.cart);
      }
      showError(cartResult.ok ? result.message || messages.generic :
        'Could not confirm your bag. Review it before trying again.');
      try { if (pendingPaidDecrease()) showPaidDecreaseRecovery(cartResult.ok ? result.message :
        'Could not confirm your bag. Review it before trying again.'); } catch (_) {}
      return result;
    }).catch(function () {
      showError('Could not confirm your bag. Review it before trying again.');
      try { if (pendingPaidDecrease()) showPaidDecreaseRecovery('Could not confirm your bag. Review it before trying again.'); } catch (_) {}
      return result;
    });
  }

  function resyncCartAfterQuantityFailure(lineKey, result) {
    return resyncAfterCartWriteFailure(result).then(function (outcome) {
      clearQuantityQueue(lineKey);
      return outcome;
    });
  }

  function flushQuantityQueue(lineKey) {
    var queue = state.quantityQueue[lineKey];
    var requestedQuantity;

    if (!queue || queue.inFlight) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        lineKey: lineKey
      });
    }

    requestedQuantity = requestedCartQuantity(queue.pendingQuantity);

    if (requestedQuantity === null) {
      clearQuantityQueue(lineKey);
      return Promise.resolve({
        ok: false,
        code: 'missing_quantity',
        lineKey: lineKey
      });
    }

    queue.inFlight = true;
    queue.requestedQuantity = requestedQuantity;
    setCartSyncing(true);
    debugLog('quantity flush start', lineKey, requestedQuantity);

    return changeItemRequest(lineKey, requestedQuantity)
      .then(attachApplyResult)
      .then(function (result) {
        var latestQueue = state.quantityQueue[lineKey];
        var latestPending = latestQueue ? requestedCartQuantity(latestQueue.pendingQuantity) : null;
        var confirmedQuantity;

        if (!result.ok) {
          return resyncCartAfterQuantityFailure(lineKey, result);
        }
        if (result.apply && !result.apply.ok) {
          showError(result.apply.message || 'Review your bag before making another change.');
          return result;
        }

        confirmedQuantity = getConfirmedCartQuantity(result.cart, lineKey);

        if (latestPending !== null && confirmedQuantity !== latestPending) {
          setQueuedInputValue(lineKey, latestPending);
        }

        debugLog('quantity flush complete', lineKey, {
          requested: requestedQuantity,
          confirmed: confirmedQuantity,
          pending: latestPending
        });

        return result;
      })
      .catch(function (error) {
        var result = structuredError('quantity_update_error', messages.generic, error && error.message ? error.message : null);

        return resyncCartAfterQuantityFailure(lineKey, result);
      })
      .finally(function () {
        var latestQueue = state.quantityQueue[lineKey];
        var latestPending;
        var requested;

        if (!latestQueue) {
          setCartSyncing(false);
          return;
        }

        latestPending = requestedCartQuantity(latestQueue.pendingQuantity);
        requested = requestedCartQuantity(latestQueue.requestedQuantity);
        latestQueue.inFlight = false;

        if (latestPending !== null && requested !== null && latestPending !== requested) {
          setCartSyncing(true);
          latestQueue.timer = window.setTimeout(function () {
            flushQuantityQueue(lineKey);
          }, 0);
          return;
        }

        clearQuantityQueue(lineKey);
        setCartSyncing(false);
      });
  }

  function queueQuantityChange(lineKey, quantity) {
    var normalizedQuantity = requestedCartQuantity(quantity);
    var queue;

    if (!lineKey || normalizedQuantity === null) {
      return Promise.resolve({
        ok: false,
        code: 'missing_quantity',
        lineKey: lineKey
      });
    }

    if (normalizedQuantity <= 0) {
      clearQuantityQueue(lineKey);
      return removeItem(lineKey);
    }

    queue = getQuantityQueue(lineKey);
    queue.pendingQuantity = normalizedQuantity;

    if (queue.timer) {
      window.clearTimeout(queue.timer);
      queue.timer = null;
    }

    if (!queue.inFlight) {
      queue.timer = window.setTimeout(function () {
        flushQuantityQueue(lineKey);
      }, quantityDebounceDelay);
    }

    debugLog('quantity queued', lineKey, normalizedQuantity);

    return Promise.resolve({
      ok: true,
      queued: true,
      lineKey: lineKey,
      quantity: normalizedQuantity
    });
  }

  function removeItem(lineKeyOrLine) {
    var target = normalizeLineTarget(lineKeyOrLine);
    var lineKey = target && target.id ? target.id : '';

    setCartSyncing(true);

    if (lineKey) {
      clearQuantityQueue(lineKey);
      setRowLoading(lineKey, true);
    }

    return changeItemRequest(lineKeyOrLine, 0)
      .then(attachApplyResult)
      .then(function (result) {
        if (!result.ok) {
          return resyncAfterCartWriteFailure(result);
        }
        if (result.apply && !result.apply.ok) {
          showError(result.apply.message || 'Review your bag before making another change.');
        }

        return result;
      })
      .catch(function (error) {
        return resyncAfterCartWriteFailure(structuredError('controller_error', messages.generic,
          error && error.message ? error.message : null));
      })
      .finally(function () {
        setCartSyncing(false);
      });
  }

  function refreshSections(sectionIds) {
    var ids = normalizeSectionIds(sectionIds);

    if (!ids.length) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        source: 'sections',
        message: 'No section IDs were provided.',
        sections: {}
      });
    }

    return requestJson('/?sections=' + ids.map(encodeURIComponent).join(',')).then(function (result) {
      if (!result.ok) {
        return structuredError('section_rendering_error', result.message, result);
      }

      var sectionHtml = result.data || {};
      var replacements = [];
      var missingTargets = [];
      var parseErrors = [];

      Object.keys(sectionHtml).forEach(function (sectionId) {
        var html = sectionHtml[sectionId];
        var replaceResult;

        if (typeof html !== 'string') {
          parseErrors.push(sectionId);
          return;
        }

        replaceResult = replaceTargetsFromHtml(html, refreshSelectors);

        if (!replaceResult.ok) {
          parseErrors.push(sectionId);
          return;
        }

        replacements = replacements.concat(replaceResult.replacements);
        missingTargets = missingTargets.concat(replaceResult.missingTargets);
      });

      return {
        ok: true,
        status: result.status,
        source: 'sections',
        sections: sectionHtml,
        replacements: replacements,
        missingTargets: missingTargets,
        parseErrors: parseErrors
      };
    }).catch(function (error) {
      return structuredError('section_rendering_error', messages.generic, error && error.message ? error.message : null);
    });
  }

  function refreshCartHtml(sectionIds) {
    var ids = normalizeSectionIds(sectionIds);

    function refreshAjaxCartView(sectionResult) {
      return requestText('/cart?view=ajax').then(function (ajaxResult) {
        var applyResult;

        if (!ajaxResult.ok) {
          return structuredError('ajax_cart_error', ajaxResult.message, {
            sectionResult: sectionResult || null,
            ajaxResult: ajaxResult
          });
        }

        applyResult = applyAjaxCartHtml(ajaxResult.html);

        return {
          ok: applyResult.ok,
          status: ajaxResult.status,
          source: 'ajax_cart_view',
          html: ajaxResult.html,
          replacements: applyResult.replacements || [],
          missingTargets: applyResult.missingTargets || [],
          cartCount: applyResult.cartCount || null,
          sectionResult: sectionResult || null,
          error: applyResult.ok ? null : applyResult
        };
      }).catch(function (error) {
        return structuredError('ajax_cart_error', messages.generic, error && error.message ? error.message : null);
      });
    }

    if (!ids.length) {
      return refreshAjaxCartView(null);
    }

    return refreshSections(ids).then(function (sectionResult) {
      if (!sectionResult.ok || !sectionResult.replacements || !sectionResult.replacements.length) {
        return refreshAjaxCartView(sectionResult);
      }

      return sectionResult;
    }).catch(function (error) {
      return refreshAjaxCartView(structuredError('section_rendering_error', messages.generic, error && error.message ? error.message : null));
    });
  }

  function refreshCartCount() {
    return getCart().then(function (cartResult) {
      var countResult;

      if (!cartResult.ok) {
        return structuredError('cart_count_error', cartResult.message, cartResult);
      }

      countResult = updateCountTargets(cartResult.cart && cartResult.cart.item_count);

      return {
        ok: true,
        source: 'cart_json',
        cart: cartResult.cart,
        count: countResult.ok ? countResult.count : null,
        updated: countResult.ok ? countResult.updated : 0,
        countResult: countResult
      };
    }).catch(function (error) {
      return structuredError('cart_count_error', messages.generic, error && error.message ? error.message : null);
    });
  }

  function refreshAfterCartChange(sectionIds) {
    setCartSyncing(true);

    return refreshCartHtml(sectionIds).then(function (htmlResult) {
      return refreshCartCount().then(function (countResult) {
        return {
          ok: Boolean(htmlResult.ok && countResult.ok),
          html: htmlResult,
          count: countResult
        };
      });
    }).catch(function (error) {
      return structuredError('cart_refresh_error', messages.generic, error && error.message ? error.message : null);
    }).finally(function () {
      setCartSyncing(false);
    });
  }

  function openDrawer(options) {
    var drawer = getDrawer();
    var opener;
    var settings = options && typeof options === 'object' ? options : {};

    if (!drawer) {
      return {
        ok: true,
        skipped: true,
        opened: false
      };
    }

    if (!settings.skipBuild) {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }

    document.dispatchEvent(new CustomEvent('cart:open'));

    if (!drawer.classList.contains('drawer--is-open')) {
      opener = document.querySelector('.js-drawer-open-cart');

      if (opener && typeof opener.click === 'function') {
        opener.click();
      }
    }

    scheduleDrawerOpenStateSync();

    return {
      ok: true,
      opened: isDrawerOpen(drawer)
    };
  }

  function closeDrawer() {
    var drawer = getDrawer();
    var closeButton;

    if (!drawer) {
      return {
        ok: true,
        skipped: true,
        opened: false
      };
    }

    document.dispatchEvent(new CustomEvent('cart:close'));

    if (drawer.classList.contains('drawer--is-open')) {
      closeButton = drawer.querySelector('.js-drawer-close');

      if (closeButton && typeof closeButton.click === 'function') {
        closeButton.click();
      }
    }

    scheduleDrawerOpenStateSync();

    return {
      ok: true,
      opened: isDrawerOpen(drawer)
    };
  }

  function closeActiveQuickShopModal() {
    var modal = document.querySelector('.modal--quick-shop.modal--is-active');
    var closeButton;

    if (!modal) {
      return {
        ok: true,
        closed: false
      };
    }

    closeButton = modal.querySelector('.js-modal-close');

    if (closeButton && typeof closeButton.click === 'function') {
      closeButton.click();
    } else {
      modal.classList.remove('modal--is-active');
      document.documentElement.classList.remove('modal-open');
    }

    return {
      ok: true,
      closed: true
    };
  }

  function openDrawerForAddStart(source, pendingContext) {
    var pendingResult = null;

    if (!isAtozEnabled()) {
      return {
        ok: true,
        skipped: true,
        source: source
      };
    }

    clearError();
    closeActiveQuickShopModal();
    setCartSyncing(true);
    openDrawer({ skipBuild: true });
    pendingResult = ensurePendingAddRows(pendingContext, source);
    debugLog('drawer opened for add start', source, pendingResult);

    return {
      ok: true,
      source: source,
      pending: pendingResult
    };
  }

  function applyCartAndOpen(cart, source) {
    var applyResult = applyCartState(cart);
    var countResult = updateCartCount(cart);

    setCartSyncing(false);
    closeActiveQuickShopModal();
    openDrawer({ skipBuild: true });
    activateAndScheduleAcquisitionOffer(cart, source);
    debugLog('add sync complete', source, {
      itemCount: cart && cart.item_count,
      apply: applyResult,
      count: countResult
    });

    return {
      ok: Boolean(applyResult.ok && countResult.ok),
      source: source,
      cart: cart,
      apply: applyResult,
      count: countResult
    };
  }

  function runAddSync(source) {
    var cart = state.addSyncCart;

    state.addSyncTimer = null;

    if (state.addSyncInFlight) {
      state.addSyncQueued = true;
      return Promise.resolve({
        ok: true,
        queued: true,
        source: source
      });
    }

    state.addSyncInFlight = true;
    state.addSyncQueued = false;
    state.addSyncCart = null;
    state.lastAddSyncAt = Date.now();

    debugLog('add sync start', source, cart ? 'provided cart' : 'fetch cart');

    return (cart
      ? Promise.resolve({ ok: true, cart: cart })
      : getCart()
    ).then(function (cartResult) {
      if (!cartResult.ok) {
        debugLog('add sync cart fetch failed', cartResult);
        clearPendingAddRows();
        setCartSyncing(false);
        showError(cartResult.message);
        openDrawer({ skipBuild: true });
        return cartResult;
      }

      return applyCartAndOpen(cartResult.cart, source);
    }).catch(function (error) {
      var result = structuredError('add_sync_error', messages.generic, error && error.message ? error.message : null);

      clearPendingAddRows();
      setCartSyncing(false);
      showError(result.message);
      openDrawer({ skipBuild: true });

      return result;
    }).finally(function () {
      state.addSyncInFlight = false;

      if (state.addSyncQueued || state.addSyncCart) {
        state.addSyncQueued = false;
        scheduleAddSync('queued');
      }
    });
  }

  function scheduleAddSync(source, cart, pendingContext) {
    if (!isAtozEnabled()) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        source: source
      });
    }

    if (cart && typeof cart === 'object') {
      state.addSyncCart = cart;
    }

    openDrawerForAddStart(source, pendingContext);

    if (state.addSyncTimer) {
      window.clearTimeout(state.addSyncTimer);
    }

    state.addSyncTimer = window.setTimeout(function () {
      runAddSync(source);
    }, 80);

    debugLog('add sync scheduled', source, cart ? 'provided cart' : 'cart fetch pending');

    return Promise.resolve({
      ok: true,
      scheduled: true,
      source: source
    });
  }

  function bindCartAddFetchObserver() {
    var originalFetch;

    if (state.fetchObserverBound || typeof window.fetch !== 'function') {
      return;
    }

    originalFetch = window.fetch;
    state.fetchObserverBound = true;

    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var input = args[0];
      var options = args[1];
      var url = getFetchUrl(input);
      var method = getFetchMethod(input, options);
      var pendingContexts = [];
      var shouldObserve = isAtozEnabled() &&
        !state.pending &&
        !state.freebieAutoAddInFlight &&
        !state.acquisitionOfferSyncInFlight &&
        method === 'POST' &&
        isCartAddUrl(url);

      if (shouldObserve) {
        pendingContexts = getPendingContextsFromFetch(input, options);
        openDrawerForAddStart('fetch:/cart/add.js:start', pendingContexts);
      }

      return originalFetch.apply(this, args).then(function (response) {
        if (shouldObserve && response && response.ok) {
          if (response && typeof response.clone === 'function') {
            response.clone().text().then(function (text) {
              rememberRecentAddedProductFromPayload(parseJson(text));
            }).catch(function () {});
          }

          scheduleAddSync('fetch:/cart/add.js', null, pendingContexts);
        } else if (shouldObserve) {
          clearPendingAddRows();
          setCartSyncing(false);

          if (response && typeof response.clone === 'function') {
            response.clone().text().then(function (text) {
              var payload = parseJson(text);
              var error = normalizeError(payload, response.status, messages.generic);

              showError(error.message);
            }).catch(function () {
              showError(messages.generic);
            });
          } else {
            showError(messages.generic);
          }
        }

        return response;
      }).catch(function (error) {
        if (shouldObserve) {
          clearPendingAddRows();
          setCartSyncing(false);
          showError(messages.network);
        }

        throw error;
      });
    };
  }

  function getUrlFromHref(href) {
    if (!href) {
      return null;
    }

    try {
      return new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function isCartRemoveHref(control) {
    var href = control && control.getAttribute ? control.getAttribute('href') : '';
    var url = getUrlFromHref(href);
    var pathname = url && url.pathname ? url.pathname : '';
    var quantity = url && url.searchParams ? url.searchParams.get('quantity') : '';
    var label = normalizeText(
      (control && control.getAttribute ? control.getAttribute('aria-label') : '') ||
      (control && control.textContent ? control.textContent : '')
    );

    if (!url || !/^\/cart\/(?:change|update)(?:\.js)?$/i.test(pathname)) {
      return false;
    }

    return quantity === '0' ||
      /remove|delete/i.test(label) ||
      Boolean(control.closest && control.closest('.cart__remove'));
  }

  function isDrawerRemoveControl(control) {
    if (!control) {
      return false;
    }

    return Boolean(
      control.hasAttribute('data-atoz-cart-remove') ||
      control.hasAttribute('data-cart-remove') ||
      control.hasAttribute('data-remove') ||
      isCartRemoveHref(control)
    );
  }

  function getLineTargetFromHref(control) {
    var href = control && control.getAttribute ? control.getAttribute('href') : '';
    var url = getUrlFromHref(href);
    var line;
    var id;

    if (!url) {
      return null;
    }

    id = normalizeText(url.searchParams.get('id'));

    if (id) {
      return id;
    }

    line = normalizeQuantity(url.searchParams.get('line'), 0);

    return line > 0 ? line : null;
  }

  function getDatasetLineTarget(element) {
    var dataset = element && element.dataset ? element.dataset : null;
    var line;
    var id;

    if (!dataset) {
      return null;
    }

    id = normalizeText(dataset.lineKey || dataset.key || dataset.id);

    if (id) {
      return id;
    }

    line = normalizeQuantity(dataset.line || dataset.index, 0);

    return line > 0 ? line : null;
  }

  function getLineTargetFromRemoveControl(control) {
    var row = control && control.closest ? control.closest(selectors.row + ', .cart__item[data-key], [data-line-key], [data-key]') : null;

    return getDatasetLineTarget(control) ||
      getLineTargetFromHref(control) ||
      getDatasetLineTarget(row);
  }

  function getQuantityControl(eventTarget, selector, fallbackSelector) {
    if (!eventTarget || typeof eventTarget.closest !== 'function') {
      return null;
    }

    return eventTarget.closest(selector) || eventTarget.closest(fallbackSelector);
  }

  function getLineKeyFromQuantity(row, input) {
    if (row && row.dataset && row.dataset.lineKey) {
      return row.dataset.lineKey;
    }

    if (row && row.dataset && row.dataset.key) {
      return row.dataset.key;
    }

    if (input && input.dataset && input.dataset.id) {
      return input.dataset.id;
    }

    return '';
  }

  function isProductAddForm(form) {
    var action;

    if (!form || !form.matches) {
      return false;
    }

    if (getDrawer() && getDrawer().contains(form)) {
      return false;
    }

    action = form.getAttribute('action') || '';

    return form.matches(selectors.productForm) || isCartAddPath(action);
  }

  function handleProductFormSubmit(event) {
    var form = event.target;

    if (!isAtozEnabled() || !isProductAddForm(form)) {
      return;
    }

    openDrawerForAddStart('form:submit', getPendingContextFromForm(form));
  }

  function handleAjaxProductError(event) {
    var detail = event && event.detail ? event.detail : {};
    var errorMessage = detail.errorMessage || messages.generic;

    if (!isAtozEnabled()) {
      return;
    }

    clearPendingAddRows();
    setCartSyncing(false);
    openDrawer({ skipBuild: true });
    showError(errorMessage);
  }

  function getUpsellPendingContext(button) {
    return normalizePendingAddContext({
      variantId: button && button.dataset ? button.dataset.variantId : '',
      title: button && button.dataset ? button.dataset.productTitle : '',
      variantText: button && button.dataset ? button.dataset.variantTitle : '',
      quantity: 1,
      image: button && button.dataset ? button.dataset.productImage : '',
      url: button && button.dataset ? button.dataset.productUrl : ''
    });
  }

  function setUpsellButtonLoading(button, isLoading) {
    if (!button) {
      return;
    }

    if (!button.dataset.defaultLabel) {
      button.dataset.defaultLabel = normalizeText(button.textContent) || 'Add to rotation';
    }

    button.disabled = Boolean(isLoading);
    button.classList.toggle('is-loading', Boolean(isLoading));

    if (isLoading) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding...';
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      button.textContent = button.dataset.defaultLabel || 'Add to rotation';
    }
  }

  function handleUpsellAddClick(event) {
    var button = event.target && event.target.closest ? event.target.closest(selectors.upsellAdd) : null;
    var drawer = getDrawer();
    var variantId;
    var pendingContext;

    if (!button || !drawer || !drawer.contains(button)) {
      return;
    }

    event.preventDefault();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    if (
      button.disabled ||
      button.getAttribute('aria-disabled') === 'true' ||
      button.classList.contains('is-loading') ||
      state.pending ||
      state.loading ||
      state.cartSyncing
    ) {
      return;
    }

    variantId = button.dataset ? normalizeText(button.dataset.variantId) : '';
    pendingContext = getUpsellPendingContext(button);
    setUpsellButtonLoading(button, true);
    state.upsellInteracted = true;
    stopUpsellAutoScroll();

    if (!window.ATOZCart || typeof window.ATOZCart.addItem !== 'function') {
      setUpsellButtonLoading(button, false);
      showError(messages.generic);
      return;
    }

    window.ATOZCart.addItem(variantId, 1, null, pendingContext).then(function (result) {
      if (!result.ok || (result.apply && !result.apply.ok)) {
        setUpsellButtonLoading(button, false);
        showError(result.message || (result.apply && result.apply.message) || messages.generic);
        return;
      }
    }).catch(function (error) {
      setUpsellButtonLoading(button, false);
      showError(error && error.message ? error.message : messages.generic);
    }).finally(function () {
      setCartSyncing(false);
    });
  }

  function handleUpsellControlClick(event) {
    var previousButton = event.target && event.target.closest ? event.target.closest(selectors.upsellPrev) : null;
    var nextButton = event.target && event.target.closest ? event.target.closest(selectors.upsellNext) : null;
    var dot = event.target && event.target.closest ? event.target.closest(selectors.upsellDot) : null;
    var control = previousButton || nextButton || dot;
    var section = control ? control.closest(selectors.upsells) : null;
    var activeIndex;
    var nextIndex;

    if (!control || !section) {
      return;
    }

    event.preventDefault();
    state.upsellInteracted = true;
    stopUpsellAutoScroll();
    activeIndex = getUpsellActiveIndex(section);
    nextIndex = dot && dot.dataset ? normalizeQuantity(dot.dataset.index, activeIndex) : nextButton ? activeIndex + 1 : activeIndex - 1;
    scrollUpsellTo(section, nextIndex, true);
    window.setTimeout(function () {
      updateUpsellControls(section);
    }, 240);
  }

  function handleUpsellInteraction(event) {
    var section = event.target && event.target.closest ? event.target.closest(selectors.upsells) : null;

    if (!section) {
      return;
    }

    state.upsellInteracted = true;
    stopUpsellAutoScroll();
  }

  function handleUpsellScroll(event) {
    var viewport = event.target && event.target.closest ? event.target.closest(selectors.upsellViewport) : null;
    var section = viewport ? viewport.closest(selectors.upsells) : null;

    if (!section) {
      return;
    }

    window.requestAnimationFrame(function () {
      updateUpsellControls(section);
    });
  }

  function handleRemoveClick(event) {
    var control = event.target && event.target.closest ? event.target.closest(selectors.removeControl) : null;
    var drawer = getDrawer();
    var row;
    var lineTarget;

    if (!control || !drawer || !drawer.contains(control) || !isDrawerRemoveControl(control)) {
      return;
    }

    event.preventDefault();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    row = control.closest ? control.closest(selectors.row) : null;
    lineTarget = getLineTargetFromRemoveControl(control);

    if (!lineTarget || (row && row.classList && row.classList.contains('is-loading'))) {
      return;
    }

    removeItem(lineTarget);
  }

  function handleQuantityClick(event) {
    var minusControl = getQuantityControl(event.target, selectors.quantityMinus, '.js-qty__adjust--minus');
    var plusControl = getQuantityControl(event.target, selectors.quantityPlus, '.js-qty__adjust--plus');
    var control = minusControl || plusControl;
    var drawer = getDrawer();
    var row;
    var input;
    var lineKey;
    var queuedQuantity;
    var currentQuantity;
    var nextQuantity;

    if (!control || !drawer || !drawer.contains(control)) {
      return;
    }

    event.preventDefault();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    if (
      control.disabled ||
      control.getAttribute('aria-disabled') === 'true' ||
      state.pending ||
      state.loading
    ) {
      return;
    }

    row = control.closest ? control.closest(selectors.row + ', .cart__item[data-key]') : null;
    input = row ? row.querySelector(selectors.quantityInput + ', .js-qty__num[data-id]') : null;
    lineKey = getLineKeyFromQuantity(row, input);

    if (!row || !lineKey) {
      return;
    }

    queuedQuantity = getQueuedQuantity(lineKey);
    currentQuantity = queuedQuantity !== null ? queuedQuantity : requestedCartQuantity(input && input.value);
    if (currentQuantity === null) {
      showError('Enter a whole number of zero or more items.');
      return;
    }
    nextQuantity = plusControl ? currentQuantity + 1 : currentQuantity - 1;

    if (input) {
      input.value = Math.max(nextQuantity, 0);
    }

    queueQuantityChange(lineKey, nextQuantity);
  }

  function handleQuantityChange(event) {
    var input = event.target && event.target.closest ? event.target.closest(selectors.quantityInput + ', .js-qty__num[data-id]') : null;
    var drawer = getDrawer();
    var row;
    var lineKey;
    var nextQuantity;

    if (!input || !drawer || !drawer.contains(input)) {
      return;
    }

    event.preventDefault();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    if (
      input.disabled ||
      input.getAttribute('aria-disabled') === 'true' ||
      state.pending ||
      state.loading
    ) {
      return;
    }

    row = input.closest ? input.closest(selectors.row + ', .cart__item[data-key]') : null;
    lineKey = getLineKeyFromQuantity(row, input);

    if (!row || !lineKey) {
      return;
    }

    nextQuantity = input && input.value;
    queueQuantityChange(lineKey, nextQuantity);
  }

  function handleAjaxProductAdded(event) {
    var detail = event && event.detail ? event.detail : null;

    if (!isAtozEnabled()) {
      return;
    }

    debugLog('ajaxProduct:added received', detail);
    rememberRecentAddedProductFromPayload(detail && detail.product);
    scheduleAddSync(
      'ajaxProduct:added',
      detail && detail.cart ? detail.cart : null,
      getPendingContextFromCartAddProduct(detail && detail.product)
    );
  }

  function hasStuckCheckoutLoading() {
    var checkoutButtons = getCheckoutButtons();
    var stuck = false;

    checkoutButtons.forEach(function (button) {
      if (
        button.classList.contains('btn--loading') ||
        button.classList.contains('is-loading') ||
        button.getAttribute('aria-disabled') === 'true'
      ) {
        stuck = true;
      }
    });

    return stuck;
  }

  function isBackForwardRestore(event) {
    var navigationEntries;

    if (event && event.persisted) {
      return true;
    }

    if (
      window.performance &&
      typeof window.performance.getEntriesByType === 'function'
    ) {
      navigationEntries = window.performance.getEntriesByType('navigation');

      if (
        navigationEntries &&
        navigationEntries[0] &&
        navigationEntries[0].type === 'back_forward'
      ) {
        return true;
      }
    }

    return false;
  }

  function resyncOnPageShow(source) {
    if (!isAtozEnabled()) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        source: source
      });
    }

    if (state.pageRestoreSyncInFlight) {
      return Promise.resolve({
        ok: true,
        queued: true,
        source: source
      });
    }

    state.pageRestoreSyncInFlight = true;
    clearAllLoadingStates();
    debugLog('page restore cart resync start', source);

    return getCart().then(function (cartResult) {
      if (!cartResult.ok) {
        showError(cartResult.message);
        clearAllLoadingStates();
        return cartResult;
      }

      applyCartState(cartResult.cart);
      clearAllLoadingStates(cartResult.cart);
      debugLog('page restore cart resync complete', source, cartResult.cart);

      return {
        ok: true,
        source: source,
        cart: cartResult.cart
      };
    }).catch(function (error) {
      var result = structuredError('page_restore_cart_error', messages.generic, error && error.message ? error.message : null);

      clearAllLoadingStates();
      showError(result.message);

      return result;
    }).finally(function () {
      state.pageRestoreSyncInFlight = false;
    });
  }

  function schedulePageRestoreSync(source) {
    if (!isAtozEnabled()) {
      return;
    }

    if (state.pageRestoreSyncTimer) {
      window.clearTimeout(state.pageRestoreSyncTimer);
    }

    state.pageRestoreSyncTimer = window.setTimeout(function () {
      state.pageRestoreSyncTimer = null;
      resyncOnPageShow(source);
    }, 0);
  }

  function prepareAcquisitionCheckout() {
    var config = getAcquisitionConfig();
    if (!config || isAcquisitionRuntimePaused(config) || !isAcquisitionSessionArmed(config) || !isAcquisitionOfferActivated(config))
      return Promise.resolve({ ok: true, skipped: true });
    if (state.acquisitionOfferSyncTimer) {
      window.clearTimeout(state.acquisitionOfferSyncTimer);
      state.acquisitionOfferSyncTimer = null;
    }
    var timer, stopped = false;
    var work = async function () {
      for (var attempt = 0; attempt < 2 && !stopped; attempt++) {
        var result = await runAcquisitionOfferSync('checkout');
        if (stopped) return { ok: false, code: 'ACQUISITION_CHECKOUT_TIMEOUT' };
        if (!result.ok) continue;
        var fresh = await getCart();
        if (stopped) return { ok: false, code: 'ACQUISITION_CHECKOUT_TIMEOUT' };
        if (!fresh.ok) continue;
        var cart = fresh.cart;
        if (!getAcquisitionCartState(cart, config).hasEligiblePerfume) return { ok: true, cart: cart };
        var benefits = getAcquisitionBenefitStatus(cart, config);
        if (benefits.sampleConfirmed && (benefits.higherPriority || benefits.merchandiseConfirmed && benefits.shippingSubmitted))
          return { ok: true, cart: cart };
      }
      return { ok: false, code: 'ACQUISITION_NOT_CONFIRMED' };
    };
    return Promise.race([work(), new Promise(function (resolve) {
      timer = window.setTimeout(function () { stopped = true; resolve({ ok: false, code: 'ACQUISITION_CHECKOUT_TIMEOUT' }); }, 12000);
    })]).finally(function () { window.clearTimeout(timer); });
  }

  function handleCheckoutSubmit(event) {
    var form = event.target;
    var drawer = getDrawer();

    if (!isAtozEnabled() || !form || !drawer || !drawer.contains(form)) {
      return;
    }

    if (!form.querySelector(selectors.checkoutButton)) {
      return;
    }

    handleCheckoutClick({ target: form.querySelector(selectors.checkoutButton),
      preventDefault: function () { event.preventDefault(); },
      stopImmediatePropagation: function () { if (event.stopImmediatePropagation) event.stopImmediatePropagation(); },
      stopPropagation: function () { if (event.stopPropagation) event.stopPropagation(); } });
  }

  function handleCheckoutClick(event) {
    var button = event.target && event.target.closest ? event.target.closest(selectors.checkoutButton) : null;
    var drawer = getDrawer();
    var rotationTarget;
    var checkoutUrl;

    if (!isAtozEnabled() || !button || !drawer || !drawer.contains(button)) {
      return;
    }

    event.preventDefault();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    if (button.disabled || button.getAttribute('aria-disabled') === 'true' || state.cartSyncing || state.loading || state.acquisitionCheckoutInFlight) return;
    state.acquisitionCheckoutInFlight = true;
    button.classList.add('btn--loading');
    button.setAttribute('aria-busy', 'true');
    prepareAcquisitionCheckout().then(function (result) {
      if (!result.ok) {
        showError('Could not confirm your offer. Check your bag and try checkout again.');
        return;
      }
      rotationTarget = getRotationCheckoutTarget();
      if (routeRotationCheckout(button, rotationTarget, event)) return;
      state.checkoutSubmitted = true;
      checkoutUrl = buildRoute('checkout');
      window.location.href = checkoutUrl;
    }).catch(function () {
      showError('Could not confirm your offer. Check your bag and try checkout again.');
    }).finally(function () {
      state.acquisitionCheckoutInFlight = false;
      if (!state.checkoutSubmitted) {
        button.classList.remove('btn--loading');
        button.removeAttribute('aria-busy');
      }
    });
  }

  function handlePageShow(event) {
    if (!isAtozEnabled()) {
      return;
    }

    if (isBackForwardRestore(event) || state.checkoutSubmitted || hasStuckCheckoutLoading()) {
      schedulePageRestoreSync('pageshow');
    }
  }

  function handleVisibilityChange() {
    if (!isAtozEnabled() || document.visibilityState !== 'visible') {
      return;
    }

    if (state.checkoutSubmitted || hasStuckCheckoutLoading()) {
      schedulePageRestoreSync('visibilitychange');
    }
  }

  function debugSync() {
    debugLog('debugSync start');

    return getCart().then(function (cartResult) {
      if (!cartResult.ok) {
        showError(cartResult.message);
        return Promise.reject(cartResult);
      }

      applyCartState(cartResult.cart);
      openDrawer({ skipBuild: true });
      debugLog('debugSync complete', cartResult.cart);

      return cartResult.cart;
    });
  }

  function syncUpsellsFromCart(source) {
    if (!isAtozEnabled() || !getUpsellSection()) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        source: source
      });
    }

    return getCart().then(function (cartResult) {
      if (!cartResult.ok) {
        return cartResult;
      }

      return Object.assign({}, renderUpsells(cartResult.cart), {
        source: source,
        cart: cartResult.cart
      });
    }).finally(function () {
      setCartSyncing(false);
    });
  }

  function syncAcquisitionOfferFromCart(source) {
    var config = getAcquisitionConfig();

    if (!isAtozEnabled() || !config) {
      return Promise.resolve({
        ok: true,
        skipped: true,
        source: source
      });
    }

    return getCart().then(function (cartResult) {
      var cartState;

      if (!cartResult.ok) {
        return cartResult;
      }

      if (isAcquisitionSessionArmed(config)) {
        return activateAndScheduleAcquisitionOffer(cartResult.cart, source);
      }

      cartState = getAcquisitionCartState(cartResult.cart, config);

      if (cartState.giftItems.length || hasAcquisitionOfferAttributes(cartResult.cart)) {
        return scheduleAcquisitionOfferSync(cartResult.cart, source);
      }

      renderAcquisitionOffer(cartResult.cart);

      return {
        ok: true,
        skipped: true,
        source: source
      };
    });
  }

  function reconcileDiscountPriorityFromCart(candidate, cart, source) {
    var normalizedCandidate = normalizePreferredDiscountCandidate(candidate);

    if (normalizedCandidate) {
      state.preferredDiscount = normalizedCandidate;
    }

    if (cart && typeof cart === 'object') {
      return Promise.resolve(scheduleAcquisitionOfferSync(cart, source || 'discount_priority'));
    }

    return getCart().then(function (cartResult) {
      if (!cartResult.ok) {
        return cartResult;
      }

      return scheduleAcquisitionOfferSync(cartResult.cart, source || 'discount_priority');
    });
  }

  function handleRotationContextEvent() {
    if (!isAtozEnabled()) {
      return;
    }

    if (!isRotationPageContext()) {
      clearRotationContextFlag();
      return;
    }

    setRotationContextFlag();

    getCart().then(function (cartResult) {
      if (cartResult.ok) {
        renderRewardBar(cartResult.cart);
      }
    });
  }

  function bindEvents() {
    if (state.eventsBound) {
      return;
    }

    state.eventsBound = true;
    document.addEventListener('click', handleUpsellAddClick, true);
    document.addEventListener('click', handleUpsellControlClick, true);
    document.addEventListener('click', handleRemoveClick, true);
    document.addEventListener('click', handleQuantityClick, true);
    document.addEventListener('change', handleQuantityChange, true);
    document.addEventListener('pointerdown', handleUpsellInteraction, true);
    document.addEventListener('touchstart', handleUpsellInteraction, true);
    document.addEventListener('wheel', handleUpsellInteraction, true);
    document.addEventListener('scroll', handleUpsellScroll, true);
    document.addEventListener('submit', handleProductFormSubmit, true);
    document.addEventListener('click', handleCheckoutClick, true);
    document.addEventListener('submit', handleCheckoutSubmit, true);
    document.addEventListener('ajaxProduct:added', handleAjaxProductAdded, true);
    document.addEventListener('ajaxProduct:error', handleAjaxProductError, true);
    document.addEventListener('tm-rotation:context', handleRotationContextEvent);
    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('pageshow', handlePageShow);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    debugLog('events bound');
  }

  function init() {
    armAcquisitionOfferFromUrl();
    isRibbedTeeLaunchContextActive();
    if (isRotationPageContext()) {
      setRotationContextFlag();
    } else {
      clearRotationContextFlag();
    }
    bindEvents();
    bindAcquisitionOfferLinkPreservation();
    bindCartAddFetchObserver();
    bindDrawerStateObserver();
    syncScrollableBodyPlacement();
    syncUpsellsFromCart('init');
    syncAcquisitionOfferFromCart('init');
    try { showAtozAddRecovery(); } catch (_) {}
    try { showPaidDecreaseRecovery(); } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.ATOZCart = {
    __atozCartController: true,
    addItem: addItem,
    reviewPendingAdd: reviewPendingAtozAdd,
    resolveReviewedAdd: resolveReviewedAtozAdd,
    reviewPendingPaidDecrease: reviewPendingPaidDecrease,
    resolveReviewedPaidDecrease: resolveReviewedPaidDecrease,
    changeItem: changeItem,
    changeItemRequest: changeItemRequest,
    queueQuantityChange: queueQuantityChange,
    removeItem: removeItem,
    getCart: getCart,
    refreshSections: refreshSections,
    refreshCartHtml: refreshCartHtml,
    refreshCartCount: refreshCartCount,
    refreshAfterCartChange: refreshAfterCartChange,
    applyCartState: applyCartState,
    reconcileDiscountPriority: reconcileDiscountPriorityFromCart,
    renderCartRows: renderCartRows,
    parseRewardConfig: parseRewardConfig,
    getEligibleCartItems: getEligibleCartItems,
    getEligibleQuantity: getEligibleQuantity,
    getEligibleSubtotal: getEligibleSubtotal,
    getActualDiscountTitles: getActualDiscountTitles,
    getFreebieState: getFreebieState,
    calculateTierStates: calculateTierStates,
    calculatePerkStates: calculatePerkStates,
    calculateRewardState: calculateRewardState,
    renderRewardBar: renderRewardBar,
    renderUpsells: renderUpsells,
    updateCartCount: updateCartCount,
    updateCartSubtotal: updateCartSubtotal,
    setRowLoading: setRowLoading,
    removeRowOptimistically: removeRowOptimistically,
    scheduleAddSync: scheduleAddSync,
    clearCheckoutLoading: clearCheckoutLoading,
    clearAllLoadingStates: clearAllLoadingStates,
    resyncOnPageShow: resyncOnPageShow,
    debugSync: debugSync,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    setLoading: setLoading,
    clearLoading: clearLoading,
    showError: showError,
    getState: function () {
      return Object.assign({}, state);
    }
  };
})();
